(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["book-appointment"] && !Shopify.designMode) return;
  try {
    
(function(){
  var sections = document.querySelectorAll('.rc-book-appt[data-section-id]');
  sections.forEach(function(root){ initBookAppt(root); });

  function initBookAppt(root){
    var waNumber = root.getAttribute('data-wa-number');
    var msgTemplate = root.getAttribute('data-msg-template');

    var state = { label: null, evening: false, when: null, time: null };

    var step1 = root.querySelector('[data-panel="step1"]');
    var step2 = root.querySelector('[data-panel="step2"]');
    var step3 = root.querySelector('[data-panel="step3"]');
    var stepFinal = root.querySelector('[data-panel="final"]');
    var panels = [step1, step2, step3, stepFinal];
    var progressSteps = root.querySelectorAll('.rc-book-appt__step');
    var eveningCard = root.querySelector('[data-evening-card]');
    var eveningNote = root.querySelector('[data-evening-note]');
    var summary = root.querySelector('[data-summary]');
    var waBtn = root.querySelector('[data-wa-btn]');

    function showPanel(target){
      panels.forEach(function(p){
        p.setAttribute('data-active', p === target ? 'true' : 'false');
      });
    }
    function setProgress(n){
      progressSteps.forEach(function(s){
        var sn = parseInt(s.getAttribute('data-step'), 10);
        s.classList.remove('is-on', 'is-done');
        if (sn < n) s.classList.add('is-done');
        if (sn === n) s.classList.add('is-on');
      });
    }

    step1.querySelectorAll('.rc-book-appt__opt-card').forEach(function(card){
      card.addEventListener('click', function(){
        step1.querySelectorAll('.rc-book-appt__opt-card').forEach(function(c){ c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        state.label = card.getAttribute('data-label');
        state.evening = card.getAttribute('data-evening') === 'true';

        if (state.evening){
          eveningCard.classList.remove('is-disabled');
          eveningNote.classList.remove('is-shown');
        } else {
          eveningCard.classList.add('is-disabled');
          eveningCard.classList.remove('is-selected');
          eveningNote.classList.add('is-shown');
          if (state.time === 'evening') state.time = null;
        }

        setTimeout(function(){ showPanel(step2); setProgress(2); }, 220);
      });
    });

    step2.querySelectorAll('.rc-book-appt__opt-card').forEach(function(card){
      card.addEventListener('click', function(){
        step2.querySelectorAll('.rc-book-appt__opt-card').forEach(function(c){ c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        state.when = card.getAttribute('data-value');
        setTimeout(function(){ showPanel(step3); setProgress(3); }, 220);
      });
    });

    step3.querySelectorAll('.rc-book-appt__opt-card').forEach(function(card){
      card.addEventListener('click', function(){
        if (card.classList.contains('is-disabled')) return;
        step3.querySelectorAll('.rc-book-appt__opt-card').forEach(function(c){ c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        state.time = card.getAttribute('data-value');
        setTimeout(finish, 220);
      });
    });

    function finish(){
      var msg = msgTemplate
        .replace('{{session}}', state.label)
        .replace('{{day}}', state.when)
        .replace('{{time}}', state.time);
      summary.innerHTML = "You're booking <b>" + state.label + "</b>, on a <b>" +
        state.when + "</b>, in the <b>" + state.time + "</b>.";
      waBtn.href = "https://wa.me/" + waNumber + "?text=" + encodeURIComponent(msg);
      showPanel(stepFinal);
      setProgress(4);
    }

    root.querySelectorAll('[data-back]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var target = btn.getAttribute('data-back');
        var map = { step1: [step1, 1], step2: [step2, 2], step3: [step3, 3] };
        showPanel(map[target][0]);
        setProgress(map[target][1]);
      });
    });

    var restartBtn = root.querySelector('[data-restart]');
    if (restartBtn){
      restartBtn.addEventListener('click', function(){
        state = { label: null, evening: false, when: null, time: null };
        root.querySelectorAll('.rc-book-appt__opt-card').forEach(function(el){
          el.classList.remove('is-selected', 'is-disabled');
        });
        eveningNote.classList.remove('is-shown');
        showPanel(step1);
        setProgress(1);
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculator-cpf-accrued"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* Shopify bundles every section's {% javascript %} into one shared
       <script> tag site-wide — if this section isn't on the current page,
       every el(id) below would be null and throw, killing every OTHER
       section's JS later in that same bundle. Bail out immediately. */
    if (!document.getElementById('rc-cpf-years-input')) return;

    var ENDPOINT = 'https://api.roncasa.co/calc/cpf-accrued-interest';
    var DEBOUNCE_MS = 300;
    var debounceTimer = null;
    var sellTouched = false;
    var latestData = null;

    var fmt = function (n) {
      return Math.round(n || 0).toLocaleString('en-SG', { maximumFractionDigits: 0 });
    };
    var fmtMoney = function (n) {
      n = n || 0;
      return (n < 0 ? '−$' : '$') + fmt(Math.abs(n));
    };
    var fmtCompact = function (n) {
      n = n || 0;
      var a = Math.abs(n);
      if (a >= 1e6) return '$' + (n / 1e6).toFixed(2).replace(/\.00$/, '') + 'M';
      if (a >= 1e3) return '$' + Math.round(n / 1e3) + 'k';
      return '$' + fmt(n);
    };

    function el(id) { return document.getElementById(id); }

    function num(inputEl) {
      var raw = (inputEl && inputEl.value || '').replace(/[^\d.]/g, '');
      return parseFloat(raw) || 0;
    }

    function getInputs() {
      return {
        years: Math.max(1, Math.round(num(el('rc-cpf-years-input')))),
        upfront: num(el('rc-cpf-upfront-input')),
        monthly: num(el('rc-cpf-monthly-input')),
        rate: num(el('rc-cpf-rate-input')) || 2.5,
        price: num(el('rc-cpf-price-input')),
        loan: num(el('rc-cpf-loan-input'))
      };
    }

    function buildUrl(inp, sale) {
      var params = new URLSearchParams();
      params.set('years', inp.years);
      params.set('upfront', inp.upfront);
      params.set('monthly', inp.monthly);
      params.set('rate', inp.rate);
      params.set('price', inp.price);
      params.set('loan', inp.loan);
      if (sale !== undefined && sale !== null) params.set('sale', sale);
      return ENDPOINT + '?' + params.toString();
    }

    function setLoading(isLoading) {
      var badge = el('rc-cpf-live-badge');
      if (!badge) return;
      badge.classList.toggle('is-loading', isLoading);
      badge.textContent = isLoading ? 'Updating…' : 'Live · updates as you drag';
    }

    function render(data, inp, sale) {
      latestData = data;

      var big;
      if ((big = el('rc-cpf-refund'))) big.textContent = fmt(data.refund);
      if ((big = el('rc-cpf-principal'))) big.textContent = fmtMoney(data.principal);
      if ((big = el('rc-cpf-interest'))) big.textContent = fmtMoney(data.interest);
      if ((big = el('rc-cpf-vs-year-one'))) big.textContent = fmtMoney(data.vs_year_one);

      // Growth chart
      drawChart(data.series || []);
      var cap = el('rc-cpf-chart-cap');
      if (cap) cap.textContent = 'Refund at ' + inp.years + 'y: ' + fmtCompact(data.refund);

      // Sale test
      var st = data.sale_test || {};
      var owed = st.owed || 0;
      var saleAmt = st.sale != null ? st.sale : sale;
      var max = Math.max(saleAmt, owed, 1);
      var pct = function (v) { return (v / max * 100) + '%'; };

      var e;
      if ((e = el('rc-cpf-seg-sale'))) e.style.width = pct(saleAmt);
      if ((e = el('rc-cpf-seg-loan'))) e.style.width = pct(inp.loan);
      if ((e = el('rc-cpf-seg-princ'))) e.style.width = pct(data.principal);
      if ((e = el('rc-cpf-seg-int'))) e.style.width = pct(data.interest);
      if ((e = el('rc-cpf-tv-sale'))) e.textContent = fmtMoney(saleAmt);
      if ((e = el('rc-cpf-tv-owed'))) e.textContent = fmtMoney(owed);
      if ((e = el('rc-cpf-sell-val'))) e.textContent = fmt(saleAmt);

      var verdict = el('rc-cpf-verdict');
      if (verdict) {
        verdict.classList.toggle('is-negative', !!st.negative);
        verdict.textContent = st.negative ? 'Negative sale' : 'Positive sale';
      }

      var note = el('rc-cpf-sale-note');
      if (note) {
        if (st.negative) {
          note.innerHTML = 'The sale can’t make the bank <em>and</em> your CPF whole. The accrued interest spills past the selling price. You’d write a cheque for <em>' + fmtMoney(st.shortfall) + '</em> in cash just to complete it.';
        } else {
          var net = saleAmt - owed;
          note.innerHTML = 'The sale clears the loan and refunds CPF in full, leaving <em>' + fmtMoney(net) + '</em> in cash. The ' + fmtCompact(data.refund) + ' CPF refund returns to your CPF, locked, not liquid.';
        }
      }

      var rel = el('rc-cpf-sell-rel');
      if (rel) rel.textContent = sellTouched ? '(custom price)' : '= purchase price';

      // Compare grid
      renderCompare(data.compare || [], inp);
    }

    function renderCompare(compare, inp) {
      var grid = el('rc-cpf-compare-grid');
      if (!grid) return;
      var names = { 5: 'Sold early: the quick flip', 10: 'A decade in', 20: 'The long hold', 30: 'A full generation' };
      grid.innerHTML = '';
      compare.forEach(function (r) {
        var featured = Math.abs(r.years - inp.years) <= 2;
        var col = document.createElement('div');
        col.className = 'rc-cpf-compare__col' + (featured ? ' rc-cpf-compare__col--featured' : '');
        col.innerHTML =
          '<div class="rc-cpf-compare__scen">' + r.years + '-YEAR HOLD</div>' +
          '<h4 class="rc-cpf-compare__h4">' + (names[r.years] || r.years + ' years') + '</h4>' +
          '<div class="rc-cpf-compare__stats">' +
            '<div class="rc-cpf-compare__stat-row">CPF refund<b>' + fmtCompact(r.refund) + '</b></div>' +
            '<div class="rc-cpf-compare__stat-row">Accrued interest<b>' + fmtCompact(r.interest) + '</b></div>' +
            '<div class="rc-cpf-compare__stat-row">Interest share<b>' + (r.interest_share_pct || 0) + '%</b></div>' +
          '</div>' +
          '<div class="rc-cpf-compare__pick">' + (featured ? '↑ Closest to you' : 'Interest ' + fmtCompact(r.interest)) + '</div>';
        grid.appendChild(col);
      });
      var noteEl = el('rc-cpf-compare-note');
      if (noteEl) noteEl.textContent = 'At ' + (inp.rate || 2.5) + '% · your current CPF inputs';
    }

    function paintChart(series) {
      var svg = el('rc-cpf-chart');
      if (!svg || !series.length) return;
      var W = 640, H = 200, padL = 4, padR = 4, padT = 14, padB = 22;
      var maxYr = series[series.length - 1].year || 1;
      var maxRefund = Math.max.apply(null, series.map(function (p) { return p.refund; }).concat([1]));
      var x = function (y) { return padL + (y / maxYr) * (W - padL - padR); };
      var yScale = function (v) { return (H - padB) - (v / maxRefund) * (H - padT - padB); };

      var topLine = series.map(function (p) { return x(p.year) + ',' + yScale(p.refund); });
      var bandTop = series.map(function (p) { return x(p.year) + ',' + yScale(p.refund); }).join(' L ');
      var bandBot = series.slice().reverse().map(function (p) { return x(p.year) + ',' + yScale(p.principal); }).join(' L ');
      var interestArea = 'M ' + bandTop + ' L ' + bandBot + ' Z';

      var baseY = H - padB;
      var princArea = 'M ' + x(0) + ',' + baseY + ' L ' +
        series.map(function (p) { return x(p.year) + ',' + yScale(p.principal); }).join(' L ') +
        ' L ' + x(maxYr) + ',' + baseY + ' Z';

      var ticks = '';
      var step = maxYr <= 10 ? 2 : maxYr <= 20 ? 5 : 10;
      for (var y = 0; y <= maxYr; y += step) {
        ticks += '<text x="' + x(y) + '" y="' + (H - 6) + '" text-anchor="middle">' + y + 'y</text>';
      }

      var last = series[series.length - 1];
      var cx = x(maxYr);

      svg.innerHTML =
        '<path d="' + princArea + '" fill="#1A1A1A"></path>' +
        '<path d="' + interestArea + '" fill="#8A8A8A"></path>' +
        '<polyline points="' + topLine.join(' ') + '" fill="none" stroke="#1A1A1A" stroke-width="1.5"></polyline>' +
        '<line x1="' + cx + '" y1="' + padT + '" x2="' + cx + '" y2="' + (H - padB) + '" stroke="#1A1A1A" stroke-width="1" stroke-dasharray="3 3" opacity="0.5"></line>' +
        '<circle cx="' + cx + '" cy="' + yScale(last.refund) + '" r="3.5" fill="#1A1A1A"></circle>' +
        ticks;
    }

    // ── Chart drag-smoothing ──
    // The Worker returns a fresh series every ~300ms (debounce) while dragging a slider.
    // Without this, the chart snapped instantly between each response -- looked "stepped"
    // rather than live while dragging. This eases the visible chart from its last painted
    // frame toward each new response over a short window, so it reads as continuously
    // live during a drag even though real data only arrives every ~300ms+fetch. No formula
    // logic lives here -- purely a visual interpolation between two already-computed series.
    var CHART_ANIM_MS = 260;
    var chartRAF = null;
    var chartDisplayed = null; // last-painted (possibly mid-tween) series snapshot

    function lerpSeries(from, to, t) {
      return to.map(function (p, i) {
        var f = from[i];
        if (!f) return p;
        return {
          year: p.year,
          refund: f.refund + (p.refund - f.refund) * t,
          principal: f.principal + (p.principal - f.principal) * t
        };
      });
    }

    function drawChart(series) {
      if (!series || !series.length) return;
      if (chartRAF) { cancelAnimationFrame(chartRAF); chartRAF = null; }

      var canTween = chartDisplayed && chartDisplayed.length === series.length;
      if (!canTween) {
        paintChart(series);
        chartDisplayed = series;
        return;
      }

      var start = chartDisplayed;
      var startTime = null;

      function step(ts) {
        if (!startTime) startTime = ts;
        var t = Math.min(1, (ts - startTime) / CHART_ANIM_MS);
        var eased = 1 - Math.pow(1 - t, 3); // ease-out cubic
        var frame = lerpSeries(start, series, eased);
        paintChart(frame);
        chartDisplayed = frame;
        if (t < 1) {
          chartRAF = requestAnimationFrame(step);
        } else {
          chartDisplayed = series;
          chartRAF = null;
        }
      }
      chartRAF = requestAnimationFrame(step);
    }

    function fetchAndRender() {
      setLoading(true);
      var inp = getInputs();
      var priceEl = el('rc-cpf-price-input');
      var sellRange = el('rc-cpf-sell-range');

      if (!sellTouched && sellRange) sellRange.value = inp.price;
      var sale = sellTouched && sellRange ? num({ value: sellRange.value }) : inp.price;

      var url = buildUrl(inp, sale);
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          setLoading(false);
          if (data && !data.error) render(data, inp, sale);
        })
        .catch(function () {
          setLoading(false);
        });
    }

    function scheduleFetch() {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(fetchAndRender, DEBOUNCE_MS);
    }

    function syncPair(inputId, rangeId, isMoney) {
      var inp = el(inputId);
      var rng = el(rangeId);
      if (!inp || !rng) return;

      inp.addEventListener('input', function () {
        var v = num(this);
        rng.value = v;
        scheduleFetch();
      });
      inp.addEventListener('blur', function () {
        if (isMoney) this.value = fmt(num(this));
      });
      rng.addEventListener('input', function () {
        var v = parseFloat(this.value);
        inp.value = isMoney ? fmt(v) : v;
        scheduleFetch();
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      syncPair('rc-cpf-years-input', 'rc-cpf-years-range', false);
      syncPair('rc-cpf-upfront-input', 'rc-cpf-upfront-range', true);
      syncPair('rc-cpf-monthly-input', 'rc-cpf-monthly-range', true);
      syncPair('rc-cpf-rate-input', 'rc-cpf-rate-range', false);
      syncPair('rc-cpf-price-input', 'rc-cpf-price-range', true);
      syncPair('rc-cpf-loan-input', 'rc-cpf-loan-range', true);

      // Year presets
      document.querySelectorAll('.rc-calc-cpf__preset[data-years]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          document.querySelectorAll('.rc-calc-cpf__preset[data-years]').forEach(function (b) {
            b.classList.remove('rc-calc-cpf__preset--active');
          });
          this.classList.add('rc-calc-cpf__preset--active');
          var val = this.getAttribute('data-years');
          var yInp = el('rc-cpf-years-input');
          var yRng = el('rc-cpf-years-range');
          if (yInp) yInp.value = val;
          if (yRng) yRng.value = val;
          scheduleFetch();
        });
      });

      // Selling-price slider (negative-sale sim)
      var sellRange = el('rc-cpf-sell-range');
      if (sellRange) {
        sellRange.addEventListener('input', function () {
          sellTouched = true;
          scheduleFetch();
        });
      }
      var sellReset = el('rc-cpf-sell-reset');
      if (sellReset) {
        sellReset.addEventListener('click', function (e) {
          e.preventDefault();
          sellTouched = false;
          var priceEl = el('rc-cpf-price-input');
          if (sellRange && priceEl) sellRange.value = num(priceEl);
          scheduleFetch();
        });
      }

      // Share / copy link
      var shareBtn = el('rc-cpf-share-btn');
      if (shareBtn) {
        shareBtn.addEventListener('click', function () {
          var original = this.textContent;
          navigator.clipboard.writeText(window.location.href).then(function () {
            shareBtn.textContent = 'Copied!';
            setTimeout(function () { shareBtn.textContent = original; }, 1600);
          }).catch(function () {
            shareBtn.textContent = 'Copy URL manually';
            setTimeout(function () { shareBtn.textContent = original; }, 2000);
          });
        });
      }

      fetchAndRender();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculator-grant-estimator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    if (!document.getElementById('rc-ge-income')) return;

    var POLICY_ENDPOINT = 'https://api.roncasa.co/calc/policy';

    /* Loaded once from the live Policy Registry — never hardcoded here. If the
       fetch fails (offline, blocked), these last-verified fallback numbers are
       used silently; no user-facing "Sample" state, same as every other
       calculator on this site, which always just says "Live". */
    var POLICY = {
      income_ceiling: { family: 16000 },
      grants: {
        ehg_family:     { table: [[1500,120000],[2000,110000],[2500,105000],[3000,95000],[3500,90000],[4000,80000],[4500,70000],[5000,65000],[5500,55000],[6000,50000],[6500,40000],[7000,30000],[7500,25000],[8000,20000],[8500,10000],[9000,5000]] },
        ehg_singles:    { table: [[750,60000],[1000,55000],[1250,52500],[1500,47500],[1750,45000],[2000,40000],[2250,35000],[2500,32500],[2750,27500],[3000,25000],[3250,20000],[3500,15000],[3750,12500],[4000,10000],[4250,5000],[4500,2500]] },
        family_resale:  { two_to_four_room: 80000, five_room_or_bigger: 50000 },
        singles_resale: { two_to_four_room: 40000, five_room: 25000 },
        phg: { family: { living_with: 30000, within_4km: 20000 }, singles: { living_with: 15000, near: 10000 } }
      }
    };

    var S = { buyer: 'family', flat: 'small', prox: 'with' };

    function el(id) { return document.getElementById(id); }
    function fmt(n) { return Math.round(n || 0).toLocaleString('en-SG'); }
    function digitsOnly(s) { return (s || '').replace(/[^\d]/g, ''); }

    function lookup(table, income) {
      for (var i = 0; i < table.length; i++) { if (income <= table[i][0]) return table[i][1]; }
      return 0;
    }

    function compute(income) {
      var g = POLICY.grants;
      var isFamily = S.buyer === 'family';
      var smallFlat = S.flat === 'small';

      var ehg = isFamily ? lookup(g.ehg_family.table, income) : lookup(g.ehg_singles.table, income / 2);
      var ehgNote = isFamily ? 'by household income' : 'by half of income';

      var fam, famName;
      if (isFamily || S.buyer === 'ftst') {
        fam = smallFlat ? g.family_resale.two_to_four_room : g.family_resale.five_room_or_bigger;
        famName = 'Family Grant';
      } else if (S.buyer === 'twosingles') {
        fam = smallFlat ? g.family_resale.two_to_four_room : g.family_resale.five_room_or_bigger;
        famName = 'Family Grant (two singles pooled)';
      } else {
        fam = smallFlat ? g.singles_resale.two_to_four_room : g.singles_resale.five_room;
        famName = 'Singles Grant';
      }

      var singleProx = S.buyer === 'single';
      var phg = 0, phgNote = 'not claimed';
      if (S.prox === 'with') { phg = singleProx ? g.phg.singles.living_with : g.phg.family.living_with; phgNote = 'living with'; }
      else if (S.prox === 'near') { phg = singleProx ? g.phg.singles.near : g.phg.family.within_4km; phgNote = 'within 4 km'; }

      return [
        { name: 'Enhanced CPF Housing Grant (EHG)', note: ehgNote, val: ehg },
        { name: famName, note: smallFlat ? '2- to 4-room' : '5-room or bigger', val: fam },
        { name: 'Proximity (PHG)', note: phgNote, val: phg }
      ];
    }

    function render() {
      var income = +digitsOnly(el('rc-ge-income').value) || 0;
      var rows = compute(income);
      var total = rows.reduce(function (s, r) { return s + r.val; }, 0);

      el('rc-ge-total').textContent = fmt(total);
      el('rc-ge-breakdown-rows').innerHTML = rows.map(function (r) {
        return '<div class="rc-calc-ge__r' + (r.val ? '' : ' rc-calc-ge__r--zero') + '">' +
          '<div class="rc-calc-ge__r-k">' + r.name + '<small>' + r.note + '</small></div>' +
          '<div class="rc-calc-ge__r-v">' + (r.val ? ('S$' + fmt(r.val)) : '—') + '</div></div>';
      }).join('');

      var ceil = POLICY.income_ceiling.family;
      el('rc-ge-ceiling-hint').textContent = income > ceil
        ? ('Above the S$' + fmt(ceil) + ' ceiling for grants + HDB loan')
        : ('Family grant ceiling S$' + fmt(ceil) + '/mo');
    }

    function setSeg(groupIds, activeId, stateKey, val) {
      groupIds.forEach(function (id) { el(id).classList.remove('rc-calc-ge__seg-btn--active'); });
      el(activeId).classList.add('rc-calc-ge__seg-btn--active');
      S[stateKey] = val;
      render();
    }

    el('rc-ge-income').addEventListener('input', function () {
      var n = +digitsOnly(el('rc-ge-income').value) || 0;
      el('rc-ge-income-range').value = Math.min(16000, n);
      render();
    });
    el('rc-ge-income').addEventListener('blur', function () {
      el('rc-ge-income').value = fmt(+digitsOnly(el('rc-ge-income').value) || 0);
    });
    el('rc-ge-income-range').addEventListener('input', function () {
      el('rc-ge-income').value = fmt(+el('rc-ge-income-range').value);
      render();
    });

    var buyerIds = ['rc-ge-buyer-family', 'rc-ge-buyer-ftst', 'rc-ge-buyer-single', 'rc-ge-buyer-twosingles'];
    buyerIds.forEach(function (id) {
      el(id).addEventListener('click', function () { setSeg(buyerIds, id, 'buyer', el(id).dataset.val); });
    });
    var flatIds = ['rc-ge-flat-small', 'rc-ge-flat-big'];
    flatIds.forEach(function (id) {
      el(id).addEventListener('click', function () { setSeg(flatIds, id, 'flat', el(id).dataset.val); });
    });
    var proxIds = ['rc-ge-prox-with', 'rc-ge-prox-near', 'rc-ge-prox-none'];
    proxIds.forEach(function (id) {
      el(id).addEventListener('click', function () { setSeg(proxIds, id, 'prox', el(id).dataset.val); });
    });

    fetch(POLICY_ENDPOINT)
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data && data.grants) { POLICY = data; render(); } })
      .catch(function () {});

    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculator-hdb-buyer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    if (!document.getElementById('rc-hb-price')) return;

    var ENDPOINT = 'https://api.roncasa.co/calc/hdb-buyer';
    var DEBOUNCE_MS = 300;
    var timer = null;
    var reqSeq = 0;

    var PROFILE_PAX = { sc: 1, scsc: 2, scpr: 2, scfr: 2, prpr: 2 };
    var PROFILE_FLAG = {
      sc: 'Sole Singapore Citizen owner. No ABSD. Stamp duty here is BSD only.',
      scsc: 'Two Singapore Citizens. No ABSD.',
      scpr: 'ABSD is <b>fully remitted</b>, under the IRAS HDB / new-EC remission, no ABSD is payable when any joint buyer is a Singapore Citizen. Remission is automatic on HDB’s approval. Not applicable to resale EC.',
      scfr: 'ABSD is <b>fully remitted</b>. The same HDB remission applies because one buyer is a Singapore Citizen. Remission is automatic on HDB’s approval. Not applicable to resale EC.',
      prpr: '<b>5% ABSD applies</b>, no citizen in the application, so no remission. Also flag the eligibility rule: both SPRs must have held PR status for <b>at least 3 years</b> before they can buy an HDB resale flat. An SPR household already owning a flat or private property cannot buy another HDB flat.'
    };

    var S = { profile: 'scsc', src: 'hdb', ext: false, useCpf: true, offset: true };

    function el(id) { return document.getElementById(id); }
    function fmt(n) { return Math.round(Math.abs(n || 0)).toLocaleString('en-SG'); }
    function fmtM(n) { return '$' + fmt(n); }
    function num(id) {
      var e = el(id);
      if (!e) return 0;
      return parseFloat((e.value || '').replace(/[^\d.]/g, '')) || 0;
    }
    function setTxt(id, v) { var e = el(id); if (e) e.textContent = v; }

    function pax() { return PROFILE_PAX[S.profile] || 2; }

    function buildUrl() {
      var p = new URLSearchParams();
      p.set('price', num('rc-hb-price'));
      p.set('profile', S.profile);
      p.set('src', S.src);
      p.set('use_cpf', S.useCpf ? 'true' : 'false');
      p.set('offset', S.offset ? 'true' : 'false');
      p.set('ext', S.ext ? 'true' : 'false');
      p.set('flat_fee', el('rc-hb-flat-type').value);
      p.set('legal', el('rc-hb-legal-type').value);
      p.set('b1_age', num('rc-hb-b1-age'));
      p.set('b1_income', num('rc-hb-b1-income'));
      p.set('b1_cpf', S.useCpf ? num('rc-hb-b1-cpf') : 0);
      if (pax() === 2) {
        p.set('b2_age', num('rc-hb-b2-age'));
        p.set('b2_income', num('rc-hb-b2-income'));
        p.set('b2_cpf', S.useCpf ? num('rc-hb-b2-cpf') : 0);
      }
      return ENDPOINT + '?' + p.toString();
    }

    function render(data) {
      setTxt('rc-hb-cash-upfront', fmt(data.rail.cash_upfront));

      setTxt('rc-hb-loan-val', fmtM(data.loan.loan));
      setTxt('rc-hb-loan-note', data.loan.tenure + 'y at ' + data.loan.rate.toFixed(2) + '% · monthly ' + fmtM(data.loan.monthly) + ' · ' + data.loan.ltv_pct.toFixed(1) + '% LTV.');

      setTxt('rc-hb-wf-option', fmtM(data.stage1.option));
      setTxt('rc-hb-wf-valuation', fmtM(data.stage1.valuation));
      setTxt('rc-hb-wf-exercise', fmtM(data.stage1.exercise));
      setTxt('rc-hb-wf-stage1', fmtM(data.stage1.total));

      setTxt('rc-hb-wf-bsd', fmtM(data.stamp_duty.bsd));
      setTxt('rc-hb-wf-absd-lab', data.stamp_duty.absd_rate_pct > 0 ? 'ABSD · ' + data.stamp_duty.absd_rate_pct + '%' : 'ABSD · remitted');
      setTxt('rc-hb-wf-absd', data.stamp_duty.absd > 0 ? fmtM(data.stamp_duty.absd) : '$0');
      setTxt('rc-hb-wf-sd', fmtM(data.stamp_duty.total));

      setTxt('rc-hb-wf-tenure-rate', data.loan.tenure + 'y · ' + data.loan.rate.toFixed(2) + '%');
      setTxt('rc-hb-wf-mo', fmtM(data.loan.monthly));
      setTxt('rc-hb-wf-msr', data.loan.msr_used_pct.toFixed(1) + '%');

      setTxt('rc-hb-wf-flatfee', fmtM(data.inputs.flat_fee));
      var extRow = el('rc-hb-wf-row-ext');
      extRow.style.display = S.ext ? 'flex' : 'none';
      if (S.ext) setTxt('rc-hb-wf-ext', '$20');
      setTxt('rc-hb-wf-legal', fmtM(data.inputs.legal));
      setTxt('rc-hb-wf-agent', fmtM(data.stage3.agent_fee));
      setTxt('rc-hb-wf-admin', fmtM(1500));
      setTxt('rc-hb-wf-downpay', fmtM(data.stage3.downpayment));
      setTxt('rc-hb-wf-cpf-down', fmtM(data.stage3.cpf.downpayment));
      setTxt('rc-hb-wf-cash-down', fmtM(data.stage3.cash.downpayment));
      setTxt('rc-hb-wf-stage3', fmtM(data.stage3.total));

      setTxt('rc-hb-wf-oa-inflow', fmtM(data.oa_offset.monthly_inflow));
      setTxt('rc-hb-wf-cash-mo', fmtM(data.oa_offset.cash_monthly));

      setTxt('rc-hb-wf-total', fmtM(data.rail.total_outlay));
    }

    function fetchAndRender() {
      var seq = ++reqSeq;
      var badge = el('rc-hb-live-badge');
      if (badge) badge.textContent = 'Updating…';
      fetch(buildUrl())
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (seq !== reqSeq) return; // a newer request was issued while this one was in flight — drop the stale response
          render(data);
          if (badge) badge.textContent = 'Live · updates as you type';
        })
        .catch(function () {
          if (seq !== reqSeq) return;
          if (badge) badge.textContent = 'Live · updates as you type';
        });
    }

    function debounced() {
      clearTimeout(timer);
      timer = setTimeout(fetchAndRender, DEBOUNCE_MS);
    }

    function applyProfile() {
      setTxt('rc-hb-profile-flag', PROFILE_FLAG[S.profile] || '');
      el('rc-hb-buyer2').style.display = pax() === 2 ? 'block' : 'none';
      el('rc-hb-cpf2').style.display = pax() === 2 ? 'block' : 'none';
      debounced();
    }

    el('rc-hb-profile').addEventListener('change', function (e) {
      S.profile = e.target.value;
      applyProfile();
    });

    function setSrc(v) { S.src = v; el('rc-hb-src-hdb').classList.toggle('rc-calc-hb__pill--active', v === 'hdb'); el('rc-hb-src-bank').classList.toggle('rc-calc-hb__pill--active', v === 'bank'); debounced(); }
    function setExt(v) { S.ext = v; el('rc-hb-ext-no').classList.toggle('rc-calc-hb__pill--active', !v); el('rc-hb-ext-yes').classList.toggle('rc-calc-hb__pill--active', v); debounced(); }
    function setUseCpf(v) { S.useCpf = v; el('rc-hb-usecpf-yes').classList.toggle('rc-calc-hb__pill--active', v); el('rc-hb-usecpf-no').classList.toggle('rc-calc-hb__pill--active', !v); el('rc-hb-cpf-wrap').style.display = v ? 'block' : 'none'; debounced(); }
    function setOffset(v) { S.offset = v; el('rc-hb-offset-yes').classList.toggle('rc-calc-hb__pill--active', v); el('rc-hb-offset-no').classList.toggle('rc-calc-hb__pill--active', !v); debounced(); }

    el('rc-hb-src-hdb').addEventListener('click', function () { setSrc('hdb'); });
    el('rc-hb-src-bank').addEventListener('click', function () { setSrc('bank'); });
    el('rc-hb-ext-no').addEventListener('click', function () { setExt(false); });
    el('rc-hb-ext-yes').addEventListener('click', function () { setExt(true); });
    el('rc-hb-usecpf-yes').addEventListener('click', function () { setUseCpf(true); });
    el('rc-hb-usecpf-no').addEventListener('click', function () { setUseCpf(false); });
    el('rc-hb-offset-yes').addEventListener('click', function () { setOffset(true); });
    el('rc-hb-offset-no').addEventListener('click', function () { setOffset(false); });
    el('rc-hb-flat-type').addEventListener('change', debounced);
    el('rc-hb-legal-type').addEventListener('change', debounced);

    var priceInput = el('rc-hb-price'), priceRange = el('rc-hb-price-range');
    priceRange.addEventListener('input', function () { priceInput.value = fmt(+priceRange.value); debounced(); });
    priceInput.addEventListener('input', function () {
      var v = num('rc-hb-price');
      if (v >= +priceRange.min && v <= +priceRange.max) priceRange.value = v;
      debounced();
    });
    priceInput.addEventListener('blur', function () { priceInput.value = fmt(num('rc-hb-price')); });

    ['rc-hb-b1-age', 'rc-hb-b1-income', 'rc-hb-b1-cpf', 'rc-hb-b2-age', 'rc-hb-b2-income', 'rc-hb-b2-cpf'].forEach(function (id) {
      var e = el(id);
      if (e) e.addEventListener('input', debounced);
    });

    applyProfile();
    fetchAndRender();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculator-hdb-eligibility"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    if (!document.getElementById('rc-el-income')) return;

    var POLICY_ENDPOINT = 'https://api.roncasa.co/calc/policy';

    /* Loaded once from the live Policy Registry — never hardcoded here. If the
       fetch fails, these last-verified fallback numbers are used silently (no
       "Sample" state), same as every other calculator on this site. */
    var POLICY = {
      income_ceiling: { family: 16000, singles: 8000, multigen: 24000 },
      absd: { pr: { '1st': 0.05 } }
    };

    var S = { scheme: 'couple', cit: 'has_sc', own: 'no' };

    function el(id) { return document.getElementById(id); }
    function fmt(n) { return Math.round(n || 0).toLocaleString('en-SG'); }
    function digitsOnly(s) { return (s || '').replace(/[^\d]/g, ''); }

    function schemeName() {
      if (S.scheme === 'couple') return 'Public Scheme';
      if (S.scheme === 'fiance') return 'Fiancé/Fiancée Scheme';
      if (S.scheme === 'single') return 'Single Singapore Citizen Scheme';
      return 'Joint Singles Scheme';
    }

    function ceilingFor() {
      var c = POLICY.income_ceiling || {};
      if (S.scheme === 'single') return c.singles || 8000;
      return c.family || 16000;
    }

    /* Citizenship eligibility per scheme.
       Singles schemes (SSCS / Joint Singles) are Citizen-only.
       Public / Fiancé need >=1 Citizen; an all-PR household can only buy a
       resale Standard flat, and each PR must have held PR for >=3 years. */
    function citState() {
      var singlesScheme = (S.scheme === 'single' || S.scheme === 'twosingles');
      if (S.cit === 'has_sc') return 'ok';
      return singlesScheme ? 'no' : 'conditional';
    }

    function absdRow() {
      if (S.cit === 'has_sc') {
        return { v: 'S$0', note: 'Remitted — a Singapore Citizen is buying (granted on HDB approval)' };
      }
      var pr = ((POLICY.absd || {}).pr || {})['1st'];
      var pct = (pr != null ? pr : 0.05) * 100;
      return { v: (pct % 1 === 0 ? pct.toFixed(0) : pct.toFixed(1)) + '% of price', note: 'All-PR household — no Citizen buyer' };
    }

    function render() {
      var income = +digitsOnly(el('rc-el-income').value) || 0;
      var ceiling = ceilingFor();
      var incomeOk = income <= ceiling;
      var cit = citState();
      var absd = absdRow();

      /* Verdict */
      var verdict, warn = false;
      if (cit === 'no') { verdict = 'Not eligible'; warn = true; }
      else if (!incomeOk) { verdict = 'Over the ceiling'; warn = true; }
      else if (cit === 'conditional') { verdict = 'Check details'; warn = true; }
      else { verdict = 'Looks eligible'; }
      var vEl = el('rc-el-verdict');
      vEl.textContent = verdict;
      vEl.classList.toggle('rc-calc-el__big-val--warn', warn);

      /* Rows */
      var rows = [];
      rows.push({ k: 'Likely scheme', note: '', v: schemeName(), vnote: '', zero: false });

      var citVal, citNote;
      if (cit === 'ok') { citVal = 'Eligible'; citNote = 'At least one Singapore Citizen'; }
      else if (cit === 'no') { citVal = 'Not met'; citNote = 'Singles schemes are for Singapore Citizens only'; }
      else { citVal = 'Conditional'; citNote = 'All-PR: resale Standard flat only, each PR held PR ≥3 years'; }
      rows.push({ k: 'Citizenship', note: '', v: citVal, vnote: citNote, zero: cit === 'no' });

      rows.push({
        k: 'Income ceiling',
        note: '',
        v: (incomeOk ? 'Within' : 'Above'),
        vnote: 'S$' + fmt(income) + ' vs S$' + fmt(ceiling) + '/mo',
        zero: !incomeOk
      });

      rows.push({ k: 'ABSD on this flat', note: '', v: absd.v, vnote: absd.note, zero: false });

      rows.push({
        k: "Seller's Stamp Duty",
        note: '',
        v: 'Normally S$0',
        vnote: 'You can only sell after MOP (5 yrs), past the 4-yr SSD window. Separate clock — an HDB-approved early sale can still trigger it.',
        zero: false
      });

      if (S.own === 'yes') {
        rows.push({
          k: 'You own another property',
          note: '',
          v: 'Must dispose',
          vnote: 'An HDB flat must meet its MOP first; existing property is generally sold within 6 months of buying the resale flat.',
          zero: false
        });
      }

      el('rc-el-breakdown-rows').innerHTML = rows.map(function (r) {
        return '<div class="rc-calc-el__r' + (r.zero ? ' rc-calc-el__r--zero' : '') + '">' +
          '<div class="rc-calc-el__r-k">' + r.k + (r.note ? '<small>' + r.note + '</small>' : '') + '</div>' +
          '<div class="rc-calc-el__r-v">' + r.v + (r.vnote ? '<small>' + r.vnote + '</small>' : '') + '</div></div>';
      }).join('');

      el('rc-el-ceiling-hint').textContent = incomeOk
        ? (schemeName() + ' ceiling S$' + fmt(ceiling) + '/mo')
        : ('Above the S$' + fmt(ceiling) + '/mo ceiling for this scheme');
    }

    function setSeg(groupIds, activeId, stateKey, val) {
      groupIds.forEach(function (id) { el(id).classList.remove('rc-calc-el__seg-btn--active'); });
      el(activeId).classList.add('rc-calc-el__seg-btn--active');
      S[stateKey] = val;
      render();
    }

    el('rc-el-income').addEventListener('input', function () {
      var n = +digitsOnly(el('rc-el-income').value) || 0;
      el('rc-el-income-range').value = Math.min(16000, n);
      render();
    });
    el('rc-el-income').addEventListener('blur', function () {
      el('rc-el-income').value = fmt(+digitsOnly(el('rc-el-income').value) || 0);
    });
    el('rc-el-income-range').addEventListener('input', function () {
      el('rc-el-income').value = fmt(+el('rc-el-income-range').value);
      render();
    });

    var schemeIds = ['rc-el-scheme-couple', 'rc-el-scheme-fiance', 'rc-el-scheme-single', 'rc-el-scheme-twosingles'];
    schemeIds.forEach(function (id) {
      el(id).addEventListener('click', function () { setSeg(schemeIds, id, 'scheme', el(id).dataset.val); });
    });
    var citIds = ['rc-el-cit-sc', 'rc-el-cit-pr'];
    citIds.forEach(function (id) {
      el(id).addEventListener('click', function () { setSeg(citIds, id, 'cit', el(id).dataset.val); });
    });
    var ownIds = ['rc-el-own-no', 'rc-el-own-yes'];
    ownIds.forEach(function (id) {
      el(id).addEventListener('click', function () { setSeg(ownIds, id, 'own', el(id).dataset.val); });
    });

    fetch(POLICY_ENDPOINT)
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data && data.income_ceiling) { POLICY = data; render(); } })
      .catch(function () {});

    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculator-hdb-valuation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* Shopify bundles every section's {% javascript %} into one shared
       <script> tag site-wide — if this section isn't on the current page,
       every el() below would be null. Bail out immediately. */
    var root = document.querySelector('.rc-calc-hv');
    if (!root) return;

    var STREETS_URL = 'https://api.roncasa.co/calc/hdb-streets';
    var SEARCH_URL = 'https://api.roncasa.co/calc/hdb-search';
    var VALUATION_URL = 'https://api.roncasa.co/calc/hdb-valuation';
    /* {% javascript %} is bundled as a static asset — Liquid never runs
       inside it, so `wa_url` (a Liquid var) was never a real JS value here.
       Every renderResult() call threw ReferenceError: wa_url is not
       defined, which is why the tool never completed a valuation through
       the actual page. Passed in via a data attribute on the root element
       instead, which Liquid does render. */
    var WA_URL = root.getAttribute('data-wa-url') || 'https://wa.me/6592977827';

    var sid = root.id.replace('rc-calc-hv-', '');
    function id(base) { return base + '-' + sid; }
    function $(base) { return document.getElementById(id(base)); }
    var sqmToSqft = function (n) { return Math.round(+n * 10.764); };
    var fmt = function (n) { return '$' + Math.round(n).toLocaleString(); };
    var fmtPsf = function (n) { return '$' + Math.round(n).toLocaleString() + ' psf'; };
    var fmtSize = function (sqft, sqm) { return sqft.toLocaleString() + ' sqft (' + (Math.round(sqm * 10) / 10) + ' sqm)'; };
    /* Mirrors slugify()/block_handle() in scripts/hdb_updates/post_hdb_product.py
       exactly — non-alphanumeric runs to '-', trimmed, lowercased — so the URL
       resolves to this block's real HDB resale product page. */
    var slugify = function (s) { return (s || '').replace(/[^A-Za-z0-9]+/g, '-').replace(/^-+|-+$/g, '').toLowerCase() || 'x'; };
    var blockHandle = function (block, street) { return slugify(block) + '-' + slugify(street) + '-hdb-resale'; };
    var FLAT_ORDER = ['1 ROOM', '2 ROOM', '3 ROOM', '4 ROOM', '5 ROOM', 'EXECUTIVE', 'MULTI-GENERATION'];
    var allTxns = [], streets = [], selBlock = '', selFlat = '', selFloor = '', selSqft = 0, selSqm = 0, selModel = '', scopeFilter = 'all', lastVal = null, lastStreet = '';

    /* Every fetch below used to have no timeout at all — a stalled request
       (cold BigQuery cache, a dropped connection) left the spinner running
       forever with no way to recover short of a page reload. Bounded at
       20s, comfortably above the Worker's own 15s BQ timeoutMs. */
    function fetchTimeout(url, ms) {
      var ctrl = new AbortController();
      var timer = setTimeout(function () { ctrl.abort(); }, ms || 20000);
      return fetch(url, { signal: ctrl.signal }).then(
        function (r) { clearTimeout(timer); return r; },
        function (err) { clearTimeout(timer); throw err; }
      );
    }

    function showAC(acBase, opts, field) {
      var inputEl = { block: 'inBlock', flat: 'inFlat', floor: 'inFloor', size: 'inSize' }[field];
      var val = $(inputEl).value.toUpperCase();
      renderAC(acBase, opts.filter(function (o) { return o.toUpperCase().indexOf(val) !== -1; }).slice(0, 10), field);
    }
    function renderAC(acBase, items, field) {
      var el = $(acBase);
      if (!items.length) { el.style.display = 'none'; return; }
      el.innerHTML = '';
      items.forEach(function (s) {
        var div = document.createElement('div');
        div.className = 'item';
        div.textContent = s;
        div.addEventListener('mousedown', function () { pickAC(field, s); });
        el.appendChild(div);
      });
      el.style.display = 'block';
    }
    function pickAC(field, val) {
      var ids = { block: 'inBlock', flat: 'inFlat', floor: 'inFloor', size: 'inSize' };
      var acIds = { block: 'acBlock', flat: 'acFlat', floor: 'acFloor', size: 'acSize' };
      if (ids[field]) { $(ids[field]).value = val; $(acIds[field]).style.display = 'none'; }
      if (field === 'block') confirmBlock(val);
      if (field === 'flat') confirmFlat(val);
      if (field === 'floor') confirmFloor(val);
      if (field === 'size') confirmSize(val);
    }
    function hideAC() { ['acStreet', 'acBlock', 'acFlat', 'acFloor', 'acSize'].forEach(function (b) { $(b).style.display = 'none'; }); }
    function hilite(items, idx) { items.forEach(function (el, i) { el.classList.toggle('sel', i === idx); }); }
    function onKeyField(e, field) {
      var acBase = { street: 'acStreet', block: 'acBlock', flat: 'acFlat', floor: 'acFloor', size: 'acSize' }[field];
      var acEl = $(acBase);
      var items = acEl.querySelectorAll('.item');
      var cur = -1;
      items.forEach(function (el, i) { if (el.classList.contains('sel')) cur = i; });
      if (e.key === 'ArrowDown') { hilite(items, Math.min(cur + 1, items.length - 1)); e.preventDefault(); }
      else if (e.key === 'ArrowUp') { hilite(items, Math.max(cur - 1, 0)); e.preventDefault(); }
      else if (e.key === 'Enter') {
        var active = acEl.querySelector('.item.sel');
        if (active) pickAC(field, active.textContent.trim());
        else if (field === 'street') doSearch();
        e.preventDefault();
      } else if (e.key === 'Escape') hideAC();
    }
    function onStreetType(val) {
      val = val.toUpperCase();
      $('inStreet').value = val;
      if (val.length < 2) { $('acStreet').style.display = 'none'; return; }
      var matches = streets.filter(function (s) { return s.indexOf(val) !== -1; }).slice(0, 8);
      var el = $('acStreet');
      if (!matches.length) { el.style.display = 'none'; return; }
      el.innerHTML = '';
      matches.forEach(function (s) {
        var div = document.createElement('div');
        div.className = 'item';
        div.textContent = s;
        div.addEventListener('mousedown', function () { pickStreet(s); });
        el.appendChild(div);
      });
      el.style.display = 'block';
    }
    function pickStreet(s) { $('inStreet').value = s; $('acStreet').style.display = 'none'; doSearch(); }

    function loadStreets() {
      fetchTimeout(STREETS_URL, 20000).then(function (r) { return r.json(); }).then(function (d) { if (d.streets) streets = d.streets; }).catch(function () {});
    }

    function getBlocks() {
      var seen = {}, out = [];
      allTxns.forEach(function (r) { if (!seen[r.block]) { seen[r.block] = true; out.push(r.block); } });
      out.sort(function (a, b) { return (isNaN(a) || isNaN(b)) ? a.localeCompare(b) : (+a - +b); });
      return out.map(function (b) { return 'Block ' + b; });
    }
    function getFlatTypes() {
      var seen = {}, out = [];
      allTxns.filter(function (r) { return r.block === selBlock; }).forEach(function (r) { if (!seen[r.flat_type]) { seen[r.flat_type] = true; out.push(r.flat_type); } });
      out.sort(function (a, b) { return FLAT_ORDER.indexOf(a) - FLAT_ORDER.indexOf(b); });
      return out;
    }
    function getFloors() {
      var seen = {}, out = [];
      allTxns.filter(function (r) { return r.block === selBlock && r.flat_type === selFlat; }).forEach(function (r) { if (!seen[r.floor]) { seen[r.floor] = true; out.push(r.floor); } });
      return out.sort();
    }
    function getSizes() {
      var seen = {}, out = [];
      allTxns.filter(function (r) { return r.block === selBlock && r.flat_type === selFlat && r.floor === selFloor; }).forEach(function (r) {
        var s = fmtSize(sqmToSqft(r.sqm), r.sqm);
        if (!seen[s]) { seen[s] = true; out.push(s); }
      });
      return out.sort(function (a, b) { return (+a) - (+b); });
    }
    function getModel() {
      var pool = allTxns.filter(function (r) { return r.block === selBlock && r.flat_type === selFlat; });
      var counts = {};
      pool.forEach(function (r) { var m = r.model || ''; counts[m] = (counts[m] || 0) + 1; });
      var best = '', bestN = -1;
      Object.keys(counts).forEach(function (k) { if (counts[k] > bestN) { bestN = counts[k]; best = k; } });
      return best;
    }

    function unlock(base) { $(base).classList.remove('locked'); }
    function setDone(base) { $(base).classList.remove('locked'); $(base).classList.add('done'); }
    function resetFrom(fromBase) {
      var steps = ['s2', 's3', 's4', 's5'];
      var from = steps.indexOf(fromBase);
      if (from < 0) return;
      var inputMap = { s2: 'inBlock', s3: 'inFlat', s4: 'inFloor', s5: 'inSize' };
      var acMap = { s2: 'acBlock', s3: 'acFlat', s4: 'acFloor', s5: 'acSize' };
      steps.slice(from).forEach(function (b) {
        $(b).classList.add('locked'); $(b).classList.remove('done');
        var inp = $(inputMap[b]); if (inp) { inp.value = ''; inp.disabled = true; }
        var ac = $(acMap[b]); if (ac) ac.style.display = 'none';
      });
      if (from <= 0) selBlock = '';
      if (from <= 1) { selFlat = ''; selModel = ''; }
      if (from <= 2) selFloor = '';
      if (from <= 3) { selSqft = 0; selSqm = 0; }
    }

    function confirmBlock(val) {
      selBlock = val.replace('Block ', '');
      setDone('s2'); resetFrom('s3'); unlock('s3');
      $('inFlat').disabled = false; $('inFlat').value = ''; $('inFlat').focus();
      setResult('');
      var opts = getFlatTypes();
      if (opts.length === 1) { $('inFlat').value = opts[0]; confirmFlat(opts[0]); }
      else renderAC('acFlat', opts, 'flat');
    }
    function confirmFlat(val) {
      selFlat = val; selModel = getModel();
      setDone('s3'); resetFrom('s4'); unlock('s4');
      $('inFloor').disabled = false; $('inFloor').value = ''; $('inFloor').focus();
      setResult('');
      var opts = getFloors();
      if (opts.length === 1) { $('inFloor').value = opts[0]; confirmFloor(opts[0]); }
      else renderAC('acFloor', opts, 'floor');
    }
    function confirmFloor(val) {
      selFloor = val;
      setDone('s4'); resetFrom('s5'); unlock('s5');
      $('inSize').disabled = false; $('inSize').value = ''; $('inSize').focus();
      setResult('');
      var opts = getSizes();
      if (opts.length === 1) { $('inSize').value = opts[0]; confirmSize(opts[0]); }
      else renderAC('acSize', opts, 'size');
    }
    function confirmSize(val) {
      selSqft = parseInt(val.replace(/,/g, ''), 10);
      selSqm = Math.round(selSqft / 10.764 * 10) / 10;
      setDone('s5'); $('acSize').style.display = 'none';
      scopeFilter = 'all';
      callValuation();
    }

    function doSearch() {
      var street = $('inStreet').value.trim().toUpperCase();
      if (street.length < 3) return;
      hideAC();
      setResult('<div class="hv-status"><span class="hv-spinner"></span>Searching ' + street + '…</div>');
      resetFrom('s2');
      fetchTimeout(SEARCH_URL + '?street=' + encodeURIComponent(street), 20000).then(function (r) { return r.json(); }).then(function (d) {
        if (d.error || !d.records || !d.records.length) { setResult('<div class="hv-status">No results. Check the street name.</div>'); return; }
        allTxns = d.records;
        setResult(''); setDone('s1'); unlock('s2');
        $('inBlock').disabled = false; $('inBlock').focus();
        var blocks = getBlocks();
        if (blocks.length === 1) { $('inBlock').value = blocks[0]; confirmBlock(blocks[0]); }
        else renderAC('acBlock', blocks, 'block');
      }).catch(function (err) {
        var msg = err && err.name === 'AbortError' ? 'Taking too long. Please try again.' : 'Connection error. Please try again.';
        setResult('<div class="hv-status">' + msg + '</div>');
      });
    }

    function callValuation() {
      var street = $('inStreet').value.trim().toUpperCase();
      setResult('<div class="hv-status"><span class="hv-spinner"></span>Calculating valuation…</div>');
      var floorNum = parseInt(selFloor.split(' TO ')[0].trim(), 10);
      var url = VALUATION_URL + '?block=' + encodeURIComponent(selBlock) + '&street=' + encodeURIComponent(street) + '&flat_type=' + encodeURIComponent(selFlat) + '&flat_model=' + encodeURIComponent(selModel) + '&floor=' + floorNum + '&sqm=' + selSqm;
      fetchTimeout(url, 20000).then(function (r) { return r.json(); }).then(function (val) {
        if (val.error) { showFallback(street); return; }
        renderResult(street, val);
      }).catch(function () { showFallback(street); });
    }

    var MONTH_ABBR = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    function fmtTxnDate(s) { var p = s.split('-'); return (+p[2]) + ' ' + MONTH_ABBR[(+p[1]) - 1]; }
    function recentCutoff() {
      var d = new Date();
      d.setMonth(d.getMonth() - 6);
      return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-01';
    }
    /* Full history (sometimes decades) is too much to show in the table —
       narrow to the last 6 months; if a quiet block/street has nothing
       that recent, fall back to full history rather than showing empty. */
    function recentPool() {
      var all = allTxns.filter(function (r) { return r.flat_type === selFlat; });
      var cutoff = recentCutoff();
      var recent = all.filter(function (r) { return r.date >= cutoff; });
      return recent.length ? recent : all;
    }
    function scopedTxns() {
      var pool = recentPool();
      if (scopeFilter === 'block') return pool.filter(function (r) { return r.block === selBlock; });
      if (scopeFilter === 'nearby') return pool.filter(function (r) { return r.block !== selBlock; });
      return pool;
    }

    function renderResult(street, val) {
      var pool = recentPool();
      var sameBlockN = pool.filter(function (r) { return r.block === selBlock; }).length;
      var nearbyN = pool.filter(function (r) { return r.block !== selBlock; }).length;
      var rows = scopedTxns().sort(function (a, b) { return b.date.localeCompare(a.date); }).slice(0, 8);
      var waMsg = encodeURIComponent('Hi Ronnie, I used the HDB valuation tool on roncasa.co.\n\nMy unit: Block ' + selBlock + ' ' + street + ', ' + selFlat + ', Floor ' + selFloor + ', ' + fmtSize(selSqft, selSqm) + '\nEstimated value: ' + fmt(val.rangeLow) + ' – ' + fmt(val.rangeHigh) + '\n\nI\'d like to find out more.');
      var lcBlock = val.lowConfidence ? '<div class="lc-note">⚠ Limited comparable data for this floor level. Estimate may be less precise</div>' : '';
      var rowsHtml = rows.length ? ('<table class="hv-txn"><tr><th>Date</th><th>Price</th><th>PSF</th><th>Floor</th><th>Sqft</th><th>Scope</th></tr>' + rows.map(function (r) {
        var sqft = sqmToSqft(r.sqm);
        var chipClass = r.block === selBlock ? 'block' : 'nearby';
        var chipLabel = r.block === selBlock ? ('Blk ' + selBlock) : 'Nearby';
        return '<tr><td>' + fmtTxnDate(r.date) + '</td><td class="price">' + fmt(r.price) + '</td><td class="psf">' + fmtPsf(r.price / sqft) + '</td><td>' + r.floor + '</td><td>' + sqft + '</td><td><span class="hv-scope-chip ' + chipClass + '">' + chipLabel + '</span></td></tr>';
      }).join('') + '</table>') : '';
      setResult('<div class="hv-result">' +
        '<div class="r-meta"><span>Blk ' + selBlock + ' ' + street + ' · ' + selFlat + ' · Floor ' + selFloor + ' · ' + fmtSize(selSqft, selSqm) + '</span><span class="hv-chip"><span class="dot"></span>' + val.diagnostics.n_comps + ' transactions analysed</span></div>' +
        '<div class="hv-verdict"><div class="lab">Estimated market value</div><div class="range">' + fmt(val.rangeLow) + ' <em>–</em> ' + fmt(val.rangeHigh) + '</div>' + lcBlock + '</div>' +
        '<div class="hv-subrow"><div class="item"><div class="lab">Point estimate</div><div class="val">' + fmt(val.estimate) + '</div></div><div class="item"><div class="lab">Est. PSF</div><div class="val pos">' + fmtPsf(val.estimate / selSqft) + '</div></div><div class="item"><div class="lab">Unit size</div><div class="val">' + fmtSize(selSqft, selSqm) + '</div></div></div>' +
        '<p class="hv-basis">SAME FLAT TYPE, THIS STREET (LAST 6 MO) <span class="n">' + sameBlockN + ' same block</span> · <span class="n">' + nearbyN + ' nearby</span></p>' +
        '<div class="hv-scope-tabs">' +
          '<button class="' + (scopeFilter === 'all' ? 'active' : '') + '" data-hv-scope="all">All ' + (sameBlockN + nearbyN) + '</button>' +
          '<button class="' + (scopeFilter === 'block' ? 'active' : '') + '" data-hv-scope="block">Same block · ' + sameBlockN + '</button>' +
          '<button class="' + (scopeFilter === 'nearby' ? 'active' : '') + '" data-hv-scope="nearby">Nearby · ' + nearbyN + '</button>' +
        '</div>' +
        rowsHtml +
        '<div class="hv-cta">' +
          '<a class="hv-cta-btn" href="/products/' + blockHandle(selBlock, street) + '">View block details →</a>' +
          '<a class="hv-cta-link" href="' + WA_URL + '?text=' + waMsg + '" target="_blank" rel="noopener">Talk to Ron about this unit →</a>' +
        '</div>' +
      '</div>');
      lastVal = val; lastStreet = street;
      var resEl = $('hvResult');
      resEl.querySelectorAll('[data-hv-scope]').forEach(function (btn) {
        btn.addEventListener('click', function () { setScope(btn.getAttribute('data-hv-scope')); });
      });
    }
    function setScope(f) { scopeFilter = f; if (lastVal) renderResult(lastStreet, lastVal); }

    function showFallback(street) {
      var pool = allTxns.filter(function (r) { return r.block === selBlock && r.flat_type === selFlat && r.floor === selFloor; });
      if (!pool.length) { setResult('<div class="hv-status">Not enough data for this unit.</div>'); return; }
      var prices = pool.map(function (r) { return r.price; }).sort(function (a, b) { return a - b; });
      var lo = prices[Math.floor(prices.length * 0.25)], hi = prices[Math.floor(prices.length * 0.75)], med = prices[Math.floor(prices.length * 0.5)];
      renderResult(street, { estimate: med, rangeLow: lo, rangeHigh: hi, lowConfidence: false, diagnostics: { n_comps: pool.length } });
    }

    function setResult(html) { $('hvResult').innerHTML = html; }

    $('inStreet').addEventListener('input', function () { onStreetType(this.value); });
    $('inStreet').addEventListener('keydown', function (e) { onKeyField(e, 'street'); });
    $('inBlock').addEventListener('input', function () { showAC('acBlock', getBlocks(), 'block'); });
    $('inBlock').addEventListener('keydown', function (e) { onKeyField(e, 'block'); });
    $('inFlat').addEventListener('input', function () { showAC('acFlat', getFlatTypes(), 'flat'); });
    $('inFlat').addEventListener('keydown', function (e) { onKeyField(e, 'flat'); });
    $('inFloor').addEventListener('input', function () { showAC('acFloor', getFloors(), 'floor'); });
    $('inFloor').addEventListener('keydown', function (e) { onKeyField(e, 'floor'); });
    $('inSize').addEventListener('input', function () { showAC('acSize', getSizes(), 'size'); });
    $('inSize').addEventListener('keydown', function (e) { onKeyField(e, 'size'); });
    root.querySelector('[data-hv-search]').addEventListener('click', doSearch);

    loadStreets();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculator-max-loan"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    if (!document.getElementById('rc-ml-type')) return;

    var section = document.querySelector('[data-ml-endpoint]');
    var ENDPOINT = section ? section.getAttribute('data-ml-endpoint') : 'https://api.roncasa.co/calc/max-loan';
    var DEBOUNCE_MS = 300;
    var timer = null;
    var reqSeq = 0;
    var last = null;

    var S = { pax: 1, tenureTouched: false, cpf: null };

    function el(id) { return document.getElementById(id); }
    function fmt(n) { return Math.round(Math.abs(n || 0)).toLocaleString('en-SG'); }
    function fmtM(n) { return '$' + fmt(n); }
    function pct(n) { return (+n).toFixed(2).replace(/\.?0+$/, '') + '%'; }
    function num(id) {
      var e = el(id);
      if (!e) return 0;
      return parseFloat((e.value || '').replace(/[^\d.]/g, '')) || 0;
    }
    function setTxt(id, v) { var e = el(id); if (e) e.textContent = v; }

    function buildUrl() {
      var p = new URLSearchParams();
      p.set('type', el('rc-ml-type').value);
      p.set('buyers', S.pax);
      p.set('debt', num('rc-ml-debt'));
      p.set('b1_age', num('rc-ml-b1-age'));
      p.set('b1_income', num('rc-ml-b1-income'));
      if (S.pax === 2) {
        p.set('b2_age', num('rc-ml-b2-age'));
        p.set('b2_income', num('rc-ml-b2-income'));
      }
      if (S.tenureTouched) p.set('tenure', num('rc-ml-tenure'));
      return ENDPOINT + '?' + p.toString();
    }

    function renderCpf(data) {
      el('rc-ml-cpf-out').hidden = S.cpf !== 'yes';
      el('rc-ml-cpf-no-note').hidden = S.cpf !== 'no';
      if (S.cpf !== 'yes') return;

      var rows = el('rc-ml-oa-rows');
      rows.textContent = '';
      data.oa.rows.forEach(function (r) {
        var row = document.createElement('div');
        row.className = 'rc-calc-ml__row';
        var lab = document.createElement('span');
        lab.className = 'rc-calc-ml__row-lab';
        lab.textContent = 'Buyer ' + (r.buyer === 1 ? 'A' : 'B') + ' OA each month (' + pct(r.pct) + ' of income, up to ' + fmtM(data.oa.ow_ceiling) + ')';
        var val = document.createElement('span');
        val.className = 'rc-calc-ml__row-val';
        val.textContent = fmtM(r.oa_monthly);
        row.appendChild(lab);
        row.appendChild(val);
        rows.appendChild(row);
      });
      setTxt('rc-ml-oa-total', fmtM(data.oa.monthly_total));
      setTxt('rc-ml-oa-covers', fmtM(data.oa.covers));
      setTxt('rc-ml-cash-topup', fmtM(data.oa.cash_topup));
      setTxt('rc-ml-oa-note', data.oa.cash_topup === 0
        ? 'Your OA contributions cover the whole instalment.'
        : 'OA covers ' + fmtM(data.oa.covers) + ' of the ' + fmtM(data.loan.monthly) + ' instalment. You top up the rest in cash.');
    }

    function render(data) {
      var L = data.loan, type = data.inputs.type;
      last = data;

      setTxt('rc-ml-max-loan', fmt(L.max_loan));
      setTxt('rc-ml-binding-sub', L.binding + ' sets your limit');
      setTxt('rc-ml-binding', L.binding);

      el('rc-ml-row-tdsr').hidden = L.tdsr_cap === null;
      el('rc-ml-row-msr').hidden = L.msr_cap === null;
      if (L.tdsr_cap !== null) setTxt('rc-ml-tdsr-cap', fmtM(L.tdsr_cap));
      if (L.msr_cap !== null) setTxt('rc-ml-msr-cap', fmtM(L.msr_cap));

      var P = data.price, C = data.compare;
      setTxt('rc-ml-max-price', fmt(P.max_price));
      setTxt('rc-ml-price-sub', 'Loan up to ' + pct(P.ltv_pct) + ' of price · minimum downpayment ' + fmtM(P.min_downpayment) + ' (' + pct(P.downpayment_pct) + ')');
      setTxt('rc-ml-price-note', P.note);
      el('rc-ml-compare').hidden = !C;
      if (C) {
        setTxt('rc-ml-cmp-a-head', C.tenure + ' years');
        setTxt('rc-ml-cmp-a-loan', fmtM(C.max_loan));
        setTxt('rc-ml-cmp-a-ltv', pct(C.ltv_pct) + ' of price');
        setTxt('rc-ml-cmp-a-price', fmtM(C.max_price));
        setTxt('rc-ml-cmp-a-mo', fmtM(C.monthly));
        setTxt('rc-ml-cmp-b-head', L.tenure + ' years');
        setTxt('rc-ml-cmp-b-loan', fmtM(L.max_loan));
        setTxt('rc-ml-cmp-b-ltv', pct(P.ltv_pct) + ' of price');
        setTxt('rc-ml-cmp-b-price', fmtM(P.max_price));
        setTxt('rc-ml-cmp-b-mo', fmtM(L.monthly));
      }

      setTxt('rc-ml-monthly', fmtM(L.monthly));
      setTxt('rc-ml-charged', pct(L.charged_rate));
      setTxt('rc-ml-test-rate', pct(L.test_rate));
      setTxt('rc-ml-tenure-used', L.tenure + ' years');

      setTxt('rc-ml-stress-note', 'TDSR and MSR are tested at the MAS regulated rate (' + pct(L.test_rate) + ' for ' + (type === 'hdb' ? 'HDB loans' : 'private and bank loans') + '), not the actual rate you will pay.');
      setTxt('rc-ml-ltv-note', 'Your final loan is also capped at ' + L.ltv_pct + '% of the property price' + (L.reduced_ltv ? ', because the tenure is long or runs past age 65.' : '.'));
      setTxt('rc-ml-debt-note', type === 'hdb' ? 'Your monthly debts are taken off the 30% MSR allowance before the loan is sized.' : '');

      setTxt('rc-ml-tenure-hint', S.tenureTouched ? 'Up to ' + L.max_tenure + ' years' : 'Set to the longest allowed');
      if (!S.tenureTouched) el('rc-ml-tenure').value = L.tenure;
      el('rc-ml-tenure-reset').hidden = !S.tenureTouched;

      renderCpf(data);
    }

    function fetchAndRender() {
      var seq = ++reqSeq;
      var badge = el('rc-ml-live-badge');
      if (badge) badge.textContent = 'Updating…';
      fetch(buildUrl())
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (seq !== reqSeq) return; // stale response, a newer request is in flight
          render(data);
          if (badge) badge.textContent = 'Live · updates as you type';
        })
        .catch(function () {
          if (seq !== reqSeq) return;
          if (badge) badge.textContent = 'Could not reach the calculator. Try again shortly.';
        });
    }

    function debounced() {
      clearTimeout(timer);
      timer = setTimeout(fetchAndRender, DEBOUNCE_MS);
    }

    function setPax(n) {
      S.pax = n;
      el('rc-ml-pax1').classList.toggle('rc-calc-ml__pill--active', n === 1);
      el('rc-ml-pax2').classList.toggle('rc-calc-ml__pill--active', n === 2);
      el('rc-ml-buyer2').hidden = n !== 2;
      S.tenureTouched = false;
      debounced();
    }
    function setCpf(v) {
      S.cpf = v;
      el('rc-ml-cpf-yes').classList.toggle('rc-calc-ml__pill--active', v === 'yes');
      el('rc-ml-cpf-no').classList.toggle('rc-calc-ml__pill--active', v === 'no');
      if (last) renderCpf(last);
    }

    el('rc-ml-pax1').addEventListener('click', function () { setPax(1); });
    el('rc-ml-pax2').addEventListener('click', function () { setPax(2); });
    el('rc-ml-cpf-yes').addEventListener('click', function () { setCpf('yes'); });
    el('rc-ml-cpf-no').addEventListener('click', function () { setCpf('no'); });
    el('rc-ml-type').addEventListener('change', function () { S.tenureTouched = false; debounced(); });

    ['rc-ml-b1-age', 'rc-ml-b2-age'].forEach(function (id) {
      el(id).addEventListener('input', function () { S.tenureTouched = false; debounced(); });
    });
    ['rc-ml-b1-income', 'rc-ml-b2-income', 'rc-ml-debt'].forEach(function (id) {
      var e = el(id);
      e.addEventListener('input', debounced);
      e.addEventListener('blur', function () { e.value = fmt(num(id)); });
    });

    el('rc-ml-tenure').addEventListener('input', function () { S.tenureTouched = true; debounced(); });
    el('rc-ml-tenure-reset').addEventListener('click', function () { S.tenureTouched = false; debounced(); });

    fetchAndRender();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculator-monthly-mortgage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* Shopify bundles every section's {% javascript %} into one shared
       <script> tag site-wide — if this section isn't on the current page,
       every el(id) below would be null and throw, killing every OTHER
       section's JS later in that same bundle. Bail out immediately. */
    if (!document.getElementById('rc-mm-loan')) return;

    var ENDPOINT = 'https://api.roncasa.co/calc/monthly-mortgage';
    var DEBOUNCE_MS = 300;
    var timer = null;

    function el(id) { return document.getElementById(id); }
    function fmt(n) { return Math.round(n || 0).toLocaleString('en-SG'); }
    function fmtMoney(n) { return '$' + fmt(n); }
    function num(id) {
      var e = el(id);
      if (!e) return 0;
      return parseFloat((e.value || '').replace(/[^\d.]/g, '')) || 0;
    }

    function buildUrl() {
      var p = new URLSearchParams();
      p.set('loan', num('rc-mm-loan'));
      p.set('tenure', num('rc-mm-tenure'));
      p.set('rate', num('rc-mm-rate'));
      return ENDPOINT + '?' + p.toString();
    }

    function render(data) {
      el('rc-mm-monthly').textContent = fmt(data.monthly);
      el('rc-mm-total-interest').textContent = fmtMoney(data.total_interest);
      el('rc-mm-total-repaid').textContent = fmtMoney(data.total_repaid);
      el('rc-mm-first-year').textContent = fmtMoney(data.first_year_payment);
      el('rc-mm-bar-p').style.width = data.principal_pct + '%';
      el('rc-mm-bar-i').style.width = data.interest_pct + '%';
      el('rc-mm-leg-p').textContent = fmt(data.principal);
      el('rc-mm-leg-i').textContent = fmt(data.total_interest);
      el('rc-mm-loan-label').textContent = fmt(data.principal);
    }

    function fetchAndRender() {
      var badge = el('rc-mm-live-badge');
      if (badge) badge.textContent = 'Updating…';
      fetch(buildUrl())
        .then(function (r) { return r.json(); })
        .then(function (data) {
          render(data);
          if (badge) badge.textContent = 'Live · updates as you type';
        })
        .catch(function () {
          if (badge) badge.textContent = 'Live · updates as you type';
        });
    }

    function debounced() {
      clearTimeout(timer);
      timer = setTimeout(fetchAndRender, DEBOUNCE_MS);
    }

    el('rc-mm-loan').addEventListener('input', function () {
      var v = num('rc-mm-loan');
      var range = el('rc-mm-loan-range');
      if (v >= +range.min && v <= +range.max) range.value = v;
      debounced();
    });
    el('rc-mm-loan').addEventListener('blur', function () { el('rc-mm-loan').value = fmt(num('rc-mm-loan')); });
    el('rc-mm-loan-range').addEventListener('input', function () {
      el('rc-mm-loan').value = fmt(+el('rc-mm-loan-range').value);
      debounced();
    });

    el('rc-mm-tenure').addEventListener('input', function () {
      var v = num('rc-mm-tenure');
      var range = el('rc-mm-tenure-range');
      if (v >= +range.min && v <= +range.max) range.value = v;
      debounced();
      refreshPresets();
    });
    el('rc-mm-tenure-range').addEventListener('input', function () {
      el('rc-mm-tenure').value = el('rc-mm-tenure-range').value;
      debounced();
      refreshPresets();
    });

    el('rc-mm-rate').addEventListener('input', function () {
      var v = num('rc-mm-rate');
      var range = el('rc-mm-rate-range');
      if (v >= +range.min && v <= +range.max) range.value = v;
      debounced();
      refreshPresets();
    });
    el('rc-mm-rate-range').addEventListener('input', function () {
      el('rc-mm-rate').value = el('rc-mm-rate-range').value;
      debounced();
      refreshPresets();
    });

    document.querySelectorAll('.rc-calc-mm__preset[data-tenure]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        el('rc-mm-tenure').value = a.dataset.tenure;
        el('rc-mm-tenure-range').value = a.dataset.tenure;
        debounced();
        refreshPresets();
      });
    });
    document.querySelectorAll('.rc-calc-mm__preset[data-rate]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        el('rc-mm-rate').value = a.dataset.rate;
        el('rc-mm-rate-range').value = a.dataset.rate;
        debounced();
        refreshPresets();
      });
    });

    function refreshPresets() {
      document.querySelectorAll('.rc-calc-mm__preset[data-tenure]').forEach(function (a) {
        a.classList.toggle('rc-calc-mm__preset--active', +a.dataset.tenure === num('rc-mm-tenure'));
      });
      document.querySelectorAll('.rc-calc-mm__preset[data-rate]').forEach(function (a) {
        a.classList.toggle('rc-calc-mm__preset--active', Math.abs(+a.dataset.rate - num('rc-mm-rate')) < 0.01);
      });
    }

    fetchAndRender();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculator-private-buyer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    if (!document.getElementById('rc-pb-price')) return;

    var ENDPOINT = 'https://api.roncasa.co/calc/private-buyer';
    var DEBOUNCE_MS = 300;
    var timer = null;
    var reqSeq = 0;

    var S = { pax: 2, useCpf: true, offset: true, loanTouched: false, tenureTouched: false };

    function el(id) { return document.getElementById(id); }
    function fmt(n) { return Math.round(Math.abs(n || 0)).toLocaleString('en-SG'); }
    function fmtM(n) { return '$' + fmt(n); }
    function num(id) {
      var e = el(id);
      if (!e) return 0;
      return parseFloat((e.value || '').replace(/[^\d.]/g, '')) || 0;
    }
    function setTxt(id, v) { var e = el(id); if (e) e.textContent = v; }

    function natLabel(n) { return n === 'sc' ? 'Singapore Citizen' : n === 'pr' ? 'Singapore PR' : 'Foreigner'; }

    function buildUrl() {
      var p = new URLSearchParams();
      p.set('price', num('rc-pb-price'));
      p.set('pax', S.pax);
      p.set('debt', num('rc-pb-debt'));
      p.set('use_cpf', S.useCpf ? 'true' : 'false');
      p.set('offset', S.offset ? 'true' : 'false');
      p.set('legal', el('rc-pb-legal-type').value);
      p.set('rate', num('rc-pb-rate'));
      p.set('tenure_touched', S.tenureTouched ? 'true' : 'false');
      if (S.tenureTouched) p.set('tenure_input', num('rc-pb-tenure'));
      p.set('loan_touched', S.loanTouched ? 'true' : 'false');
      if (S.loanTouched) p.set('loan_input', num('rc-pb-loan'));

      p.set('b1_age', num('rc-pb-b1-age'));
      p.set('b1_income', num('rc-pb-b1-income'));
      p.set('b1_cpf', S.useCpf ? num('rc-pb-b1-cpf') : 0);
      p.set('b1_nat', el('rc-pb-b1-nat').value);
      p.set('b1_owned', el('rc-pb-b1-owned').value);
      if (S.pax === 2) {
        p.set('b2_age', num('rc-pb-b2-age'));
        p.set('b2_income', num('rc-pb-b2-income'));
        p.set('b2_cpf', S.useCpf ? num('rc-pb-b2-cpf') : 0);
        p.set('b2_nat', el('rc-pb-b2-nat').value);
        p.set('b2_owned', el('rc-pb-b2-owned').value);
      }
      return ENDPOINT + '?' + p.toString();
    }

    function render(data) {
      setTxt('rc-pb-cash-required', fmt(data.effective_cash.total));

      setTxt('rc-pb-max-loan-val', fmtM(data.loan.max_loan));
      setTxt('rc-pb-max-loan-note', 'LTV ' + data.loan.ltv_pct + '% cap ' + fmtM(data.loan.ltv_cap) + ' · TDSR cap ' + fmtM(data.loan.tdsr_cap) + '.');

      var natB1 = el('rc-pb-b1-nat').value, ownedB1 = +el('rc-pb-b1-owned').value;
      var flag = '';
      if (S.pax === 1 || data.absd.top_buyer_index === 0) {
        flag = natLabel(natB1) + ' · ' + data.absd.rate_pct + '% ABSD' + (data.absd.rate_pct === 0 ? ' (nil on a first Singapore Citizen purchase)' : '') + '.';
      } else {
        var natB2 = el('rc-pb-b2-nat').value;
        flag = 'Charged at the higher rate: ' + natLabel(natB2) + ' · ' + data.absd.rate_pct + '% ABSD.';
      }
      setTxt('rc-pb-profile-flag', flag);

      if (!S.loanTouched) {
        el('rc-pb-loan').value = fmt(data.loan.max_loan);
        el('rc-pb-loan-range').value = data.loan.max_loan;
      }
      el('rc-pb-loan-range').max = Math.max(10000, data.loan.max_loan);
      setTxt('rc-pb-loan-max-label', fmtM(data.loan.max_loan) + ' max');

      if (!S.tenureTouched) {
        el('rc-pb-tenure').value = data.loan.tenure;
        el('rc-pb-tenure-range').value = data.loan.tenure;
      }
      el('rc-pb-tenure-range').max = data.loan.max_tenure_age;

      setTxt('rc-pb-wf-option', fmtM(data.stage1.option));

      setTxt('rc-pb-wf-exercise', fmtM(data.stage2.exercise));
      setTxt('rc-pb-wf-bsd', fmtM(data.stage2.bsd));
      el('rc-pb-wf-row-absd').style.display = data.stage2.absd > 0 ? 'flex' : 'none';
      setTxt('rc-pb-wf-absd-lab', 'ABSD · ' + data.absd.rate_pct + '%');
      setTxt('rc-pb-wf-absd', fmtM(data.stage2.absd));
      setTxt('rc-pb-wf-legal', fmtM(data.stage2.legal));
      setTxt('rc-pb-wf-stage2', fmtM(data.stage2.exercise + data.stage2.stamp_duty + data.stage2.legal));

      setTxt('rc-pb-wf-ltv-cap', fmtM(data.loan.ltv_cap));
      setTxt('rc-pb-wf-tdsr-cap', fmtM(data.loan.tdsr_cap));
      setTxt('rc-pb-wf-loan-tenure', fmtM(data.loan.loan) + ' · ' + data.loan.tenure + 'y · ' + data.loan.rate.toFixed(2) + '%');
      setTxt('rc-pb-wf-mo', fmtM(data.loan.monthly));
      setTxt('rc-pb-wf-tdsr-used', data.loan.tdsr_used_pct.toFixed(1) + '%');
      setTxt('rc-pb-wf-balance-down', fmtM(data.funding.balance_downpayment));
      setTxt('rc-pb-wf-cpf-down', fmtM(data.funding.cpf.downpayment));
      var rowShort = el('rc-pb-wf-row-shortfall');
      rowShort.style.display = data.funding.shortfall > 0 ? 'flex' : 'none';
      setTxt('rc-pb-wf-shortfall', fmtM(data.funding.shortfall));

      setTxt('rc-pb-wf-oa-inflow', fmtM(data.oa_offset.monthly_inflow));
      setTxt('rc-pb-wf-cash-mo', fmtM(data.oa_offset.cash_monthly));

      setTxt('rc-pb-wf-total', fmtM(data.effective_cash.total));
    }

    function fetchAndRender() {
      var seq = ++reqSeq;
      var badge = el('rc-pb-live-badge');
      if (badge) badge.textContent = 'Updating…';
      fetch(buildUrl())
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (seq !== reqSeq) return; // a newer request was issued while this one was in flight — drop the stale response
          render(data);
          if (badge) badge.textContent = 'Live · updates as you type';
        })
        .catch(function () {
          if (seq !== reqSeq) return;
          if (badge) badge.textContent = 'Live · updates as you type';
        });
    }

    function debounced() {
      clearTimeout(timer);
      timer = setTimeout(fetchAndRender, DEBOUNCE_MS);
    }

    function setPax(n) {
      S.pax = n;
      el('rc-pb-pax1').classList.toggle('rc-calc-pb__pill--active', n === 1);
      el('rc-pb-pax2').classList.toggle('rc-calc-pb__pill--active', n === 2);
      el('rc-pb-buyer2').style.display = n === 2 ? 'block' : 'none';
      el('rc-pb-age-buyer2').style.display = n === 2 ? 'block' : 'none';
      el('rc-pb-cpf2').style.display = n === 2 ? 'block' : 'none';
      S.loanTouched = false; S.tenureTouched = false;
      debounced();
    }
    function setUseCpf(v) { S.useCpf = v; el('rc-pb-usecpf-yes').classList.toggle('rc-calc-pb__pill--active', v); el('rc-pb-usecpf-no').classList.toggle('rc-calc-pb__pill--active', !v); el('rc-pb-cpf-wrap').style.display = v ? 'block' : 'none'; debounced(); }
    function setOffset(v) { S.offset = v; el('rc-pb-offset-yes').classList.toggle('rc-calc-pb__pill--active', v); el('rc-pb-offset-no').classList.toggle('rc-calc-pb__pill--active', !v); debounced(); }

    el('rc-pb-pax1').addEventListener('click', function () { setPax(1); });
    el('rc-pb-pax2').addEventListener('click', function () { setPax(2); });
    el('rc-pb-usecpf-yes').addEventListener('click', function () { setUseCpf(true); });
    el('rc-pb-usecpf-no').addEventListener('click', function () { setUseCpf(false); });
    el('rc-pb-offset-yes').addEventListener('click', function () { setOffset(true); });
    el('rc-pb-offset-no').addEventListener('click', function () { setOffset(false); });
    el('rc-pb-legal-type').addEventListener('change', debounced);
    ['rc-pb-b1-nat', 'rc-pb-b1-owned', 'rc-pb-b2-nat', 'rc-pb-b2-owned'].forEach(function (id) {
      el(id).addEventListener('change', debounced);
    });

    var priceInput = el('rc-pb-price'), priceRange = el('rc-pb-price-range');
    priceRange.addEventListener('input', function () { priceInput.value = fmt(+priceRange.value); debounced(); });
    priceInput.addEventListener('input', function () {
      var v = num('rc-pb-price');
      if (v >= +priceRange.min && v <= +priceRange.max) priceRange.value = v;
      debounced();
    });
    priceInput.addEventListener('blur', function () { priceInput.value = fmt(num('rc-pb-price')); });

    el('rc-pb-debt').addEventListener('input', debounced);
    el('rc-pb-debt').addEventListener('blur', function () { el('rc-pb-debt').value = fmt(num('rc-pb-debt')); });

    var rateInput = el('rc-pb-rate'), rateRange = el('rc-pb-rate-range');
    rateRange.addEventListener('input', function () { rateInput.value = (+rateRange.value).toFixed(2); debounced(); });
    rateInput.addEventListener('input', function () {
      var v = num('rc-pb-rate');
      if (v >= +rateRange.min && v <= +rateRange.max) rateRange.value = v;
      debounced();
    });

    var loanInput = el('rc-pb-loan'), loanRange = el('rc-pb-loan-range');
    loanRange.addEventListener('input', function () { S.loanTouched = true; loanInput.value = fmt(+loanRange.value); debounced(); });
    loanInput.addEventListener('input', function () { S.loanTouched = true; debounced(); });
    loanInput.addEventListener('blur', function () { loanInput.value = fmt(num('rc-pb-loan')); });

    var tenureInput = el('rc-pb-tenure'), tenureRange = el('rc-pb-tenure-range');
    tenureRange.addEventListener('input', function () { S.tenureTouched = true; tenureInput.value = tenureRange.value; debounced(); });
    tenureInput.addEventListener('input', function () {
      S.tenureTouched = true;
      var v = num('rc-pb-tenure');
      if (v >= 5 && v <= 35) tenureRange.value = v;
      debounced();
    });

    ['rc-pb-b1-age', 'rc-pb-b1-income', 'rc-pb-b1-cpf', 'rc-pb-b2-age', 'rc-pb-b2-income', 'rc-pb-b2-cpf'].forEach(function (id) {
      var e = el(id);
      if (e) e.addEventListener('input', debounced);
    });

    fetchAndRender();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculator-progressive-payment-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* Shopify bundles every section's {% javascript %} into one shared
       <script> tag site-wide — if this section isn't on the current page,
       every el(id) below would be null and throw, killing every OTHER
       section's JS later in that same bundle. Bail out immediately. */
    if (!document.getElementById('rc-pp-price')) return;

    var ENDPOINT = 'https://api.roncasa.co/calc/progressive-payment';
    var DEBOUNCE_MS = 300;
    var timer = null;

    var S = { loanEst: false, buyers: 1, useCPF: false, sdActive: false, manualLoan: null, baseLtv: 75 };

    function el(id) { return document.getElementById(id); }
    function fmt(n) { return Math.round(n || 0).toLocaleString('en-SG'); }
    function fmtMoney(n) { return '$' + fmt(n); }
    function num(id) {
      var e = el(id);
      if (!e) return 0;
      return parseFloat((e.value || '').replace(/[^\d.]/g, '')) || 0;
    }
    function tag(label, cls) {
      return '<span class="rc-calc-pp__tag rc-calc-pp__tag--' + cls + '">' + label + '</span>';
    }

    function buildUrl() {
      var p = new URLSearchParams();
      p.set('price', num('rc-pp-price'));
      p.set('rate', num('rc-pp-rate'));
      p.set('tenure', num('rc-pp-tenure'));
      p.set('ltv', S.baseLtv);
      p.set('loan_est', S.loanEst ? 'true' : 'false');
      if (S.loanEst) {
        p.set('buyers', S.buyers);
        p.set('b1_age', num('rc-pp-b1-age'));
        p.set('b1_income', num('rc-pp-b1-income'));
        if (S.buyers === 2) {
          p.set('b2_age', num('rc-pp-b2-age'));
          p.set('b2_income', num('rc-pp-b2-income'));
        }
        if (S.manualLoan != null) p.set('manual_loan', S.manualLoan);
      }
      p.set('use_cpf', S.useCPF ? 'true' : 'false');
      p.set('sd_active', S.sdActive ? 'true' : 'false');
      if (S.sdActive) {
        p.set('sd_status', el('rc-pp-sd-status').value);
        p.set('sd_residency1', el('rc-pp-sd-residency1').value);
        p.set('sd_residency2', el('rc-pp-sd-residency2').value);
        p.set('sd_prop_count', el('rc-pp-sd-propcount').value);
      }
      return ENDPOINT + '?' + p.toString();
    }

    // Which of LTV / TDSR actually limits the loan — pure comparison of two
    // numbers the Worker already returned, no formula re-derivation.
    function bindingNote(tdsr) {
      var ltvCap = tdsr.ltv_cap, maxLoan = tdsr.max_loan_tdsr;
      if (ltvCap < maxLoan) {
        return '<b>LTV is the binding constraint</b>. Bank will lend up to ' + fmtMoney(ltvCap) + ' even though income supports ' + fmtMoney(maxLoan) + '.';
      }
      if (maxLoan < ltvCap) {
        return '<b>TDSR is the binding constraint</b>. Income limits the loan to ' + fmtMoney(maxLoan) + ', below the ' + tdsr.ltv_pct_used + '% LTV cap of ' + fmtMoney(ltvCap) + '.';
      }
      return 'LTV cap and TDSR max loan are equal at ' + fmtMoney(ltvCap) + '.';
    }

    // Tenure/LTV tradeoff — relevantAge comes straight from the buyer age
    // inputs already on screen; baseLtv/tenure are the values already sent
    // to the Worker. Same MAS rule the Worker used, just explained back.
    function tenureNote(tdsr) {
      var relevantAge = S.buyers === 2 ? Math.max(num('rc-pp-b1-age'), num('rc-pp-b2-age')) : num('rc-pp-b1-age');
      var tenure = num('rc-pp-tenure');
      var maxTenureForFullLtv = Math.max(1, 65 - relevantAge);
      if (!tdsr.mas_triggered) {
        return '✓ At ' + tenure + 'y, you stay within the ' + S.baseLtv + '% LTV tier (age ' + relevantAge + ' + ' + tenure + 'y = ' + (relevantAge + tenure) + ', within 65).';
      }
      if (maxTenureForFullLtv >= 5) {
        return '<span class="rc-calc-pp__mo-split--warn">*</span> Reducing tenure to ' + maxTenureForFullLtv + 'y or below would restore the ' + S.baseLtv + '% LTV tier (age ' + relevantAge + ' + tenure ≤ 65).';
      }
      return '<span class="rc-calc-pp__mo-split--warn">*</span> At age ' + relevantAge + ', no tenure keeps you within 65, the reduced ' + tdsr.ltv_pct_used + '% LTV tier applies regardless.';
    }

    // MAS reduced-LTV callout. Every figure is read from values already on
    // screen / returned by the Worker: base LTV (S.baseLtv), the LTV the Worker
    // actually used (ltv_pct_used), tenure and buyer age inputs, ltv_cap.
    function ltvCalloutHtml(tdsr) {
      var from = S.baseLtv, to = tdsr.ltv_pct_used;
      var relevantAge = S.buyers === 2 ? Math.max(num('rc-pp-b1-age'), num('rc-pp-b2-age')) : num('rc-pp-b1-age');
      var tenure = num('rc-pp-tenure');
      var why = [];
      if (tenure > 30) why.push('your loan tenure is over 30 years (' + tenure + 'y)');
      if (relevantAge + tenure > 65) why.push('the loan runs past age 65 (age ' + relevantAge + ' + ' + tenure + 'y = ' + (relevantAge + tenure) + ')');
      var whyTxt = why.length ? why.join(' and ') : 'tenure or age is past the MAS limit';
      return '<div class="rc-calc-pp__ltv-title">MAS reduced LTV applied: ' + from + '% &rarr; ' + to + '%</div>'
        + '<div><b>Why:</b> ' + whyTxt + '.</div>'
        + '<div><b>Effect:</b> your loan is capped at ' + to + '% of the price (' + fmtMoney(tdsr.ltv_cap) + '), and the minimum downpayment rises from ' + (100 - from) + '% to ' + (100 - to) + '%.</div>'
        + '<div class="rc-calc-pp__ltv-aside">The TDSR max loan above is an income test, not the penalty. The LTV drop is what cuts your loan.</div>';
    }

    function stageOutlayHtml(st) {
      var html = '<div class="rc-calc-pp__outlay-pct">' + st.pct + '%</div>';
      html += '<div class="rc-calc-pp__outlay-amt">' + fmtMoney(st.stage_amount) + '</div>';

      if (!st.is_bank_stage && st.loan_applied === 0 && st.monthly_payment == null) {
        // OTP / S&P — never bank-financed
        var oneOff = st.pct === 5
          ? tag('Cash only', 'cash')
          : (tag('CPF OA', 'cpf') + ' ' + tag('Cash', 'cash'));
        html += '<div class="rc-calc-pp__outlay-tags">' + oneOff + '</div>';
        return html;
      }

      var cpfCashTags = '';
      if (S.useCPF && st.is_bank_stage) {
        if (st.cpf_covers > 0) cpfCashTags += tag('Via CPF ' + fmtMoney(st.cpf_covers) + '/mo', 'cpf');
        if (st.cash_shortfall > 0) cpfCashTags += tag('Cash ' + fmtMoney(st.cash_shortfall) + '/mo', 'warn');
      }

      if (st.loan_applied >= st.stage_amount) {
        html += '<div class="rc-calc-pp__outlay-tags">' + tag('Bank Loan', 'bank') + cpfCashTags + '</div>';
      } else if (st.loan_applied === 0) {
        html += '<div class="rc-calc-pp__outlay-tags">' + tag('CPF OA', 'cpf') + tag('Cash', 'cash') + '</div>';
      } else {
        html += '<div class="rc-calc-pp__outlay-split"><b>' + fmtMoney(st.loan_applied) + '</b> via loan<br><b>' + fmtMoney(st.buyer_cash) + '</b> CPF / Cash</div>';
        html += '<div class="rc-calc-pp__outlay-tags">' + tag('Bank Loan', 'bank') + tag('CPF OA', 'cpf') + tag('Cash', 'cash') + '</div>';
      }
      return html;
    }

    function stageMonthlyHtml(st, fullMo) {
      if (st.monthly_payment == null || st.monthly_payment === 0) {
        return '<span class="rc-calc-pp__mo-unit">No loan drawn</span>';
      }
      var html = '<span class="rc-calc-pp__mo-figure">' + fmtMoney(st.monthly_payment) + '</span><span class="rc-calc-pp__mo-unit">/mo</span>';
      if (st.label === 'TOP') {
        html += '<div class="rc-calc-pp__mo-atcsc">At CSC: ' + fmtMoney(fullMo) + '/mo</div>';
      }
      if (S.useCPF) {
        if (st.cash_shortfall > 0) {
          html += '<div class="rc-calc-pp__mo-split">CPF ' + fmtMoney(st.cpf_covers) + '</div><div class="rc-calc-pp__mo-split rc-calc-pp__mo-split--warn">+ Cash ' + fmtMoney(st.cash_shortfall) + '</div>';
        } else if (st.cpf_covers > 0) {
          html += '<div class="rc-calc-pp__mo-split">CPF ' + fmtMoney(st.cpf_covers) + ' · Cash $0</div>';
        }
      }
      return html;
    }

    function renderOA(oa) {
      var box = el('rc-pp-oa');
      if (!oa || !oa.use_cpf) { box.innerHTML = ''; return; }
      var pct = function (x) { return (Math.round(x * 10000) / 100) + '%'; };
      var h = '<div class="rc-calc-pp__oa-title">CPF OA · how we get the monthly figure</div>';
      oa.rows.forEach(function (r) {
        var capNote = r.income > oa.ow_ceiling ? ' (capped at OW ceiling)' : '';
        h += '<div class="rc-calc-pp__oa-row"><span>Buyer ' + r.buyer + ' · age ' + r.age + ' · income ' + fmtMoney(r.income) + '</span><span class="rc-calc-pp__oa-amt">' + fmtMoney(r.oa_monthly) + '<small>/mo</small></span>'
          + '<div class="rc-calc-pp__oa-work">' + fmtMoney(r.capped) + capNote + ' × ' + pct(r.pct) + ' (' + r.band + ') = ' + fmtMoney(r.oa_monthly) + ' into OA</div></div>';
      });
      h += '<div class="rc-calc-pp__oa-hl">CPF OA into your account each month: <b>' + fmtMoney(oa.monthly_total) + '</b> · used against the loan</div>';
      h += '<table class="rc-calc-pp__oa-rates"><thead><tr><th>Age</th><th>Total CPF rate</th><th>OA share of wage</th><th>OA allocation ratio</th></tr></thead><tbody>';
      var lo = 0;
      oa.bands.forEach(function (b) {
        var you = oa.rows.some(function (r) { return r.age > lo && r.age <= b.max_age; });
        h += '<tr' + (you ? ' class="is-you"' : '') + '><td>' + b.label + '</td><td>' + pct(b.total_contribution_rate) + '</td><td>' + pct(b.oa_pct) + '</td><td>' + b.oa_allocation_ratio.toFixed(4) + '</td></tr>';
        lo = b.max_age;
      });
      h += '</tbody></table>';
      h += '<div class="rc-calc-pp__oa-src">OW ceiling ' + fmtMoney(oa.ow_ceiling) + ' from ' + oa.effective_from + ' · CPF Board contribution and allocation rates, Jan 2026 (via data.gov.sg) · OA share = total rate × allocation ratio</div>';
      box.innerHTML = h;
    }

    function render(data) {
      renderOA(data.cpf_oa);
      el('rc-pp-out-capital').textContent = fmtMoney(data.capital.total);
      el('rc-pp-out-booking').textContent = fmtMoney(data.capital.otp);
      el('rc-pp-out-loan-label').textContent = 'Loan ' + fmtMoney(data.loan_amount);
      el('rc-pp-out-sd').textContent = fmtMoney(data.capital.stamp_duty);
      el('rc-pp-out-sd-note').textContent = data.absd > 0
        ? ('BSD ' + fmtMoney(data.bsd) + ' + ABSD ' + fmtMoney(data.absd))
        : 'CPF OA or cash';

      if (data.tdsr) {
        el('rc-pp-tdsr-result').style.display = 'block';
        el('rc-pp-tdsr-ltv-cap').textContent = fmtMoney(data.tdsr.ltv_cap) + ' (' + data.tdsr.ltv_pct_used + '%)';
        el('rc-pp-tdsr-max').textContent = fmtMoney(data.tdsr.max_loan_tdsr);
        el('rc-pp-tdsr-pct').textContent = data.tdsr.tdsr_used_pct + '%';
        var noteEl = el('rc-pp-tdsr-note');
        if (data.tdsr.mas_triggered) {
          noteEl.className = 'rc-calc-pp__tdsr-note rc-calc-pp__ltv-callout';
          noteEl.innerHTML = ltvCalloutHtml(data.tdsr);
        } else {
          noteEl.className = 'rc-calc-pp__tdsr-note';
          noteEl.textContent = (data.tdsr.over_55 ? 'TDSR exceeds 55%, loan amount above MAS threshold.' : 'Within TDSR 55% and LTV limits.') + ' TDSR is tested at the MAS 4.0% stress rate, not the rate you selected.';
        }
        el('rc-pp-tdsr-binding').innerHTML = bindingNote(data.tdsr);
        el('rc-pp-tdsr-tenure-note').innerHTML = tenureNote(data.tdsr);
        var slider = el('rc-pp-loan-slider');
        slider.max = Math.max(data.tdsr.max_loan_tdsr, data.tdsr.ltv_cap, 10000);
        if (S.manualLoan == null) slider.value = data.loan_amount;
        el('rc-pp-loan-slider-val').textContent = fmtMoney(data.loan_amount);
      } else {
        el('rc-pp-tdsr-result').style.display = 'none';
      }

      var body = el('rc-pp-sched-body');
      body.innerHTML = '';
      data.schedule.forEach(function (st) {
        var tr = document.createElement('tr');
        var stageCell = '<div class="rc-calc-pp__stage-label">' + st.label + '</div><div class="rc-calc-pp__stage-timing">' + st.timing + '</div>';
        tr.innerHTML = '<td>' + stageCell + '</td>' +
          '<td>' + stageMonthlyHtml(st, data.full_monthly_at_completion) + '</td>' +
          '<td>' + stageOutlayHtml(st) + '</td>';
        body.appendChild(tr);
      });
      el('rc-pp-sched-footer').textContent = 'Full monthly payment once fully drawn: ' + fmtMoney(data.full_monthly_at_completion);
    }

    function fetchAndRender() {
      var badge = el('rc-pp-live-badge');
      if (badge) badge.textContent = 'Updating…';
      fetch(buildUrl())
        .then(function (r) { return r.json(); })
        .then(function (data) {
          render(data);
          if (badge) badge.textContent = 'Live · updates as you type';
        })
        .catch(function () {
          if (badge) badge.textContent = 'Live · updates as you type';
        });
    }

    function debounced() {
      clearTimeout(timer);
      timer = setTimeout(fetchAndRender, DEBOUNCE_MS);
    }

    // Price
    el('rc-pp-price').addEventListener('input', function () {
      var v = num('rc-pp-price');
      var r = el('rc-pp-price-range');
      if (v >= +r.min && v <= +r.max) r.value = v;
      debounced();
    });
    el('rc-pp-price-range').addEventListener('input', function () {
      el('rc-pp-price').value = fmt(+el('rc-pp-price-range').value);
      debounced();
    });
    // Lock the typed price into comma-formatted form once the user's done
    // typing, instead of leaving raw digits ("2344444") on screen forever.
    el('rc-pp-price').addEventListener('blur', function () {
      el('rc-pp-price').value = fmt(num('rc-pp-price'));
    });

    // LTV
    function setLtv(v) {
      S.baseLtv = v;
      el('rc-pp-ltv').value = v;
      el('rc-pp-ltv-range').value = v;
      document.querySelectorAll('.rc-calc-pp__preset[data-ltv]').forEach(function (a) {
        a.classList.toggle('rc-calc-pp__preset--active', +a.dataset.ltv === v);
      });
      debounced();
    }
    el('rc-pp-ltv').addEventListener('input', function () { setLtv(num('rc-pp-ltv')); });
    el('rc-pp-ltv-range').addEventListener('input', function () { setLtv(+el('rc-pp-ltv-range').value); });
    document.querySelectorAll('.rc-calc-pp__preset[data-ltv]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); setLtv(+a.dataset.ltv); });
    });

    // Rate (with presets) / tenure
    // Only the range/preset paths rewrite the text field's value — never do
    // that from the text input's own handler, or reformatting on every
    // keystroke (e.g. "3." -> "3") fights the user while they're typing.
    function syncRatePresets(v) {
      document.querySelectorAll('.rc-calc-pp__preset[data-rate]').forEach(function (a) {
        a.classList.toggle('rc-calc-pp__preset--active', Math.abs(+a.dataset.rate - v) < 0.01);
      });
    }
    function setRate(v) {
      el('rc-pp-rate').value = v;
      el('rc-pp-rate-range').value = v;
      syncRatePresets(v);
      debounced();
    }
    el('rc-pp-rate').addEventListener('input', function () {
      var v = num('rc-pp-rate');
      el('rc-pp-rate-range').value = v;
      syncRatePresets(v);
      debounced();
    });
    el('rc-pp-rate-range').addEventListener('input', function () { setRate(+el('rc-pp-rate-range').value); });
    document.querySelectorAll('.rc-calc-pp__preset[data-rate]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); setRate(+a.dataset.rate); });
    });

    el('rc-pp-tenure').addEventListener('input', function () { el('rc-pp-tenure-range').value = num('rc-pp-tenure'); debounced(); });
    el('rc-pp-tenure-range').addEventListener('input', function () { el('rc-pp-tenure').value = el('rc-pp-tenure-range').value; debounced(); });

    // Loan estimate toggle
    el('rc-pp-loanest-no').addEventListener('click', function () {
      S.loanEst = false; S.manualLoan = null;
      el('rc-pp-loanest-no').classList.add('rc-calc-pp__seg-btn--active');
      el('rc-pp-loanest-yes').classList.remove('rc-calc-pp__seg-btn--active');
      el('rc-pp-loanest-body').style.display = 'none';
      debounced();
    });
    el('rc-pp-loanest-yes').addEventListener('click', function () {
      S.loanEst = true; S.manualLoan = null;
      el('rc-pp-loanest-yes').classList.add('rc-calc-pp__seg-btn--active');
      el('rc-pp-loanest-no').classList.remove('rc-calc-pp__seg-btn--active');
      el('rc-pp-loanest-body').style.display = 'block';
      debounced();
    });

    el('rc-pp-buyers-1').addEventListener('click', function () {
      S.buyers = 1;
      el('rc-pp-buyers-1').classList.add('rc-calc-pp__seg-btn--active');
      el('rc-pp-buyers-2').classList.remove('rc-calc-pp__seg-btn--active');
      el('rc-pp-buyer2-block').style.display = 'none';
      debounced();
    });
    el('rc-pp-buyers-2').addEventListener('click', function () {
      S.buyers = 2;
      el('rc-pp-buyers-2').classList.add('rc-calc-pp__seg-btn--active');
      el('rc-pp-buyers-1').classList.remove('rc-calc-pp__seg-btn--active');
      el('rc-pp-buyer2-block').style.display = 'block';
      debounced();
    });

    ['rc-pp-b1-age', 'rc-pp-b1-income', 'rc-pp-b2-age', 'rc-pp-b2-income'].forEach(function (id) {
      el(id).addEventListener('input', debounced);
    });

    el('rc-pp-loan-slider').addEventListener('input', function () {
      S.manualLoan = +el('rc-pp-loan-slider').value;
      el('rc-pp-loan-slider-val').textContent = fmtMoney(S.manualLoan);
      debounced();
    });

    el('rc-pp-cpf-no').addEventListener('click', function () {
      S.useCPF = false;
      el('rc-pp-cpf-no').classList.add('rc-calc-pp__seg-btn--active');
      el('rc-pp-cpf-yes').classList.remove('rc-calc-pp__seg-btn--active');
      debounced();
    });
    el('rc-pp-cpf-yes').addEventListener('click', function () {
      S.useCPF = true;
      el('rc-pp-cpf-yes').classList.add('rc-calc-pp__seg-btn--active');
      el('rc-pp-cpf-no').classList.remove('rc-calc-pp__seg-btn--active');
      debounced();
    });

    // Stamp duty toggle
    el('rc-pp-sd-no').addEventListener('click', function () {
      S.sdActive = false;
      el('rc-pp-sd-no').classList.add('rc-calc-pp__seg-btn--active');
      el('rc-pp-sd-yes').classList.remove('rc-calc-pp__seg-btn--active');
      el('rc-pp-sd-body').style.display = 'none';
      debounced();
    });
    el('rc-pp-sd-yes').addEventListener('click', function () {
      S.sdActive = true;
      el('rc-pp-sd-yes').classList.add('rc-calc-pp__seg-btn--active');
      el('rc-pp-sd-no').classList.remove('rc-calc-pp__seg-btn--active');
      el('rc-pp-sd-body').style.display = 'block';
      debounced();
    });
    el('rc-pp-sd-status').addEventListener('change', function () {
      el('rc-pp-sd-residency2-wrap').style.display = el('rc-pp-sd-status').value === 'joint' ? 'block' : 'none';
      debounced();
    });
    el('rc-pp-sd-residency1').addEventListener('change', debounced);
    el('rc-pp-sd-residency2').addEventListener('change', debounced);
    el('rc-pp-sd-propcount').addEventListener('change', debounced);

    fetchAndRender();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculator-progressive-payment"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* Shopify bundles every section's {% javascript %} into one shared
       <script> tag site-wide — if this section isn't on the current page,
       every el(id) below would be null and throw, killing every OTHER
       section's JS later in that same bundle. Bail out immediately. */
    if (!document.getElementById('rc-pp-price')) return;

    var ENDPOINT = 'https://api.roncasa.co/calc/progressive-payment';
    var DEBOUNCE_MS = 300;
    var timer = null;

    var S = { loanEst: false, buyers: 1, useCPF: false, sdActive: false, manualLoan: null, baseLtv: 75 };

    function el(id) { return document.getElementById(id); }
    function fmt(n) { return Math.round(n || 0).toLocaleString('en-SG'); }
    function fmtMoney(n) { return '$' + fmt(n); }
    function num(id) {
      var e = el(id);
      if (!e) return 0;
      return parseFloat((e.value || '').replace(/[^\d.]/g, '')) || 0;
    }

    function buildUrl() {
      var p = new URLSearchParams();
      p.set('price', num('rc-pp-price'));
      p.set('rate', num('rc-pp-rate'));
      p.set('tenure', num('rc-pp-tenure'));
      p.set('ltv', S.baseLtv);
      p.set('loan_est', S.loanEst ? 'true' : 'false');
      if (S.loanEst) {
        p.set('buyers', S.buyers);
        p.set('b1_age', num('rc-pp-b1-age'));
        p.set('b1_income', num('rc-pp-b1-income'));
        if (S.buyers === 2) {
          p.set('b2_age', num('rc-pp-b2-age'));
          p.set('b2_income', num('rc-pp-b2-income'));
        }
        if (S.manualLoan != null) p.set('manual_loan', S.manualLoan);
      }
      p.set('use_cpf', S.useCPF ? 'true' : 'false');
      p.set('sd_active', S.sdActive ? 'true' : 'false');
      if (S.sdActive) {
        p.set('sd_status', el('rc-pp-sd-status').value);
        p.set('sd_residency1', el('rc-pp-sd-residency1').value);
        p.set('sd_residency2', el('rc-pp-sd-residency2').value);
        p.set('sd_prop_count', el('rc-pp-sd-propcount').value);
      }
      return ENDPOINT + '?' + p.toString();
    }

    function renderOA(oa) {
      var box = el('rc-pp-oa');
      if (!oa || !oa.use_cpf) { box.innerHTML = ''; return; }
      var pct = function (x) { return (Math.round(x * 10000) / 100) + '%'; };
      var h = '<div class="rc-calc-pp__oa-title">CPF OA · how we get the monthly figure</div>';
      oa.rows.forEach(function (r) {
        var capNote = r.income > oa.ow_ceiling ? ' (capped at OW ceiling)' : '';
        h += '<div class="rc-calc-pp__oa-row"><span>Buyer ' + r.buyer + ' · age ' + r.age + ' · income ' + fmtMoney(r.income) + '</span><span class="rc-calc-pp__oa-amt">' + fmtMoney(r.oa_monthly) + '<small>/mo</small></span>'
          + '<div class="rc-calc-pp__oa-work">' + fmtMoney(r.capped) + capNote + ' × ' + pct(r.pct) + ' (' + r.band + ') = ' + fmtMoney(r.oa_monthly) + ' into OA</div></div>';
      });
      h += '<div class="rc-calc-pp__oa-hl">CPF OA into your account each month: <b>' + fmtMoney(oa.monthly_total) + '</b> · used against the loan</div>';
      h += '<table class="rc-calc-pp__oa-rates"><thead><tr><th>Age</th><th>Total CPF rate</th><th>OA share of wage</th><th>OA allocation ratio</th></tr></thead><tbody>';
      var lo = 0;
      oa.bands.forEach(function (b) {
        var you = oa.rows.some(function (r) { return r.age > lo && r.age <= b.max_age; });
        h += '<tr' + (you ? ' class="is-you"' : '') + '><td>' + b.label + '</td><td>' + pct(b.total_contribution_rate) + '</td><td>' + pct(b.oa_pct) + '</td><td>' + b.oa_allocation_ratio.toFixed(4) + '</td></tr>';
        lo = b.max_age;
      });
      h += '</tbody></table>';
      h += '<div class="rc-calc-pp__oa-src">OW ceiling ' + fmtMoney(oa.ow_ceiling) + ' from ' + oa.effective_from + ' · CPF Board contribution and allocation rates, Jan 2026 (via data.gov.sg) · OA share = total rate × allocation ratio</div>';
      box.innerHTML = h;
    }

    function render(data) {
      renderOA(data.cpf_oa);
      el('rc-pp-out-capital').textContent = fmtMoney(data.capital.total);
      el('rc-pp-out-booking').textContent = fmtMoney(data.capital.otp);
      el('rc-pp-out-loan-label').textContent = 'Loan ' + fmtMoney(data.loan_amount);
      el('rc-pp-out-sd').textContent = fmtMoney(data.capital.stamp_duty);

      if (data.tdsr) {
        el('rc-pp-tdsr-result').style.display = 'block';
        el('rc-pp-tdsr-ltv-cap').textContent = fmtMoney(data.tdsr.ltv_cap) + ' (' + data.tdsr.ltv_pct_used + '%)';
        el('rc-pp-tdsr-max').textContent = fmtMoney(data.tdsr.max_loan_tdsr);
        el('rc-pp-tdsr-pct').textContent = data.tdsr.tdsr_used_pct + '%';
        el('rc-pp-tdsr-note').textContent = data.tdsr.mas_triggered
          ? 'MAS LTV reduction applied. Tenure or age+tenure exceeds the cap.'
          : (data.tdsr.over_55 ? 'TDSR exceeds 55%, loan amount above MAS threshold.' : 'Within TDSR 55% and LTV limits.') + ' TDSR is tested at the MAS 4.0% stress rate, not the rate you selected.';
        var slider = el('rc-pp-loan-slider');
        slider.max = Math.max(data.tdsr.max_loan_tdsr, data.tdsr.ltv_cap, 10000);
        if (S.manualLoan == null) slider.value = data.loan_amount;
        el('rc-pp-loan-slider-val').textContent = fmtMoney(data.loan_amount);
      } else {
        el('rc-pp-tdsr-result').style.display = 'none';
      }

      var body = el('rc-pp-sched-body');
      body.innerHTML = '';
      data.schedule.forEach(function (st) {
        var tr = document.createElement('tr');
        var moCell = st.monthly_payment != null ? fmtMoney(st.monthly_payment) : '—';
        // "Use CPF OA" was previously a no-op here — the Worker already
        // returns cpf_covers/cash_shortfall per stage, this just stopped
        // discarding it.
        if (st.monthly_payment != null && S.useCPF) {
          if (st.cash_shortfall > 0) {
            moCell += '<div class="rc-calc-pp__mo-split">CPF ' + fmtMoney(st.cpf_covers) + '</div><div class="rc-calc-pp__mo-split rc-calc-pp__mo-split--warn">+ Cash ' + fmtMoney(st.cash_shortfall) + '</div>';
          } else if (st.cpf_covers > 0) {
            moCell += '<div class="rc-calc-pp__mo-split">CPF ' + fmtMoney(st.cpf_covers) + ' · Cash $0</div>';
          }
        }
        tr.innerHTML = '<td>' + st.label + ' <span style="opacity:.5">· ' + st.pct + '%</span></td>' +
          '<td>' + moCell + '</td>' +
          '<td>' + fmtMoney(st.stage_amount) + '</td>';
        body.appendChild(tr);
      });
      el('rc-pp-sched-footer').textContent = 'Full monthly payment once fully drawn: ' + fmtMoney(data.full_monthly_at_completion);
    }

    function fetchAndRender() {
      var badge = el('rc-pp-live-badge');
      if (badge) badge.textContent = 'Updating…';
      fetch(buildUrl())
        .then(function (r) { return r.json(); })
        .then(function (data) {
          render(data);
          if (badge) badge.textContent = 'Live · updates as you type';
        })
        .catch(function () {
          if (badge) badge.textContent = 'Live · updates as you type';
        });
    }

    function debounced() {
      clearTimeout(timer);
      timer = setTimeout(fetchAndRender, DEBOUNCE_MS);
    }

    // Price
    el('rc-pp-price').addEventListener('input', function () {
      var v = num('rc-pp-price');
      var r = el('rc-pp-price-range');
      if (v >= +r.min && v <= +r.max) r.value = v;
      debounced();
    });
    el('rc-pp-price-range').addEventListener('input', function () {
      el('rc-pp-price').value = fmt(+el('rc-pp-price-range').value);
      debounced();
    });
    // Lock the typed price into comma-formatted form once the user's done
    // typing, instead of leaving raw digits ("2344444") on screen forever.
    el('rc-pp-price').addEventListener('blur', function () {
      el('rc-pp-price').value = fmt(num('rc-pp-price'));
    });

    // LTV
    function setLtv(v) {
      S.baseLtv = v;
      el('rc-pp-ltv').value = v;
      el('rc-pp-ltv-range').value = v;
      document.querySelectorAll('.rc-calc-pp__preset[data-ltv]').forEach(function (a) {
        a.classList.toggle('rc-calc-pp__preset--active', +a.dataset.ltv === v);
      });
      debounced();
    }
    el('rc-pp-ltv').addEventListener('input', function () { setLtv(num('rc-pp-ltv')); });
    el('rc-pp-ltv-range').addEventListener('input', function () { setLtv(+el('rc-pp-ltv-range').value); });
    document.querySelectorAll('.rc-calc-pp__preset[data-ltv]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); setLtv(+a.dataset.ltv); });
    });

    // Rate / tenure
    el('rc-pp-rate').addEventListener('input', function () { el('rc-pp-rate-range').value = num('rc-pp-rate'); debounced(); });
    el('rc-pp-rate-range').addEventListener('input', function () { el('rc-pp-rate').value = el('rc-pp-rate-range').value; debounced(); });
    el('rc-pp-tenure').addEventListener('input', function () { el('rc-pp-tenure-range').value = num('rc-pp-tenure'); debounced(); });
    el('rc-pp-tenure-range').addEventListener('input', function () { el('rc-pp-tenure').value = el('rc-pp-tenure-range').value; debounced(); });

    // Loan estimate toggle
    el('rc-pp-loanest-no').addEventListener('click', function () {
      S.loanEst = false; S.manualLoan = null;
      el('rc-pp-loanest-no').classList.add('rc-calc-pp__seg-btn--active');
      el('rc-pp-loanest-yes').classList.remove('rc-calc-pp__seg-btn--active');
      el('rc-pp-loanest-body').style.display = 'none';
      debounced();
    });
    el('rc-pp-loanest-yes').addEventListener('click', function () {
      S.loanEst = true; S.manualLoan = null;
      el('rc-pp-loanest-yes').classList.add('rc-calc-pp__seg-btn--active');
      el('rc-pp-loanest-no').classList.remove('rc-calc-pp__seg-btn--active');
      el('rc-pp-loanest-body').style.display = 'block';
      debounced();
    });

    el('rc-pp-buyers-1').addEventListener('click', function () {
      S.buyers = 1;
      el('rc-pp-buyers-1').classList.add('rc-calc-pp__seg-btn--active');
      el('rc-pp-buyers-2').classList.remove('rc-calc-pp__seg-btn--active');
      el('rc-pp-buyer2-block').style.display = 'none';
      debounced();
    });
    el('rc-pp-buyers-2').addEventListener('click', function () {
      S.buyers = 2;
      el('rc-pp-buyers-2').classList.add('rc-calc-pp__seg-btn--active');
      el('rc-pp-buyers-1').classList.remove('rc-calc-pp__seg-btn--active');
      el('rc-pp-buyer2-block').style.display = 'block';
      debounced();
    });

    ['rc-pp-b1-age', 'rc-pp-b1-income', 'rc-pp-b2-age', 'rc-pp-b2-income'].forEach(function (id) {
      el(id).addEventListener('input', debounced);
    });

    el('rc-pp-loan-slider').addEventListener('input', function () {
      S.manualLoan = +el('rc-pp-loan-slider').value;
      el('rc-pp-loan-slider-val').textContent = fmtMoney(S.manualLoan);
      debounced();
    });

    el('rc-pp-cpf-no').addEventListener('click', function () {
      S.useCPF = false;
      el('rc-pp-cpf-no').classList.add('rc-calc-pp__seg-btn--active');
      el('rc-pp-cpf-yes').classList.remove('rc-calc-pp__seg-btn--active');
      debounced();
    });
    el('rc-pp-cpf-yes').addEventListener('click', function () {
      S.useCPF = true;
      el('rc-pp-cpf-yes').classList.add('rc-calc-pp__seg-btn--active');
      el('rc-pp-cpf-no').classList.remove('rc-calc-pp__seg-btn--active');
      debounced();
    });

    // Stamp duty toggle
    el('rc-pp-sd-no').addEventListener('click', function () {
      S.sdActive = false;
      el('rc-pp-sd-no').classList.add('rc-calc-pp__seg-btn--active');
      el('rc-pp-sd-yes').classList.remove('rc-calc-pp__seg-btn--active');
      el('rc-pp-sd-body').style.display = 'none';
      debounced();
    });
    el('rc-pp-sd-yes').addEventListener('click', function () {
      S.sdActive = true;
      el('rc-pp-sd-yes').classList.add('rc-calc-pp__seg-btn--active');
      el('rc-pp-sd-no').classList.remove('rc-calc-pp__seg-btn--active');
      el('rc-pp-sd-body').style.display = 'block';
      debounced();
    });
    el('rc-pp-sd-status').addEventListener('change', function () {
      el('rc-pp-sd-residency2-wrap').style.display = el('rc-pp-sd-status').value === 'joint' ? 'block' : 'none';
      debounced();
    });
    el('rc-pp-sd-residency1').addEventListener('change', debounced);
    el('rc-pp-sd-residency2').addEventListener('change', debounced);
    el('rc-pp-sd-propcount').addEventListener('change', debounced);

    fetchAndRender();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculator-sellers-proceeds"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* Shopify bundles every section's {% javascript %} into one shared
       <script> tag site-wide — if this section isn't on the current page,
       every el(id) below would be null and throw, killing every OTHER
       section's JS later in that same bundle. Bail out immediately. */
    if (!document.getElementById('rc-sp-price')) return;

    var ENDPOINT = 'https://api.roncasa.co/calc/sellers-proceeds';
    var DEBOUNCE_MS = 300;
    var timer = null;

    var S = { propertyType: 'hdb', owners: 1, levy: false, levyDate: 'after', grant: 'household' };

    function el(id) { return document.getElementById(id); }
    function fmt(n) { return Math.round(Math.abs(n || 0)).toLocaleString('en-SG'); }
    function fmtM(n) { return '$' + fmt(n); }
    function fmtD(n) { return (n || 0) === 0 ? '$0' : '−$' + fmt(n); }
    function num(id) {
      var e = el(id);
      if (!e) return 0;
      return parseFloat((e.value || '').replace(/[^\d.]/g, '')) || 0;
    }
    function setTxt(id, v) { var e = el(id); if (e) e.textContent = v; }

    function buildUrl() {
      var p = new URLSearchParams();
      p.set('property_type', S.propertyType);
      p.set('price', num('rc-sp-price'));
      p.set('loan', num('rc-sp-loan'));
      p.set('legal', num('rc-sp-legal'));
      p.set('ext', num('rc-sp-ext'));
      p.set('owners', S.owners);
      if (S.owners === 1) {
        p.set('cpf_p1', num('rc-sp-cpf-p1'));
        p.set('cpf_i1', num('rc-sp-cpf-i1'));
      } else {
        p.set('o1_p', num('rc-sp-o1-p'));
        p.set('o1_i', num('rc-sp-o1-i'));
        p.set('o2_p', num('rc-sp-o2-p'));
        p.set('o2_i', num('rc-sp-o2-i'));
      }
      if (S.propertyType === 'hdb') {
        p.set('app_fee', el('rc-sp-app-fee').value);
        p.set('levy', S.levy ? 'true' : 'false');
        if (S.levy) {
          p.set('grant', S.grant);
          p.set('levy_date', S.levyDate);
          p.set('fixed_type', el('rc-sp-fixed-type').value);
          p.set('var_type', el('rc-sp-var-type').value);
        }
      }
      return ENDPOINT + '?' + p.toString();
    }

    function render(data) {
      var isHDB = S.propertyType === 'hdb';

      if (S.owners === 1) {
        setTxt('rc-sp-cpf-total-1', fmtM(data.cpf.total));
      } else {
        setTxt('rc-sp-cpf-total-2', fmtM(data.cpf.total));
      }

      setTxt('rc-sp-prof-fee', fmtM(data.professional_fee));

      el('rc-sp-warn').classList.toggle('is-shown', !!data.pre_costs_negative);

      setTxt('rc-sp-net-pre', data.negative ? '−$' : '$');
      setTxt('rc-sp-net', fmt(data.net_proceeds));

      setTxt('rc-sp-cpf-proceeds-val', fmtM(data.cpf.total));
      setTxt('rc-sp-cpf-proceeds-lab', S.owners === 1
        ? 'CPF proceeds · principal + accrued interest'
        : 'CPF proceeds · both owners · principal + accrued interest');

      setTxt('rc-sp-wf-price', fmtM(data.inputs.price));
      setTxt('rc-sp-wf-loan', fmtD(data.inputs.loan));

      if (S.owners === 1) {
        setTxt('rc-sp-wf-cpf-p', fmtD(data.cpf.principal));
        setTxt('rc-sp-wf-cpf-i', fmtD(data.cpf.interest));
      } else {
        setTxt('rc-sp-wf-o1', fmtD(data.cpf.owner_1.total));
        setTxt('rc-sp-wf-o2', fmtD(data.cpf.owner_2.total));
      }

      var rowLevy = el('rc-sp-row-levy');
      rowLevy.style.display = (isHDB && data.levy.enabled) ? 'flex' : 'none';
      setTxt('rc-sp-wf-levy-lab', 'Less — resale levy' + (data.levy.label && data.levy.label !== 'None' ? ' · ' + data.levy.label : ''));
      setTxt('rc-sp-wf-levy', fmtD(data.levy.amount));

      setTxt('rc-sp-wf-subtotal', (data.pre_costs_negative ? '−$' : '$') + fmt(data.cash_pre_costs));

      setTxt('rc-sp-wf-legal', fmtD(data.inputs.legal));
      setTxt('rc-sp-wf-prof', fmtD(data.professional_fee));
      setTxt('rc-sp-wf-app', fmtD(data.inputs.app_fee));
      setTxt('rc-sp-wf-ext', fmtD(data.inputs.ext));

      setTxt('rc-sp-wf-net', (data.negative ? '−$' : '$') + fmt(data.net_proceeds));
    }

    function fetchAndRender() {
      var badge = el('rc-sp-live-badge');
      if (badge) badge.textContent = 'Updating…';
      fetch(buildUrl())
        .then(function (r) { return r.json(); })
        .then(function (data) {
          render(data);
          if (badge) badge.textContent = 'Live · updates as you type';
        })
        .catch(function () {
          if (badge) badge.textContent = 'Live · updates as you type';
        });
    }

    function debounced() {
      clearTimeout(timer);
      timer = setTimeout(fetchAndRender, DEBOUNCE_MS);
    }

    function setPropertyType(t) {
      S.propertyType = t;
      var isHDB = t === 'hdb';
      el('rc-sp-pt-hdb').classList.toggle('rc-calc-sp__pill--active', isHDB);
      el('rc-sp-pt-private').classList.toggle('rc-calc-sp__pill--active', !isHDB);
      el('rc-sp-levy-step').style.display = isHDB ? 'block' : 'none';
      el('rc-sp-levy-field').style.display = isHDB ? 'block' : 'none';
      el('rc-sp-app-fee-field').style.display = isHDB ? 'block' : 'none';
      var legalEl = el('rc-sp-legal');
      legalEl.value = isHDB ? '1500' : '3000';
      setTxt('rc-sp-legal-note', isHDB
        ? '$1,500 set aside: typically more than enough for HDB conveyancing.'
        : '$3,000 set aside: typical conveyancing range for private property resale.');
      setTxt('rc-sp-disclaimer', isHDB
        ? 'Estimate only. Actual figures vary, confirm with your conveyancing lawyer and HDB.'
        : 'Estimate only. Actual figures vary, confirm with your conveyancing lawyer. Private sales are not subject to HDB resale levy or application fee.');
      debounced();
    }

    function setOwners(n) {
      S.owners = n;
      el('rc-sp-own-1').classList.toggle('rc-calc-sp__pill--active', n === 1);
      el('rc-sp-own-2').classList.toggle('rc-calc-sp__pill--active', n === 2);
      el('rc-sp-cpf1').style.display = n === 1 ? 'block' : 'none';
      el('rc-sp-cpf2').style.display = n === 2 ? 'block' : 'none';
      el('rc-sp-wf-cpf1').style.display = n === 1 ? 'block' : 'none';
      el('rc-sp-wf-cpf2').style.display = n === 2 ? 'block' : 'none';
      debounced();
    }

    function setLevy(on) {
      S.levy = on;
      el('rc-sp-levy-no').classList.toggle('rc-calc-sp__pill--active', !on);
      el('rc-sp-levy-yes').classList.toggle('rc-calc-sp__pill--active', on);
      el('rc-sp-levy-fields').classList.toggle('is-open', on);
      debounced();
    }

    function setLevyDate(d) {
      S.levyDate = d;
      el('rc-sp-lv-after').classList.toggle('rc-calc-sp__pill--active', d === 'after');
      el('rc-sp-lv-before').classList.toggle('rc-calc-sp__pill--active', d === 'before');
      el('rc-sp-fixed-field').style.display = d === 'after' ? 'block' : 'none';
      el('rc-sp-var-field').style.display = d === 'before' ? 'block' : 'none';
      debounced();
    }

    function setGrant(g) {
      S.grant = g;
      el('rc-sp-gr-hh').classList.toggle('rc-calc-sp__pill--active', g === 'household');
      el('rc-sp-gr-s').classList.toggle('rc-calc-sp__pill--active', g === 'singles');
      debounced();
    }

    el('rc-sp-pt-hdb').addEventListener('click', function () { setPropertyType('hdb'); });
    el('rc-sp-pt-private').addEventListener('click', function () { setPropertyType('private'); });
    el('rc-sp-own-1').addEventListener('click', function () { setOwners(1); });
    el('rc-sp-own-2').addEventListener('click', function () { setOwners(2); });
    el('rc-sp-levy-no').addEventListener('click', function () { setLevy(false); });
    el('rc-sp-levy-yes').addEventListener('click', function () { setLevy(true); });
    el('rc-sp-lv-after').addEventListener('click', function () { setLevyDate('after'); });
    el('rc-sp-lv-before').addEventListener('click', function () { setLevyDate('before'); });
    el('rc-sp-gr-hh').addEventListener('click', function () { setGrant('household'); });
    el('rc-sp-gr-s').addEventListener('click', function () { setGrant('singles'); });
    el('rc-sp-fixed-type').addEventListener('change', debounced);
    el('rc-sp-var-type').addEventListener('change', debounced);
    el('rc-sp-app-fee').addEventListener('change', debounced);

    ['rc-sp-price', 'rc-sp-loan', 'rc-sp-cpf-p1', 'rc-sp-cpf-i1', 'rc-sp-o1-p', 'rc-sp-o1-i', 'rc-sp-o2-p', 'rc-sp-o2-i', 'rc-sp-legal', 'rc-sp-ext'].forEach(function (id) {
      var e = el(id);
      if (e) e.addEventListener('input', debounced);
    });

    fetchAndRender();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculator-stamp-duty"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* Shopify bundles every section's {% javascript %} into one shared
       <script> tag site-wide — if this section isn't on the current page,
       every el(id) below would be null and throw, killing every OTHER
       section's JS later in that same bundle. Bail out immediately. */
    if (!document.getElementById('rc-sd-price')) return;

    var ENDPOINT = 'https://api.roncasa.co/calc/stamp-duty';
    var DEBOUNCE_MS = 300;
    var timer = null;

    var S = { propertyType: 'residential', status: 'individual', propCount: 1 };

    function el(id) { return document.getElementById(id); }
    function fmt(n) { return Math.round(n || 0).toLocaleString('en-SG'); }
    function fmtMoney(n) { return 'S$' + fmt(n); }
    function num(id) {
      var e = el(id);
      if (!e) return 0;
      return parseFloat((e.value || '').replace(/[^\d.]/g, '')) || 0;
    }

    function buildUrl() {
      var p = new URLSearchParams();
      p.set('price', num('rc-sd-price'));
      p.set('property_type', S.propertyType);
      p.set('status', S.status);
      p.set('residency1', el('rc-sd-residency1').value);
      p.set('residency2', el('rc-sd-residency2').value);
      p.set('prop_count', S.propCount);
      return ENDPOINT + '?' + p.toString();
    }

    function nthLabel(n) {
      if (n === 1) return '1st property';
      if (n === 2) return '2nd property';
      return n + (n === 3 ? 'rd' : 'th') + '+ property';
    }
    function residencyLabel(v) {
      return { citizen: 'Singapore Citizen', pr: 'Permanent Resident', foreigner: 'Foreigner', entity: 'Entity / Company' }[v] || v;
    }

    function render(data) {
      el('rc-sd-total').textContent = fmt(data.total);
      el('rc-sd-total-2').textContent = fmtMoney(data.total);
      el('rc-sd-bsd').textContent = fmtMoney(data.bsd);
      el('rc-sd-absd').textContent = fmtMoney(data.absd);
      el('rc-sd-absd-note').textContent = Math.round(data.absd_rate_pct) + '% · ' + residencyLabel(data.absd_residency_used) + ', ' + nthLabel(S.propCount);
    }

    function fetchAndRender() {
      var badge = el('rc-sd-live-badge');
      if (badge) badge.textContent = 'Updating…';
      fetch(buildUrl())
        .then(function (r) { return r.json(); })
        .then(function (data) {
          render(data);
          if (badge) badge.textContent = 'Live · updates as you type';
        })
        .catch(function () {
          if (badge) badge.textContent = 'Live · updates as you type';
        });
    }

    function debounced() {
      clearTimeout(timer);
      timer = setTimeout(fetchAndRender, DEBOUNCE_MS);
    }

    el('rc-sd-price').addEventListener('input', function () {
      var v = num('rc-sd-price');
      var range = el('rc-sd-price-range');
      if (v >= +range.min && v <= +range.max) range.value = v;
      debounced();
    });
    el('rc-sd-price').addEventListener('blur', function () { el('rc-sd-price').value = fmt(num('rc-sd-price')); });
    el('rc-sd-price-range').addEventListener('input', function () {
      el('rc-sd-price').value = fmt(+el('rc-sd-price-range').value);
      debounced();
    });

    el('rc-sd-pt-res').addEventListener('click', function () {
      S.propertyType = 'residential';
      el('rc-sd-pt-res').classList.add('rc-calc-sd__seg-btn--active');
      el('rc-sd-pt-nonres').classList.remove('rc-calc-sd__seg-btn--active');
      debounced();
    });
    el('rc-sd-pt-nonres').addEventListener('click', function () {
      S.propertyType = 'non-residential';
      el('rc-sd-pt-nonres').classList.add('rc-calc-sd__seg-btn--active');
      el('rc-sd-pt-res').classList.remove('rc-calc-sd__seg-btn--active');
      debounced();
    });

    el('rc-sd-status-single').addEventListener('click', function () {
      S.status = 'individual';
      el('rc-sd-status-single').classList.add('rc-calc-sd__seg-btn--active');
      el('rc-sd-status-joint').classList.remove('rc-calc-sd__seg-btn--active');
      el('rc-sd-residency2-wrap').style.display = 'none';
      debounced();
    });
    el('rc-sd-status-joint').addEventListener('click', function () {
      S.status = 'joint';
      el('rc-sd-status-joint').classList.add('rc-calc-sd__seg-btn--active');
      el('rc-sd-status-single').classList.remove('rc-calc-sd__seg-btn--active');
      el('rc-sd-residency2-wrap').style.display = 'block';
      debounced();
    });

    el('rc-sd-residency1').addEventListener('change', debounced);
    el('rc-sd-residency2').addEventListener('change', debounced);

    el('rc-sd-prop-minus').addEventListener('click', function () {
      S.propCount = Math.max(1, S.propCount - 1);
      el('rc-sd-prop-count-val').textContent = S.propCount;
      debounced();
    });
    el('rc-sd-prop-plus').addEventListener('click', function () {
      S.propCount = Math.min(6, S.propCount + 1);
      el('rc-sd-prop-count-val').textContent = S.propCount;
      debounced();
    });

    fetchAndRender();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flowchart-ec-eligibility"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* Shopify bundles every section's {% javascript %} into one shared
       <script> tag site-wide — if this section isn't on the current page,
       every el(id) below would be null and throw, killing every OTHER
       section's JS later in that same bundle. Bail out immediately. */
    if (!document.getElementById('rc-ec-q-text')) return;

    /* EC income ceiling reads live from the Policy Registry (/calc/policy →
       income_ceiling.ec_current) instead of a typed-in number, so it never goes
       stale when HDB moves it. 16000 is only the offline fallback snapshot. */
    var EC_CEILING = 16000;
    function fmtSGD(n) { return '$' + Math.round(n).toLocaleString('en-SG'); }
    var CEIL_TPL = {
      q: 'Does your household income meet the ceiling ({c}/month)?',
      body: 'New EC purchases are capped at a {c} household income ceiling. A resale EC past its MOP has no such cap.'
    };

    var TREE = {
      start: 'start',
      nodes: {
        start: { q: "Are you buying a <em>new</em> EC or a <em>resale</em> EC?", options: [
          { label: 'New EC (from developer)', to: 'new1' },
          { label: 'Resale EC', to: 'resale1' } ] },
        new1: { q: CEIL_TPL.q.replace('{c}', fmtSGD(EC_CEILING)), options: [
          { label: 'Yes', to: 'new2' }, { label: 'No', to: 'r_new_income_fail' } ] },
        new2: { q: 'Do you have an eligible family nucleus (spouse/fiancé, or a citizen single aged 35+)?', options: [
          { label: 'Yes', to: 'new3' }, { label: 'No', to: 'r_new_nucleus_fail' } ] },
        new3: { q: 'Have you or your spouse owned or disposed of a private property in the last 30 months?', options: [
          { label: 'Yes', to: 'r_new_dispose' }, { label: 'No', to: 'new4' } ] },
        new4: { q: "Is this the first time you're applying for a housing subsidy?", options: [
          { label: 'Yes — first-timer', to: 'r_new_firsttimer' }, { label: 'No — second-timer', to: 'r_new_secondtimer' } ] },
        resale1: { q: 'Has the EC reached its Minimum Occupation Period (5 years from TOP)?', options: [
          { label: 'Yes', to: 'resale2' }, { label: 'No', to: 'r_resale_mop' } ] },
        resale2: { q: "Was the project's EC land tender (GLS) awarded before 8 May 2026?", options: [
          { label: 'Yes — older rules', to: 'resale_old' }, { label: 'No — new rules', to: 'resale_new' } ] },
        resale_old: { q: 'Has it been at least 10 years since TOP (full privatisation)?', options: [
          { label: 'Yes', to: 'r_resale_open_old' }, { label: 'No', to: 'r_resale_citizen_old' } ] },
        resale_new: { q: 'Has it been at least 15 years since TOP (full privatisation)?', options: [
          { label: 'Yes', to: 'r_resale_open_new' }, { label: 'No', to: 'r_resale_citizen_new' } ] }
      },
      results: {
        r_new_income_fail:     { tag: 'Not eligible', style: 'solid', title: "You're <em>above</em> the income ceiling", body: CEIL_TPL.body.replace('{c}', fmtSGD(EC_CEILING)) },
        r_new_nucleus_fail:    { tag: 'Not eligible', style: 'solid', title: "You need an eligible <em>family nucleus</em>", body: "New ECs require a spouse/fiancé nucleus, or a single citizen aged 35 and above applying under the Single Singapore Citizen Scheme." },
        r_new_dispose:         { tag: 'Wait & reapply', style: 'dashed', title: 'Clear your <em>30-month</em> wait first', body: "Owning or disposing of private property within the last 30 months disqualifies a new EC application until that window passes." },
        r_new_firsttimer:      { tag: 'Eligible · first-timer', style: 'outline', title: "You qualify as a <em>first-timer</em>", body: "First-timer quota and priority period differ by project: 70% quota / 1-month priority under the older rules, 90% quota / 2-year priority for tenders closing after 8 May 2026." },
        r_new_secondtimer:     { tag: 'Eligible · second-timer', style: 'outline', title: "You qualify, with a <em>resale levy</em>", body: "Second-timer applicants can still buy a new EC, subject to the resale levy and a smaller allocation quota." },
        r_resale_mop:          { tag: 'Not yet', style: 'solid', title: "MOP not met — <em>can't buy</em> yet", body: "This EC hasn't cleared its 5-year Minimum Occupation Period, so it isn't transactable on the resale market yet." },
        r_resale_citizen_old:  { tag: 'Citizens / PRs only', style: 'dashed', title: 'Only <em>SC / PR</em> can buy, for now', body: "Under the older rule set, the EC is restricted to Singapore Citizens and PRs until year 10 from TOP, when it fully privatises." },
        r_resale_open_old:     { tag: 'Eligible', style: 'outline', title: 'Fully privatised — <em>open</em> to all buyers', body: "Past its 10-year full privatisation mark, this EC is open to any buyer, including foreigners." },
        r_resale_citizen_new:  { tag: 'Citizens / PRs only', style: 'dashed', title: 'Only <em>SC / PR</em> can buy, for now', body: "Under the new rules (tenders closing after 8 May 2026), the EC stays restricted to Citizens and PRs until year 15 from TOP." },
        r_resale_open_new:     { tag: 'Eligible', style: 'outline', title: 'Fully privatised — <em>open</em> to all buyers', body: "Past its 15-year full privatisation mark under the new rules, this EC is open to any buyer, including foreigners." }
      },
      map: {
        columns: [
          { title: 'Buying a new EC', nodes: ['start', 'new1', 'new2', 'new3', 'new4'], leaves: { new1: 'r_new_income_fail', new2: 'r_new_nucleus_fail', new3: 'r_new_dispose', new4: ['r_new_firsttimer', 'r_new_secondtimer'] } },
          { title: 'Buying a resale EC', nodes: ['start', 'resale1', 'resale2', 'resale_old', 'resale_new'], leaves: { resale1: 'r_resale_mop', resale_old: ['r_resale_open_old', 'r_resale_citizen_old'], resale_new: ['r_resale_open_new', 'r_resale_citizen_new'] } }
        ]
      }
    };

    var MAX_DEPTH = 5;
    var path = [];
    var currentNode = TREE.start;
    var resultId = null;

    function el(id) { return document.getElementById(id); }
    var qText = el('rc-ec-q-text'), optWrap = el('rc-ec-opt-wrap'), qCard = el('rc-ec-q-card'),
        resultCard = el('rc-ec-result-card'), progressEl = el('rc-ec-progress'),
        stepLabel = el('rc-ec-step-label'), backBtn = el('rc-ec-back-btn');

    function renderProgress() {
      progressEl.innerHTML = '';
      for (var i = 0; i < MAX_DEPTH; i++) {
        var seg = document.createElement('div');
        seg.className = 'rc-flow__seg';
        if (i < path.length) seg.className += ' rc-flow__seg--done';
        else if (i === path.length) seg.className += ' rc-flow__seg--current';
        progressEl.appendChild(seg);
      }
    }

    function renderQuestion() {
      resultCard.classList.remove('is-shown');
      qCard.style.display = '';
      var node = TREE.nodes[currentNode];
      qText.innerHTML = node.q;
      optWrap.innerHTML = '';
      node.options.forEach(function (opt, i) {
        var b = document.createElement('button');
        b.className = 'rc-flow__opt';
        b.innerHTML = '<span>' + opt.label + '</span><span class="rc-flow__arrow">→</span>';
        b.onclick = function () { choose(opt); };
        optWrap.appendChild(b);
      });
      stepLabel.textContent = '— Step ' + String(path.length + 1).padStart(2, '0');
      backBtn.classList.toggle('is-shown', path.length > 0);
      renderProgress();
    }

    function choose(opt) {
      path.push({ nodeId: currentNode, label: opt.label });
      if (TREE.nodes[opt.to]) {
        currentNode = opt.to;
        renderQuestion();
      } else {
        resultId = opt.to;
        renderResult();
      }
    }

    function goBack() {
      if (!path.length) return;
      var last = path.pop();
      currentNode = last.nodeId;
      renderQuestion();
    }
    backBtn.onclick = goBack;

    function renderResult() {
      qCard.style.display = 'none';
      resultCard.classList.add('is-shown');
      var r = TREE.results[resultId];
      var sw = el('rc-ec-result-swatch');
      sw.outerHTML = '<span class="rc-flow__swatch rc-flow__swatch--' + r.style + '" id="rc-ec-result-swatch" style="width:14px;height:14px;"></span>';
      el('rc-ec-result-tag').textContent = r.tag;
      el('rc-ec-result-title').innerHTML = r.title;
      el('rc-ec-result-body').textContent = r.body;
    }

    el('rc-ec-restart-btn').onclick = function () {
      path = []; currentNode = TREE.start; resultId = null; renderQuestion();
    };

    renderQuestion();

    /* Pull the current EC income ceiling from the registry; if it differs from the
       fallback, update the two places it appears and re-render whatever is shown. */
    function applyCeiling() {
      var c = fmtSGD(EC_CEILING);
      TREE.nodes.new1.q = CEIL_TPL.q.replace('{c}', c);
      TREE.results.r_new_income_fail.body = CEIL_TPL.body.replace('{c}', c);
    }
    fetch('https://api.roncasa.co/calc/policy')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = d && d.income_ceiling && d.income_ceiling.ec_current;
        if (c && c !== EC_CEILING) {
          EC_CEILING = c;
          applyCeiling();
          if (resultId === 'r_new_income_fail') renderResult();
          else if (currentNode === 'new1') renderQuestion();
        }
      })
      .catch(function () {});

    var mapOverlay = el('rc-ec-map-overlay'), mapCols = el('rc-ec-map-cols');
    el('rc-ec-view-map-btn').onclick = function () { buildMap(); mapOverlay.classList.add('is-shown'); };
    el('rc-ec-map-close-btn').onclick = function () { mapOverlay.classList.remove('is-shown'); };
    mapOverlay.addEventListener('click', function (e) { if (e.target === mapOverlay) mapOverlay.classList.remove('is-shown'); });

    function visitedNodeIds() { return path.map(function (p) { return p.nodeId; }); }
    function chosenLabelFor(nodeId) {
      var step = path.filter(function (p) { return p.nodeId === nodeId; })[0];
      return step ? step.label : null;
    }

    function buildMap() {
      mapCols.innerHTML = '';
      var visited = visitedNodeIds();
      TREE.map.columns.forEach(function (col) {
        var colEl = document.createElement('div');
        var title = document.createElement('div');
        title.className = 'rc-flow__map-col-title';
        title.textContent = col.title;
        colEl.appendChild(title);

        var tl = document.createElement('div');
        tl.className = 'rc-flow__tl';

        col.nodes.forEach(function (nodeId) {
          var node = TREE.nodes[nodeId];
          var isActive = visited.indexOf(nodeId) !== -1 || nodeId === currentNode;
          var nodeEl = document.createElement('div');
          nodeEl.className = 'rc-flow__tl-node' + (isActive ? ' is-active' : '');
          var chosen = chosenLabelFor(nodeId);
          nodeEl.innerHTML = '<p class="rc-flow__tl-q">' + node.q.replace(/<[^>]+>/g, '') + '</p>' +
            '<div class="rc-flow__tl-a">' + node.options.map(function (o) {
              return '<span class="' + (chosen === o.label ? 'is-taken' : '') + '">' + o.label + '</span>';
            }).join('') + '</div>';
          tl.appendChild(nodeEl);

          var leafDef = col.leaves[nodeId];
          if (leafDef) {
            var leafIds = Array.isArray(leafDef) ? leafDef : [leafDef];
            leafIds.forEach(function (lid) {
              var r = TREE.results[lid];
              var reached = resultId === lid;
              var leafEl = document.createElement('div');
              leafEl.className = 'rc-flow__tl-result rc-flow--style-' + r.style + (reached ? ' is-reached' : '');
              leafEl.innerHTML = '<div class="rc-flow__tl-t">' + r.title.replace(/<[^>]+>/g, '') + '</div>';
              tl.appendChild(leafEl);
            });
          }
        });

        colEl.appendChild(tl);
        mapCols.appendChild(colEl);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flowchart-inheritance"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* Shopify bundles every section's {% javascript %} into one shared
       <script> tag site-wide — if this section isn't on the current page,
       every el(id) below would be null and throw, killing every OTHER
       section's JS later in that same bundle. Bail out immediately. */
    if (!document.getElementById('rc-inh-q-text')) return;

    var TREE = {
      start: 'start',
      nodes: {
        start: { q: "What are you <em>inheriting</em>?", options: [
          { label: 'An HDB flat', to: 'hdb1' }, { label: 'A private property', to: 'priv1' } ] },
        hdb1: { q: 'Do you currently own an existing HDB flat?', options: [
          { label: 'Yes', to: 'r_sell_either' }, { label: 'No', to: 'hdb2' } ] },
        hdb2: { q: 'Do you own an existing private property?', options: [
          { label: 'No', to: 'r_inherit_hdb_free' }, { label: 'Yes', to: 'hdb3' } ] },
        hdb3: { q: 'Is the inherited flat a non-subsidised HDB bought before 30 Aug 2010?', options: [
          { label: 'Yes', to: 'r_keep_both_hdb' }, { label: 'No', to: 'r_sell_private_hdb' } ] },
        priv1: { q: 'Are you a Singapore Citizen or PR?', options: [
          { label: 'Yes', to: 'priv2' }, { label: 'No', to: 'priv_landed' } ] },
        priv_landed: { q: 'Is it a landed or non-landed property?', options: [
          { label: 'Landed', to: 'r_sell_unless_approval' }, { label: 'Non-landed', to: 'priv2' } ] },
        priv2: { q: 'Do you own an existing HDB flat?', options: [
          { label: 'No', to: 'r_inherit_private_free' }, { label: 'Yes', to: 'priv3' } ] },
        priv3: { q: "Is your HDB still within its Minimum Occupation Period (5 years)?", options: [
          { label: 'Yes', to: 'r_sell_inherited_private' }, { label: 'No', to: 'r_keep_both_private' } ] }
      },
      results: {
        r_sell_either:            { tag: 'Sell decision', style: 'solid', title: "You'll need to <em>sell</em> one flat", body: "HDB rules allow only one subsidised flat per household. Keep either your existing flat or the inherited one, not both." },
        r_inherit_hdb_free:       { tag: 'Clear to inherit', style: 'outline', title: 'You can inherit the <em>HDB</em> freely', body: "With no existing flat or private property, you meet the eligibility conditions to take over the flat outright." },
        r_keep_both_hdb:          { tag: 'Keep both', style: 'outline', title: 'You may <em>keep both</em> properties', body: "Non-subsidised flats bought before 30 Aug 2010 let you retain your private property alongside the inherited HDB." },
        r_sell_private_hdb:       { tag: 'Sell decision', style: 'solid', title: "You'll likely need to <em>sell</em> one", body: "Post-2010 subsidised flats restrict concurrent private property ownership. Expect to divest one of the two." },
        r_sell_unless_approval:   { tag: 'Approval needed', style: 'dashed', title: 'Sale required — <em>unless</em> approved', body: "Landed property inherited by a non-citizen must be sold unless the Land Dealings Approval Unit grants an exception." },
        r_inherit_private_free:   { tag: 'Clear to inherit', style: 'outline', title: 'You can inherit the <em>property</em>', body: "No existing HDB flat in the picture means you're clear to take on the private property outright." },
        r_sell_inherited_private: { tag: 'Sell decision', style: 'solid', title: "You'll need to <em>sell</em> the inherited unit", body: "Your HDB is still within its Minimum Occupation Period, so the inherited private property will likely need to be sold first." },
        r_keep_both_private:      { tag: 'Keep both', style: 'outline', title: 'You can <em>keep both</em> properties', body: "Once past MOP, you may retain your HDB flat and the inherited private property together." }
      },
      map: {
        columns: [
          { title: 'Inheriting an HDB flat', nodes: ['start', 'hdb1', 'hdb2', 'hdb3'], leaves: { hdb1: 'r_sell_either', hdb2: 'r_inherit_hdb_free', hdb3: ['r_keep_both_hdb', 'r_sell_private_hdb'] } },
          { title: 'Inheriting a private property', nodes: ['start', 'priv1', 'priv_landed', 'priv2', 'priv3'], leaves: { priv_landed: 'r_sell_unless_approval', priv2: 'r_inherit_private_free', priv3: ['r_sell_inherited_private', 'r_keep_both_private'] } }
        ]
      }
    };

    var MAX_DEPTH = 4;
    var path = [];
    var currentNode = TREE.start;
    var resultId = null;

    function el(id) { return document.getElementById(id); }
    var qText = el('rc-inh-q-text'), optWrap = el('rc-inh-opt-wrap'), qCard = el('rc-inh-q-card'),
        resultCard = el('rc-inh-result-card'), progressEl = el('rc-inh-progress'),
        stepLabel = el('rc-inh-step-label'), backBtn = el('rc-inh-back-btn');

    function renderProgress() {
      progressEl.innerHTML = '';
      for (var i = 0; i < MAX_DEPTH; i++) {
        var seg = document.createElement('div');
        seg.className = 'rc-flow__seg';
        if (i < path.length) seg.className += ' rc-flow__seg--done';
        else if (i === path.length) seg.className += ' rc-flow__seg--current';
        progressEl.appendChild(seg);
      }
    }

    function renderQuestion() {
      resultCard.classList.remove('is-shown');
      qCard.style.display = '';
      var node = TREE.nodes[currentNode];
      qText.innerHTML = node.q;
      optWrap.innerHTML = '';
      node.options.forEach(function (opt) {
        var b = document.createElement('button');
        b.className = 'rc-flow__opt';
        b.innerHTML = '<span>' + opt.label + '</span><span class="rc-flow__arrow">→</span>';
        b.onclick = function () { choose(opt); };
        optWrap.appendChild(b);
      });
      stepLabel.textContent = '— Step ' + String(path.length + 1).padStart(2, '0');
      backBtn.classList.toggle('is-shown', path.length > 0);
      renderProgress();
    }

    function choose(opt) {
      path.push({ nodeId: currentNode, label: opt.label });
      if (TREE.nodes[opt.to]) {
        currentNode = opt.to;
        renderQuestion();
      } else {
        resultId = opt.to;
        renderResult();
      }
    }

    function goBack() {
      if (!path.length) return;
      var last = path.pop();
      currentNode = last.nodeId;
      renderQuestion();
    }
    backBtn.onclick = goBack;

    function renderResult() {
      qCard.style.display = 'none';
      resultCard.classList.add('is-shown');
      var r = TREE.results[resultId];
      var sw = el('rc-inh-result-swatch');
      sw.outerHTML = '<span class="rc-flow__swatch rc-flow__swatch--' + r.style + '" id="rc-inh-result-swatch" style="width:14px;height:14px;"></span>';
      el('rc-inh-result-tag').textContent = r.tag;
      el('rc-inh-result-title').innerHTML = r.title;
      el('rc-inh-result-body').textContent = r.body;
    }

    el('rc-inh-restart-btn').onclick = function () {
      path = []; currentNode = TREE.start; resultId = null; renderQuestion();
    };

    renderQuestion();

    var mapOverlay = el('rc-inh-map-overlay'), mapCols = el('rc-inh-map-cols');
    el('rc-inh-view-map-btn').onclick = function () { buildMap(); mapOverlay.classList.add('is-shown'); };
    el('rc-inh-map-close-btn').onclick = function () { mapOverlay.classList.remove('is-shown'); };
    mapOverlay.addEventListener('click', function (e) { if (e.target === mapOverlay) mapOverlay.classList.remove('is-shown'); });

    function visitedNodeIds() { return path.map(function (p) { return p.nodeId; }); }
    function chosenLabelFor(nodeId) {
      var step = path.filter(function (p) { return p.nodeId === nodeId; })[0];
      return step ? step.label : null;
    }

    function buildMap() {
      mapCols.innerHTML = '';
      var visited = visitedNodeIds();
      TREE.map.columns.forEach(function (col) {
        var colEl = document.createElement('div');
        var title = document.createElement('div');
        title.className = 'rc-flow__map-col-title';
        title.textContent = col.title;
        colEl.appendChild(title);

        var tl = document.createElement('div');
        tl.className = 'rc-flow__tl';

        col.nodes.forEach(function (nodeId) {
          var node = TREE.nodes[nodeId];
          var isActive = visited.indexOf(nodeId) !== -1 || nodeId === currentNode;
          var nodeEl = document.createElement('div');
          nodeEl.className = 'rc-flow__tl-node' + (isActive ? ' is-active' : '');
          var chosen = chosenLabelFor(nodeId);
          nodeEl.innerHTML = '<p class="rc-flow__tl-q">' + node.q.replace(/<[^>]+>/g, '') + '</p>' +
            '<div class="rc-flow__tl-a">' + node.options.map(function (o) {
              return '<span class="' + (chosen === o.label ? 'is-taken' : '') + '">' + o.label + '</span>';
            }).join('') + '</div>';
          tl.appendChild(nodeEl);

          var leafDef = col.leaves[nodeId];
          if (leafDef) {
            var leafIds = Array.isArray(leafDef) ? leafDef : [leafDef];
            leafIds.forEach(function (lid) {
              var r = TREE.results[lid];
              var reached = resultId === lid;
              var leafEl = document.createElement('div');
              leafEl.className = 'rc-flow__tl-result rc-flow--style-' + r.style + (reached ? ' is-reached' : '');
              leafEl.innerHTML = '<div class="rc-flow__tl-t">' + r.title.replace(/<[^>]+>/g, '') + '</div>';
              tl.appendChild(leafEl);
            });
          }
        });

        colEl.appendChild(tl);
        mapCols.appendChild(colEl);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policy-tracker"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (!document.getElementById('rc-track-list')) return;

    var ENDPOINT = 'https://api.roncasa.co/calc/policy-history';

    /* Last-verified fallback snapshot — shown silently only if the fetch fails.
       The live endpoint carries the full, current timeline. */
    var FALLBACK = [
      { date: '2026-08-24', label: 'HDB / EC income ceilings', category: 'Eligibility', current: true, note: 'Raised at National Day Rally 2026 (family $16k, multigen $24k, singles $8k; new EC tenders $18k).', source_url: '' },
      { date: '2026-07-28', label: 'Private-to-HDB wait-out', category: 'Eligibility', current: true, note: '15-month wait-out removed for buying a non-subsidised resale flat without an HDB loan.', source_url: '' },
      { date: '2025-07-04', label: "Seller's Stamp Duty (SSD)", category: 'Stamp duty', current: true, note: 'Holding period lengthened to 4 years for property bought on/after 4 Jul 2025.', source_url: '' },
      { date: '2023-04-27', label: "Additional Buyer's Stamp Duty (ABSD)", category: 'Stamp duty', current: true, note: 'Current ABSD rates (citizen 2nd 20% / 3rd 30%; PR 5%/30%/35%; foreigner 60%).', source_url: '' }
    ];

    var DATA = FALLBACK, filter = 'all', CHECKED = '2026-09-03';
    var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    function el(id) { return document.getElementById(id); }
    function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]; }); }
    function fmtDate(iso) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
      if (!m) return iso || '';
      return parseInt(m[3], 10) + ' ' + MONTHS[parseInt(m[2], 10) - 1] + ' ' + m[1];
    }

    function categories() {
      var seen = {}, list = [];
      DATA.forEach(function (e) { if (e.category && !seen[e.category]) { seen[e.category] = 1; list.push(e.category); } });
      return list;
    }

    function buildChips() {
      var wrap = el('rc-track-filters');
      var cats = ['all'].concat(categories());
      wrap.innerHTML = '';
      cats.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rc-track__chip' + (c === filter ? ' rc-track__chip--active' : '');
        b.textContent = c === 'all' ? 'All' : c;
        b.onclick = function () { filter = c; buildChips(); render(); };
        wrap.appendChild(b);
      });
    }

    function render() {
      var rows = DATA.filter(function (e) { return filter === 'all' || e.category === filter; });
      el('rc-track-list').innerHTML = rows.map(function (e) {
        var badge = e.current
          ? '<span class="rc-track__badge rc-track__badge--current">Current</span>'
          : '<span class="rc-track__badge rc-track__badge--past">Superseded' + (e.superseded_on ? ' ' + fmtDate(e.superseded_on) : '') + '</span>';
        var src = e.source_url ? '<a class="rc-track__src" href="' + esc(e.source_url) + '" target="_blank" rel="noopener">Official source →</a>' : '';
        return '<div class="rc-track__row">' +
          '<div class="rc-track__date">' + fmtDate(e.date) + '</div>' +
          '<div class="rc-track__main">' +
            '<div class="rc-track__head"><span class="rc-track__label">' + esc(e.label) + '</span>' +
            '<span class="rc-track__tag">' + esc(e.category) + '</span>' + badge + '</div>' +
            '<p class="rc-track__note">' + esc(e.note) + '</p>' + src +
          '</div></div>';
      }).join('') || '<div class="rc-track__row"><div class="rc-track__date"></div><div class="rc-track__main"><p class="rc-track__note">No changes in this category.</p></div></div>';
    }

    function renderChecked() {
      var c = el('rc-track-checked');
      if (c) c.textContent = CHECKED ? 'Checked ' + fmtDate(CHECKED) : '';
    }

    buildChips();
    render();
    renderChecked();

    fetch(ENDPOINT)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var arr = Array.isArray(d) ? d : (d && d.changes) || [];
        if (arr.length) {
          DATA = arr;
          if (d && d.last_checked) CHECKED = d.last_checked;
          buildChips(); render(); renderChecked();
        }
      })
      .catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-reviews-filters"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initFilters() {
    /* Shopify does NOT run Liquid inside {% javascript %} — it's compiled as a
       shared static asset across every instance of this section, site-wide.
       Find the root element via its static class instead of rebuilding the
       dynamic id string, which would ship as a literal, never-matching value. */
    var filterWrap = document.querySelector('.rc-prf-filters');
    if (!filterWrap) return;

    var selects = {
      district: document.getElementById('rc-prj-filter-district'),
      status:   document.getElementById('rc-prj-filter-status'),
      psf:      document.getElementById('rc-prj-filter-psf'),
      verdict:  document.getElementById('rc-prj-filter-verdict'),
      tenure:   document.getElementById('rc-prj-filter-tenure')
    };

    function applyFilters() {
      var dVal = selects.district ? selects.district.value : '';
      var sVal = selects.status   ? selects.status.value   : '';
      var pVal = selects.psf      ? selects.psf.value      : '';
      var vVal = selects.verdict  ? selects.verdict.value  : '';
      var tVal = selects.tenure   ? selects.tenure.value   : '';

      var cards = document.querySelectorAll('.rc-prj-card');
      var visibleCount = 0;

      cards.forEach(function (card) {
        var show = true;

        if (dVal && card.dataset.district !== dVal) show = false;
        if (sVal && card.dataset.status   !== sVal) show = false;
        if (tVal && card.dataset.tenure   !== tVal) show = false;

        if (vVal) {
          if (vVal === 'view') {
            if (card.dataset.verdict !== 'pick' && card.dataset.verdict !== 'view') show = false;
          } else if (vVal === 'wait') {
            if (card.dataset.verdict !== 'wait' && card.dataset.verdict !== 'pass') show = false;
          } else {
            if (card.dataset.verdict !== vVal) show = false;
          }
        }

        if (pVal) {
          var psf = parseInt(card.dataset.psf, 10) || 0;
          if (pVal === 'under-1800'  && psf >= 1800)  show = false;
          if (pVal === '1800-2500'   && (psf < 1800 || psf >= 2500)) show = false;
          if (pVal === '2500-3200'   && (psf < 2500 || psf >= 3200)) show = false;
          if (pVal === 'over-3200'   && psf < 3200)   show = false;
        }

        card.style.display = show ? '' : 'none';
        if (show) visibleCount++;
      });

      /* Update empty-state message if present */
      var emptyMsg = document.querySelector('.rc-prj-empty');
      if (emptyMsg) {
        emptyMsg.style.display = visibleCount === 0 ? '' : 'none';
      }
    }

    Object.values(selects).forEach(function (sel) {
      if (sel) sel.addEventListener('change', applyFilters);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilters);
  } else {
    initFilters();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-hdb-resale"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* Shopify bundles every section's javascript tag into one shared
       <script> tag site-wide — if this section isn't on the current page,
       every el(id) below would be null and throw, killing every OTHER
       section's JS later in that same bundle. Bail out immediately. */
    if (!document.getElementById('rc-tl-tab-walk')) return;

    /* ── Mobile strip: Full Timeline tab + markup removed entirely below 768px,
       and the desktop sticky spine+detail walkthrough is swapped for the
       mobile card-stack walkthrough. Checked once on load only — not on
       resize (28 Jul 2026 decision, extended 11 Sep 2026). ── */
    var IS_MOBILE = window.innerWidth < 768;
    if (IS_MOBILE) {
      var vf0 = document.getElementById('rc-tl-view-full');
      if (vf0) { vf0.remove(); }
      var tf0 = document.getElementById('rc-tl-tab-full');
      if (tf0) { tf0.remove(); }
      var svb0 = document.getElementById('rc-tl-sc-view-btn');
      if (svb0) { svb0.remove(); }
      var wvb0 = document.getElementById('rc-tl-walkend-viewfull-btn');
      if (wvb0) { wvb0.remove(); }
      var so0 = document.getElementById('rc-tl-scroll-outer');
      if (so0) { so0.remove(); }
    } else {
      var mw0 = document.getElementById('rc-tl-m-wrap');
      if (mw0) { mw0.remove(); }
    }

    /* Shopify does NOT run Liquid inside the javascript tag — it's compiled as a
       shared static asset across every instance of this section, site-wide.
       Read customizer settings from data-* attributes on the root element
       (which IS Liquid-rendered, since it's regular HTML) instead. */
    var rootEl = document.getElementById('rc-tl-tab-walk').closest('.rc-tl');
    var CFG = {
      showCosts: rootEl.dataset.showCosts !== 'false',
      extAdminFee: rootEl.dataset.extAdminFee || '',
      fee1Room: rootEl.dataset.fee1room || '',
      fee3Room: rootEl.dataset.fee3room || ''
    };
    var ENDPOINT = 'https://api.roncasa.co/calc/timeline-dates';
    var DEBOUNCE_MS = 300;
    var fetchTimer = null;

    function el(id) { return document.getElementById(id); }

    /* ════════════════════════════════════════════════════
       STAGE DATA — copy/costs/tips, ported ~verbatim from source
    ════════════════════════════════════════════════════ */
    var D = {
      b: [
        {n:"01",t:"Apply for HFE",sub:"HDB Flat Eligibility",dur:"~21 working days",
         desc:"Apply on the HDB Flat Portal with your Singpass. The HFE letter confirms your eligibility, the grants you qualify for, and your loan ceiling: before you commit to anything. Processing typically takes <strong>~21 working days (about 1 month)</strong> after all documents are submitted, though it can be as fast as 1 week.",
         cost:"Free",costL:"Cost",wait:"~30 working days",waitL:"Processing",
         tip:"Start here, start early. This is the long pole of the whole process. Don't shortlist seriously until it's in hand. HFE typically takes ~21 working days. Apply before you start viewing.",
         gap:"~21 wkg days"},
        {n:"02",t:"Receive OTP + Valuation",sub:"Option to Purchase",dur:"21 days to exercise",
         desc:"Agree on price, pay $1,000 option fee, receive the OTP. Submit a Request for Value via My Flat Dashboard by the <strong>next working day</strong>, pay $120 processing fee. Valuation sets your CPF and loan ceiling.",
         cost:"$1,000 + $120",costL:"Fees",wait:"21-day window",waitL:"To exercise",
         tip:"The valuation fee is $120 regardless of flat type. If the agreed price exceeds valuation, the Cash Over Valuation must be paid in cash, not CPF, not loan.",
         gap:"21 days",hasExSlider:true},
        {n:"03",t:"Exercise OTP",sub:"Commit to buy",dur:"Within 21 days of OTP grant",
         desc:"Pay the $4,000 balance exercise fee to the seller and submit Intent to Proceed via the HDB MyFlat portal. Total option monies: $5,000: non-refundable if you withdraw.",
         cost:"$4,000",costL:"Exercise deposit",wait:"within 21 days",waitL:"Deadline",
         tip:"Miss the 21-day window and the OTP lapses. Your $1,000 option fee is forfeited. Confirm your financing is locked before exercising.",
         gap:"60 days"},
        {n:"04",t:"Submit Resale Application",sub:"Buyer's portion",dur:"Within 60 days of OTP exercise",
         desc:"Submit your application on the HDB portal independently. The seller must submit within 7 calendar days of you. Misaligned submissions void both applications and require a full restart.",
         cost:CFG.fee1Room,costL:"1–2 Room flat",wait:CFG.fee3Room,waitL:"3-Room & above",
         tip:"Both parties submit separately. The admin fee is the same rate for buyer and seller. Pay by credit card on the HDB Resale Portal when submitting.",
         gap:"~28 wkg days",hasSlider:true,hasExtToggle:true},
        {n:"05",t:"HDB Accepts Application",sub:"Processing",dur:"Within 28 working days",
         desc:"HDB reviews both applications and formally accepts. A completion date is issued, typically 8 weeks out. Use this window to set up SP Power and utilities for your new flat in advance, so services transfer smoothly on handover day.",
         cost:"—",costL:"Cost",wait:"~28 wkg days",waitL:"Processing",
         tip:"Book movers and renovation quotes now, contractor slots fill fast once your completion date is set. Confirm your SP utilities transfer at least 2 weeks before completion.",
         gap:"8 weeks"},
        {n:"06",t:"HDB Completion",sub:"Keys change hands",dur:"~8 weeks after acceptance",
         desc:"Attend the completion appointment. Sign the Transfer of Flat document, CPF is deducted, bank loan disbursed. Pay your remaining cash balance.",
         descNoExt:" You typically collect keys on this day.",
         descWithExt:" Keys will be collected separately at the end of the extension period.",
         cost:"BSD + Legal",costL:"Due",wait:"~8 weeks",waitL:"After",
         tip:"BSD is due within 14 days of the OTP date, not completion day. Rates: 1% on first $180k, 2% on next $180k, 3% on next $640k.",
         gap:"ext"},
        {n:"07",t:"Handover",sub:"Move in",dur:"Up to 3 months after completion",hasExtSlider:true,
         desc:"Keys in hand and time to move in. If a move-out extension was agreed, the seller vacates during the extension period and hands over keys at the end. Do a thorough walkthrough before signing the handover form.",
         cost:"—",costL:"Ext. fee",wait:"at completion",waitL:"Handover",
         dynCostL:"Handover",dynCost:{on:"Up to 3 months",off:"At completion"},
         dynWaitL:"Move in",dynWait:{on:"After extension ends",off:"Same day"},
         tip:"Don't rush the walkthrough. Once you sign the handover form, any defects are yours to fix. Check every fixture listed as 'included' in the OTP.",
         gap:null}
      ],
      s: [
        {n:"01",t:"Confirm Eligibility",sub:"Before you list",dur:"Before committing to any timeline",
         desc:"Confirm your Minimum Occupation Period (5 years from key collection, not booking date). Allow at least 7 days to verify your exact MOP date and outstanding loan balance via HDB MyFlat before committing to a sale timeline. Check ABSD implications if buying concurrently.",
         cost:"Free",costL:"Cost",wait:"Know this first",waitL:"MOP check",
         tip:"The MOP clock starts from key collection, not your BTO ballot date. Many sellers get this wrong. Verify your exact date via HDB MyFlat.",
         gap:"When ready"},
        {n:"02",t:"Listing & Viewing",sub:"Find your buyer",dur:"Depends on market and price",
         desc:"List on your preferred portal and begin viewings. No HDB valuation needed from you, the buyer arranges and pays for it ($120). To gauge your price, check recent transacted units on the HDB Resale Portal. If you price above the HDB valuation, the gap (Cash Over Valuation, COV) must be paid by the buyer in cash, not CPF. Price it right: too high and you narrow your pool.",
         cost:"—",costL:"Cost",wait:"Until offer",waitL:"Time to buyer",
         tip:"Pricing above valuation narrows your buyer pool. The buyer pays the $120 valuation fee, not you. There's a real trade-off between a higher asking price and time to transact.",
         gap:"On agreement"},
        {n:"03",t:"Grant OTP to Buyer",sub:"Option to Purchase",dur:"Buyer has 21 days to exercise",
         desc:"Agree on price, receive $1,000 option fee from the buyer, and issue the Option to Purchase. You cannot sell to anyone else for 21 days. The buyer will request a valuation at their own cost.",
         cost:"+ $1,000",costL:"Option fee in",wait:"21-day window",waitL:"Buyer's decision",
         tip:"You're not committed until the OTP is exercised. If the buyer lets it lapse, the $1,000 is yours to keep and you can relist freely.",
         gap:"21 days",hasExSlider:true},
        {n:"04",t:"OTP Exercised",sub:"Buyer commits",dur:"60-day window opens from exercise date",
         desc:"The buyer pays you $4,000 in exercise fees. You are now legally committed to the sale. Begin planning your move-out timeline and confirm your next housing arrangement.",
         cost:"+ $4,000",costL:"Received",wait:"60 days to submit",waitL:"From exercise",
         tip:"This is your signal to get serious about where you're going next. If buying simultaneously, your sell and buy completion dates need to align. Start coordinating now.",
         gap:"60 days"},
        {n:"05",t:"Submit Resale Application",sub:"Seller's portion",dur:"Both parties within 7 days of each other",
         desc:"Submit your application on the HDB portal independently. The buyer must submit within 7 calendar days of you, coordinate timing before either party submits. Pay your portion of the admin fee.",
         cost:CFG.fee1Room,costL:"1–2 Room flat",wait:CFG.fee3Room,waitL:"3-Room & above",
         tip:"The admin fee is the same for buyer and seller. Misaligned submissions void both applications and require a full restart, coordinate with the buyer before either of you submits.",
         gap:"~28 wkg days",hasSlider:true,hasExtToggle:true},
        {n:"06",t:"HDB Accepts Application",sub:"Processing",dur:"Within 28 working days",
         desc:"HDB confirms both applications and sets a completion date, typically 8 weeks out. Finalise movers and coordinate your next home's key collection date to align with it.",
         cost:"—",costL:"Cost",wait:"8 weeks",waitL:"To completion",
         tip:"If you need an extension, negotiate and agree the rate in writing now. Standard rate is $45–80 per day to the buyer.",
         gap:"8 weeks"},
        {n:"07",t:"Completion",sub:"Receive proceeds",dur:"Legal completion day",
         desc:"Attend HDB completion. Your outstanding loan is repaid from sale proceeds. CPF principal + accrued interest at 2.5% p.a. is refunded to your CPF OA, not cash in hand.",
         descNoExt:" Vacate and hand over keys to the buyer on completion day.",
         descWithExt:" Legal transfer completes today. You vacate during the extension period and hand over keys at the end.",
         cost:"Legal + loan",costL:"Costs",wait:"At completion",waitL:"Keys",
         tip:"Your CPF refund goes to your CPF OA with 2.5% p.a. accrued interest, not cash in hand. Factor this into your next purchase budget before you commit.",
         gap:"ext"},
        {n:"08",t:"Vacate & Handover",sub:"Hand over keys",dur:"After extension period ends",
         desc:"The extension period ends. Vacate the flat and hand over keys to the buyer. Do a thorough walkthrough together before signing the handover form.",
         cost:"—",costL:"Ext. fee",wait:"End of ext.",waitL:"Handover",
         hasExtSlider:true,
         tip:"The buyer is entitled to inspect before signing the handover form. Ensure all OTP-listed fixtures are present and all agreed conditions are met.",
         gap:null}
      ]
    };

    /* ════════════════════════════════════════════════════
       STATE
    ════════════════════════════════════════════════════ */
    var MODE = 'b';
    var sliderVal = 14;      /* submission window days */
    var exerciseDays = 21;   /* exercise window days */
    var showExt = false;
    var extDays = 90;
    var activeStage = -1;

    /* Latest data from the Worker — gaps array + per-stage-index dates.
       Never computed locally; only ever assigned from a fetch response. */
    var latestGaps = [];
    var latestStages = {};
    var latestTotalDays = 0;
    var otpDate = null; /* Date object — anchor date, local echo of SEG_DATE for display fallback */

    function visibleStages() {
      return showExt ? D[MODE] : D[MODE].slice(0, D[MODE].length - 1);
    }
    function stageTotal() { return visibleStages().length; }

    /* Index in the gaps/stages arrays that the exercise / submission / extension
       sliders map onto — same mode-branch convention as the rest of this data model. */
    function exGapIndex() { return MODE === 'b' ? 1 : 2; }
    function subGapIndex() { return MODE === 'b' ? 2 : 3; }
    function extGapIndex() { return latestGaps.length - 1; }

    /* ════════════════════════════════════════════════════
       WORKER FETCH — the only place stage dates / day-gaps come from
    ════════════════════════════════════════════════════ */
    function isoSeg(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }

    function buildEndpointUrl() {
      var p = new URLSearchParams();
      p.set('tool', 'hdb-resale');
      p.set('mode', MODE);
      p.set('anchor', otpDate ? isoSeg(otpDate) : isoSeg(new Date()));
      p.set('exercise_days', exerciseDays);
      p.set('submission_days', sliderVal);
      p.set('show_ext', showExt ? 'true' : 'false');
      p.set('ext_days', extDays);
      return ENDPOINT + '?' + p.toString();
    }

    function parseStageDates(raw) {
      var out = {};
      if (!raw) return out;
      Object.keys(raw).forEach(function (k) {
        var parts = raw[k].split('-');
        out[k] = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      });
      return out;
    }

    function fetchDates(rebuildAfter) {
      fetch(buildEndpointUrl())
        .then(function (r) { return r.json(); })
        .then(function (data) {
          latestGaps = data.gaps || [];
          latestStages = parseStageDates(data.stages);
          latestTotalDays = data.total_days || 0;
          if (rebuildAfter) {
            var rebuiltTarget = Math.min(Math.max(activeStage, 0), stageTotal() - 1);
            buildPanels(); buildSpine(); buildMap(); buildMobileCards();
            /* buildPanels() replaces every .rc-tl__sp node, so the previously-active
               panel's element is gone — force re-activation even if the target index
               is unchanged, or transitionToStage's idx===activeStage guard skips it
               and every panel stays at opacity:0. */
            activeStage = -1;
            transitionToStage(rebuiltTarget);
          }
          repaint();
        })
        .catch(function () { /* leave previous state — don't blank the UI on a transient failure */ });
    }

    function scheduleFetch(rebuildAfter) {
      clearTimeout(fetchTimer);
      fetchTimer = setTimeout(function () { fetchDates(rebuildAfter); }, DEBOUNCE_MS);
    }

    /* Optimistic local patch of a single gap slot — a direct assignment of the
       raw slider value already known to the browser, not a recomputed date
       cascade — so the spine/map reposition instantly while dates catch up
       once the debounced fetch resolves. */
    function patchGap(idx, val) {
      if (idx >= 0 && idx < latestGaps.length) { latestGaps[idx] = val; }
    }

    /* ════════════════════════════════════════════════════
       PROPORTIONAL POSITIONS — layout math, stays client-side (uses latestGaps)
    ════════════════════════════════════════════════════ */
    function spinePositions() {
      var gaps = latestGaps.length ? latestGaps : visibleStages().map(function () { return 1; });
      var tot = gaps.reduce(function (a, b) { return a + b; }, 0) || 1;
      var pos = [0]; var c = 0;
      for (var i = 0; i < gaps.length; i++) { c += gaps[i]; pos.push(c / tot * 100); }
      var MIN_GAP = 9;
      for (var j = 1; j < pos.length; j++) { if (pos[j] < pos[j - 1] + MIN_GAP) { pos[j] = pos[j - 1] + MIN_GAP; } }
      if (pos[pos.length - 1] > 100) {
        var scale = 100 / pos[pos.length - 1];
        for (var k = 0; k < pos.length; k++) { pos[k] = pos[k] * scale; }
      }
      return pos;
    }

    function mapPositions() {
      var gaps = latestGaps.length ? latestGaps.slice() : visibleStages().map(function () { return 1; });
      var lastIdx = gaps.length - 1;
      if (showExt && gaps[lastIdx] > 45) { gaps[lastIdx] = 45; }
      var tot = gaps.reduce(function (a, b) { return a + b; }, 0) || 1;
      var pL = 5, span = 90;
      var pos = [pL]; var c = 0;
      for (var i = 0; i < gaps.length; i++) { c += gaps[i]; pos.push(pL + span * (c / tot)); }
      return pos;
    }

    function gapText(i, s) {
      if (s.gap === 'ext') { return 'Extension\n' + extDays + ' days'; }
      if (i === exGapIndex()) { return exerciseDays + ' days'; }
      if (i === subGapIndex()) { return sliderVal + ' days'; }
      if (s.gap && s.gap !== 'When ready' && s.gap !== 'On agreement') { return s.gap; }
      return '';
    }

    /* ════════════════════════════════════════════════════
       LEFT SPINE
    ════════════════════════════════════════════════════ */
    function buildSpine() {
      var track = el('rc-tl-spine-track');
      if (!track) return;
      track.querySelectorAll('.rc-tl__tick-row,.rc-tl__tick-dur').forEach(function (n) { n.remove(); });
      var data = visibleStages();
      var pos = spinePositions();
      data.forEach(function (s, i) {
        var row = document.createElement('div');
        row.className = 'rc-tl__tick-row';
        row.id = 'rc-tl-tr-' + i;
        row.style.top = pos[i] + '%';
        row.innerHTML = '<span class="rc-tl__tnum">' + s.n + '</span>' +
          '<span class="rc-tl__tdot"></span>' +
          '<div class="rc-tl__tright"><span class="rc-tl__tdate" id="rc-tl-trdate-' + i + '"></span><span class="rc-tl__ttext">' + s.t + '</span></div>';
        row.addEventListener('click', function () { jumpToStage(i); });
        track.appendChild(row);

        if (i < data.length - 1 && s.gap && s.gap !== 'When ready' && s.gap !== 'On agreement') {
          var midPct = (pos[i] + pos[i + 1]) / 2;
          var dur = document.createElement('div');
          dur.className = 'rc-tl__tick-dur';
          dur.id = 'rc-tl-td-' + i;
          dur.style.top = midPct + '%';
          dur.textContent = gapText(i, s);
          track.appendChild(dur);
        }
      });
    }

    function updateSpineFill(stageIdx) {
      var pos = spinePositions();
      var fill = el('rc-tl-spine-fill');
      if (fill) { fill.style.height = pos[stageIdx] + '%'; }
    }

    function updateSpinePositions() {
      var pos = spinePositions();
      var data = visibleStages();
      data.forEach(function (s, i) {
        var row = el('rc-tl-tr-' + i);
        if (row) { row.style.top = pos[i] + '%'; }
        var dur = el('rc-tl-td-' + i);
        if (dur) {
          var midPct = (pos[i] + (pos[i + 1] !== undefined ? pos[i + 1] : pos[i])) / 2;
          dur.style.top = midPct + '%';
          var txt = gapText(i, s);
          if (txt) { dur.textContent = txt; }
        }
      });
      if (activeStage >= 0) { updateSpineFill(activeStage); }
    }

    /* ════════════════════════════════════════════════════
       STAGE PANELS
    ════════════════════════════════════════════════════ */
    function sliderCtx(v) {
      if (v <= 14) { return 'Very early, all parties must be fully aligned before the OTP exercise date'; }
      if (v <= 25) { return 'Tight, works if paperwork is prepped and seller is on standby from day one'; }
      if (v <= 42) { return 'Standard, enough time to coordinate with seller and settle all documents'; }
      if (v <= 55) { return 'Comfortable, typical when managing a concurrent sale or upgrade'; }
      return "60 days is HDB's hard deadline, avoid leaving it this late without reason";
    }

    function getExtMaxDays() {
      var completionIdx = MODE === 'b' ? 5 : 6;
      var completionDate = latestStages[completionIdx];
      if (!completionDate) return 92;
      var endDate = new Date(completionDate);
      endDate.setMonth(endDate.getMonth() + 3);
      return Math.round((endDate - completionDate) / (1000 * 60 * 60 * 24));
    }

    /* Shared body-content generator — used by BOTH buildPanels() (desktop
       panel, sfx='') and buildMobileCards() (mobile card, sfx='-m') so the
       slider/chip/tip markup is generated once, not duplicated per view
       (roncasa-timeline-builder skill: both views must call the same
       functions, never diverge on the same computed content). */
    function renderStageBody(s, i, sfx) {
      var sliderHTML = '', extToggleHTML = '';

      if (s.hasSlider && s.hasExtToggle) {
        var pct = (sliderVal / 60 * 100).toFixed(1);
        sliderHTML = '<div class="rc-tl__sp-dual-box">' +
          '<div class="rc-tl__sp-dual-left">' +
          '<span class="rc-tl__sl-eye">Days from exercising until you submit</span>' +
          '<div class="rc-tl__sl-pill"><div class="rc-tl__sl-fill" id="rc-tl-sl-fill' + sfx + '" style="width:' + pct + '%">' +
          '<span class="rc-tl__sl-fill-txt" id="rc-tl-sl-num' + sfx + '">' + sliderVal + ' days</span><span class="rc-tl__sl-handle"></span></div>' +
          '<span class="rc-tl__sl-pill-max">60 max</span>' +
          '<input type="range" class="rc-tl__sl-range" id="rc-tl-sl-range' + sfx + '" min="7" max="60" value="' + sliderVal + '"/></div>' +
          '<div class="rc-tl__sl-ctx" id="rc-tl-sl-ctx' + sfx + '">' + sliderCtx(sliderVal) + '</div></div>' +
          '<div class="rc-tl__sp-dual-right">' +
          (showExt ? '<div class="rc-tl__sp-dual-topfee"><strong>+ ' + CFG.extAdminFee + '</strong> <span>extension admin fee</span></div>' : '') +
          '<div class="rc-tl__sp-ext-q"><strong>Is there a move-out extension?</strong> Adds up to 3 months before handover.</div>' +
          '<div class="rc-tl__ext-pills" style="margin-top:8px">' +
          '<button type="button" id="rc-tl-wext-no' + sfx + '" class="rc-tl__ext-pill' + (!showExt ? ' rc-tl__ext-pill--on' : '') + '" data-ext="no">No</button>' +
          '<button type="button" id="rc-tl-wext-yes' + sfx + '" class="rc-tl__ext-pill' + (showExt ? ' rc-tl__ext-pill--on' : '') + '" data-ext="yes">Yes — extension</button>' +
          '</div></div></div>';
      } else if (s.hasSlider) {
        var pct2 = (sliderVal / 60 * 100).toFixed(1);
        sliderHTML = '<div class="rc-tl__sp-slider">' +
          '<span class="rc-tl__sl-eye">Days from exercising until you submit</span>' +
          '<div class="rc-tl__sl-pill"><div class="rc-tl__sl-fill" id="rc-tl-sl-fill' + sfx + '" style="width:' + pct2 + '%">' +
          '<span class="rc-tl__sl-fill-txt" id="rc-tl-sl-num' + sfx + '">' + sliderVal + ' days</span><span class="rc-tl__sl-handle"></span></div>' +
          '<span class="rc-tl__sl-pill-max">60 max</span>' +
          '<input type="range" class="rc-tl__sl-range" id="rc-tl-sl-range' + sfx + '" min="7" max="60" value="' + sliderVal + '"/></div>' +
          '<div class="rc-tl__sl-ctx" id="rc-tl-sl-ctx' + sfx + '">' + sliderCtx(sliderVal) + '</div></div>';
      }

      if (s.hasExtToggle && !s.hasSlider) {
        extToggleHTML = '<div class="rc-tl__sp-ext-toggle">' +
          '<div class="rc-tl__sp-ext-q"><strong>Is there a move-out extension?</strong> Adds up to 3 months.</div>' +
          '<div class="rc-tl__ext-pills" style="margin-top:10px">' +
          '<button type="button" id="rc-tl-wext-no' + sfx + '" class="rc-tl__ext-pill' + (!showExt ? ' rc-tl__ext-pill--on' : '') + '" data-ext="no">No — keys at completion</button>' +
          '<button type="button" id="rc-tl-wext-yes' + sfx + '" class="rc-tl__ext-pill' + (showExt ? ' rc-tl__ext-pill--on' : '') + '" data-ext="yes">Yes — add extension</button>' +
          '</div></div>';
      }

      var fullDesc = s.desc;
      if (s.descNoExt || s.descWithExt) { fullDesc += showExt ? (s.descWithExt || '') : (s.descNoExt || ''); }

      var costL = s.dynCostL || s.costL;
      var costVal = s.dynCost ? (showExt ? s.dynCost.on : s.dynCost.off) : s.cost;
      var waitL = s.dynWaitL || s.waitL;
      var waitVal = s.dynWait ? (showExt ? s.dynWait.on : s.dynWait.off) : s.wait;

      var exSliderHTML = '';
      if (s.hasExSlider) {
        var exPct = (exerciseDays / 21 * 100).toFixed(1);
        exSliderHTML = '<div class="rc-tl__sp-slider"><span class="rc-tl__sl-eye">Days until exercise (max 21 days from OTP grant)</span>' +
          '<div class="rc-tl__sl-pill"><div class="rc-tl__sl-fill" id="rc-tl-ex-fill' + sfx + '" style="width:' + exPct + '%">' +
          '<span class="rc-tl__sl-fill-txt" id="rc-tl-ex-num' + sfx + '">' + exerciseDays + ' days</span><span class="rc-tl__sl-handle"></span></div>' +
          '<span class="rc-tl__sl-pill-max">21 max</span>' +
          '<input type="range" class="rc-tl__sl-range" id="rc-tl-ex-range' + sfx + '" min="1" max="21" value="' + exerciseDays + '"/></div></div>';
      }

      var extSliderHTML = '';
      if (s.hasExtSlider && showExt) {
        var maxDays = getExtMaxDays();
        var extPct = (extDays / maxDays * 100).toFixed(1);
        extSliderHTML = '<div class="rc-tl__sp-slider" style="margin-top:14px"><span class="rc-tl__sl-eye">Extension days — up to ' + maxDays + ' days (3 calendar months)</span>' +
          '<div class="rc-tl__sl-pill"><div class="rc-tl__sl-fill" id="rc-tl-extsl-fill' + sfx + '" style="width:' + extPct + '%">' +
          '<span class="rc-tl__sl-fill-txt" id="rc-tl-extsl-num' + sfx + '">' + extDays + ' days</span><span class="rc-tl__sl-handle"></span></div>' +
          '<span class="rc-tl__sl-pill-max">' + maxDays + ' max</span>' +
          '<input type="range" id="rc-tl-extsl-range' + sfx + '" class="rc-tl__sl-range" min="1" max="' + maxDays + '" value="' + extDays + '"/></div></div>';
      }

      return {
        chips: CFG.showCosts ? ('<div class="rc-tl__sp-chips"><div class="rc-tl__sp-chip"><div class="rc-tl__cl">' + costL + '</div><div class="rc-tl__cv">' + costVal + '</div></div>' +
          '<div class="rc-tl__sp-chip"><div class="rc-tl__cl">' + waitL + '</div><div class="rc-tl__cv">' + waitVal + '</div></div></div>') : '',
        feeNote: (CFG.showCosts && s.hasSlider) ? ('<p class="rc-tl__sp-fee-note">* An extra ' + CFG.extAdminFee + ' fee (GST inclusive) applies if a move-out extension is included.</p>') : '',
        desc: fullDesc,
        controls: sliderHTML + extToggleHTML + extSliderHTML + exSliderHTML,
        tip: '<div class="rc-tl__sp-note"><span class="rc-tl__nl">Ron\'s Note</span><p>' + s.tip + '</p></div>'
      };
    }

    function buildPanels() {
      var wrap = el('rc-tl-detail-wrap');
      if (!wrap) return;
      wrap.innerHTML = '';
      var data = visibleStages();
      var total = data.length;
      var totalStr = (total < 10 ? '0' : '') + total;

      data.forEach(function (s, i) {
        var body = renderStageBody(s, i, '');
        var panel = document.createElement('div');
        panel.className = 'rc-tl__sp';
        panel.id = 'rc-tl-sp-' + i;
        panel.innerHTML =
          '<div class="rc-tl__sp-num">Stage <span>' + s.n + '</span> / ' + totalStr + '</div>' +
          '<div class="rc-tl__sp-name">' + s.t + '</div>' +
          '<div class="rc-tl__sp-sub">' + s.sub + '</div>' +
          '<div class="rc-tl__sp-stage-date" id="rc-tl-spdate-' + i + '"></div>' +
          '<div class="rc-tl__sp-desc">' + body.desc + '</div>' +
          body.chips + body.feeNote + body.controls + body.tip;
        wrap.appendChild(panel);
      });

      bindPanelControls('');
    }

    /* Mobile card-stack walkthrough — see header comment. Same stage data +
       same renderStageBody() output as the desktop panels, different
       container markup (all cards stacked in normal flow, revealed on
       scroll via IntersectionObserver, not a sticky one-at-a-time swap). */
    function buildMobileCards() {
      var wrap = el('rc-tl-m-stages');
      if (!wrap) return;
      wrap.innerHTML = '';
      var data = visibleStages();
      var total = data.length;
      var totalStr = (total < 10 ? '0' : '') + total;

      data.forEach(function (s, i) {
        var body = renderStageBody(s, i, '-m');
        var row = document.createElement('div');
        row.className = 'rc-tl__m-card-wrap';
        row.id = 'rc-tl-m-row-' + i;
        row.innerHTML = '<div class="rc-tl__m-dot"></div><div class="rc-tl__m-card">' +
          '<div class="rc-tl__m-num">Stage ' + s.n + ' / ' + totalStr + '</div>' +
          '<h3>' + s.t + '</h3>' +
          '<div class="rc-tl__m-sub">' + s.sub + '</div>' +
          '<div class="rc-tl__m-date" id="rc-tl-mdate-' + i + '"></div>' +
          '<div class="rc-tl__m-desc">' + body.desc + '</div>' +
          body.chips + body.feeNote + body.controls + body.tip +
          '</div>';
        wrap.appendChild(row);
      });

      bindPanelControls('-m');
      initMobileObserver();
    }

    function initMobileObserver() {
      var rows = Array.prototype.slice.call(document.querySelectorAll('.rc-tl__m-card-wrap'));
      var fill = el('rc-tl-m-fill');
      if (!rows.length || !fill) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('rc-tl__m-in'); } });
      }, { rootMargin: '0px 0px -15% 0px', threshold: 0.1 });
      rows.forEach(function (r) { io.observe(r); });

      function updateFill() {
        if (rows.length < 2) return;
        var track = document.querySelector('.rc-tl__m-track');
        var firstDot = rows[0].querySelector('.rc-tl__m-dot'), lastDot = rows[rows.length - 1].querySelector('.rc-tl__m-dot');
        if (!track || !firstDot || !lastDot) return;
        var first = firstDot.getBoundingClientRect(), last = lastDot.getBoundingClientRect();
        var mid = window.innerHeight * 0.5;
        var total = last.top - first.top;
        if (!total) return;
        var p = Math.max(0, Math.min(1, (mid - first.top) / total));
        fill.style.height = Math.max(0, (last.top - track.getBoundingClientRect().top) * p) + 'px';
      }
      var tickingM = false;
      window.addEventListener('scroll', function () {
        if (!tickingM) { requestAnimationFrame(function () { updateFill(); tickingM = false; }); tickingM = true; }
      }, { passive: true });
      window.addEventListener('resize', updateFill);
      updateFill();
    }

    function bindPanelControls(sfx) {
      sfx = sfx || '';
      var slRange = el('rc-tl-sl-range' + sfx);
      if (slRange) { slRange.addEventListener('input', function () { onSubmissionSlider(this.value); }); }
      var exRange = el('rc-tl-ex-range' + sfx);
      if (exRange) { exRange.addEventListener('input', function () { onExerciseSlider(this.value); }); }
      var extslRange = el('rc-tl-extsl-range' + sfx);
      if (extslRange) { extslRange.addEventListener('input', function () { onExtensionSlider(this.value); }); }
      var wextNo = el('rc-tl-wext-no' + sfx);
      if (wextNo) { wextNo.addEventListener('click', function () { toggleExt(false); }); }
      var wextYes = el('rc-tl-wext-yes' + sfx);
      if (wextYes) { wextYes.addEventListener('click', function () { toggleExt(true); }); }
    }

    /* ════════════════════════════════════════════════════
       TRANSITION TO STAGE
    ════════════════════════════════════════════════════ */
    function transitionToStage(idx) {
      if (idx === activeStage) { return; }
      if (activeStage >= 0) {
        var oldP = el('rc-tl-sp-' + activeStage); if (oldP) { oldP.classList.remove('rc-tl__sp--active'); }
        var oldT = el('rc-tl-tr-' + activeStage); if (oldT) { oldT.classList.remove('rc-tl__tick-row--active'); }
      }
      for (var j = 0; j < idx; j++) { var dT = el('rc-tl-tr-' + j); if (dT) { dT.classList.add('rc-tl__tick-row--done'); } }
      var panel = el('rc-tl-sp-' + idx); if (panel) { panel.classList.add('rc-tl__sp--active'); }
      var tick = el('rc-tl-tr-' + idx); if (tick) { tick.classList.remove('rc-tl__tick-row--done'); tick.classList.add('rc-tl__tick-row--active'); }
      var ghost = el('rc-tl-ghost-num');
      if (ghost) {
        ghost.classList.remove('rc-tl__ghost-num--pop'); void ghost.offsetWidth;
        ghost.textContent = visibleStages()[idx] ? visibleStages()[idx].n : String(idx + 1);
        ghost.classList.add('rc-tl__ghost-num--pop');
      }
      var tot = stageTotal(); var totS = (tot < 10 ? '0' : '') + tot;
      var sN = visibleStages()[idx] ? visibleStages()[idx].n : String(idx + 1);
      var sc = el('rc-tl-stage-counter'); if (sc) { sc.innerHTML = '<b>' + sN + '</b> / ' + totS; }
      var hint = el('rc-tl-tab-hint'); if (hint) { hint.textContent = 'Stage ' + (idx + 1) + ' of ' + tot; }
      updateSpineFill(idx);
      activeStage = idx;
      var cue = el('rc-tl-scroll-cue');
      if (cue) { cue.style.opacity = idx >= stageTotal() - 1 ? '0' : ''; }
    }

    /* ════════════════════════════════════════════════════
       SCROLL LOGIC
    ════════════════════════════════════════════════════ */
    function getProgress() {
      var outer = el('rc-tl-scroll-outer');
      if (!outer || outer.offsetHeight === 0) { return 0; }
      var rect = outer.getBoundingClientRect();
      var scrolled = Math.max(0, -rect.top);
      var total = Math.max(1, outer.offsetHeight - window.innerHeight);
      return Math.min(1, scrolled / total);
    }

    function onScroll() {
      var wv = el('rc-tl-view-walk');
      if (!wv || !wv.classList.contains('rc-tl__view-walk--active')) { return; }
      var p = getProgress();
      var pf = el('rc-tl-prog-fill'); if (pf) { pf.style.height = (p * 100) + '%'; }
      var N = stageTotal();
      var idx = Math.min(N - 1, Math.floor(p * N));
      transitionToStage(idx);
    }

    var ticking = false;
    if (!IS_MOBILE) {
      window.addEventListener('scroll', function () {
        if (!ticking) { requestAnimationFrame(function () { onScroll(); ticking = false; }); ticking = true; }
      }, { passive: true });
      window.addEventListener('resize', onScroll);
    }

    function jumpToStage(i) {
      var outer = el('rc-tl-scroll-outer');
      if (!outer) return;
      var N = stageTotal();
      var targetP = N > 1 ? i / (N - 1) : 0;
      var total = outer.offsetHeight - window.innerHeight;
      window.scrollTo({ top: outer.offsetTop + targetP * total, behavior: 'smooth' });
    }

    /* ════════════════════════════════════════════════════
       SLIDERS
    ════════════════════════════════════════════════════ */
    function onExerciseSlider(val) {
      exerciseDays = parseInt(val, 10);
      var f = el('rc-tl-ex-fill'), n = el('rc-tl-ex-num');
      if (f) f.style.width = (exerciseDays / 21 * 100) + '%';
      if (n) n.textContent = exerciseDays + ' days';
      var mf = el('rc-tl-ex-fill-m'), mn = el('rc-tl-ex-num-m'), mr = el('rc-tl-ex-range-m');
      if (mf) mf.style.width = (exerciseDays / 21 * 100) + '%';
      if (mn) mn.textContent = exerciseDays + ' days';
      if (mr) mr.value = exerciseDays;
      var ftf = el('rc-tl-ft-ex-fill'), ftn = el('rc-tl-ft-ex-num'), ftr = el('rc-tl-ft-ex-range');
      if (ftf) ftf.style.width = (exerciseDays / 21 * 100) + '%';
      if (ftn) ftn.textContent = exerciseDays + ' days';
      if (ftr) ftr.value = exerciseDays;
      patchGap(exGapIndex(), exerciseDays);
      updateSpinePositions(); updateMapPositions();
      scheduleFetch(false);
    }

    function onSubmissionSlider(val) {
      var v = parseInt(val, 10);
      sliderVal = v;
      var n = el('rc-tl-sl-num'), f = el('rc-tl-sl-fill'), c = el('rc-tl-sl-ctx');
      if (n) n.textContent = v + ' days';
      if (f) f.style.width = (v / 60 * 100) + '%';
      if (n) n.className = (v <= 25 || v > 55) ? 'rc-tl__sl-fill-txt' : 'rc-tl__sl-fill-txt';
      if (c) { c.className = (v <= 25 || v > 55) ? 'rc-tl__sl-ctx rc-tl__sl-ctx--warn' : 'rc-tl__sl-ctx'; c.textContent = sliderCtx(v); }
      var mn2 = el('rc-tl-sl-num-m'), mf2 = el('rc-tl-sl-fill-m'), mc2 = el('rc-tl-sl-ctx-m'), mr2 = el('rc-tl-sl-range-m');
      if (mn2) mn2.textContent = v + ' days';
      if (mf2) mf2.style.width = (v / 60 * 100) + '%';
      if (mc2) { mc2.className = (v <= 25 || v > 55) ? 'rc-tl__sl-ctx rc-tl__sl-ctx--warn' : 'rc-tl__sl-ctx'; mc2.textContent = sliderCtx(v); }
      if (mr2) mr2.value = v;
      var ftf = el('rc-tl-ft-sl-fill'), ftn = el('rc-tl-ft-sl-num'), ftr = el('rc-tl-ft-sl-range');
      if (ftf) ftf.style.width = (v / 60 * 100) + '%';
      if (ftn) ftn.textContent = v + ' days';
      if (ftr) ftr.value = v;
      patchGap(subGapIndex(), v);
      updateSpinePositions(); updateMapPositions();
      scheduleFetch(false);
    }

    function onExtensionSlider(val) {
      extDays = parseInt(val, 10);
      var maxDays = getExtMaxDays();
      var f = el('rc-tl-extsl-fill'), n = el('rc-tl-extsl-num');
      if (f) f.style.width = (extDays / maxDays * 100) + '%';
      if (n) n.textContent = extDays + ' days';
      var mf3 = el('rc-tl-extsl-fill-m'), mn3 = el('rc-tl-extsl-num-m'), mr3 = el('rc-tl-extsl-range-m');
      if (mf3) mf3.style.width = (extDays / maxDays * 100) + '%';
      if (mn3) mn3.textContent = extDays + ' days';
      if (mr3) mr3.value = extDays;
      syncFTExtSlider(extDays);
      patchGap(extGapIndex(), extDays);
      updateSpinePositions(); updateMapPositions();
      scheduleFetch(false);
    }

    function syncFTExtSlider(v) {
      var ftf = el('rc-tl-ft-ext-fill'), ftn = el('rc-tl-ft-ext-num');
      var maxDays = getExtMaxDays();
      if (ftf) ftf.style.width = (parseInt(v, 10) / maxDays * 100) + '%';
      if (ftn) ftn.textContent = v + ' days';
    }

    /* ════════════════════════════════════════════════════
       HORIZONTAL MAP
    ════════════════════════════════════════════════════ */
    function buildMap() {
      var h = el('rc-tl-horiz');
      if (!h) { buildVertMap(); return; }
      h.querySelectorAll('.rc-tl__hn,.rc-tl__hl,.rc-tl__hgap,.rc-tl__hext,.rc-tl__hext-lab').forEach(function (n) { n.remove(); });
      var pos = mapPositions();
      var data = visibleStages();
      var N = data.length;

      data.forEach(function (s, i) {
        var xi = pos[i];
        var term = (i === N - 1);
        var nd = document.createElement('div');
        nd.className = 'rc-tl__hn' + (term ? ' rc-tl__hn--term' : '');
        nd.style.left = xi + '%';
        nd.id = 'rc-tl-hn-' + i;
        nd.addEventListener('click', (function (idx) { return function () { switchTab('walk'); setTimeout(function () { jumpToStage(idx); }, 100); }; })(i));
        h.appendChild(nd);

        var up = (i % 2 === 0);
        var costDisplay = (s.hasSlider && s.hasExtToggle) ? (CFG.fee1Room + ' / ' + CFG.fee3Room) : (s.cost || '');
        var showCost = CFG.showCosts && costDisplay && costDisplay !== '—' && costDisplay !== 'Legal + loan' && costDisplay !== 'BSD + Legal' && costDisplay.charAt(0) !== '+';
        var lb = document.createElement('div');
        lb.className = 'rc-tl__hl ' + (up ? 'rc-tl__hl--up' : 'rc-tl__hl--dn');
        lb.style.left = xi + '%';
        lb.id = 'rc-tl-hl-' + i;
        lb.innerHTML = '<div class="rc-tl__tick"></div><div class="rc-tl__hln">' + s.n + '</div><div class="rc-tl__hlt">' + s.t + '</div>' + (showCost ? '<div class="rc-tl__hlc">' + costDisplay + '</div>' : '') + '<div class="rc-tl__hldate" id="rc-tl-hldate-' + i + '"></div>';
        h.appendChild(lb);

        var tooClose = (i < pos.length - 1 && Math.abs(pos[i + 1] - pos[i]) < 4);
        if (!tooClose && i < N - 1 && s.gap && s.gap !== 'ext' && s.gap !== 'When ready' && s.gap !== 'On agreement') {
          var gp = document.createElement('div');
          gp.className = 'rc-tl__hgap';
          gp.id = 'rc-tl-hgap-' + i;
          gp.style.left = ((xi + pos[i + 1]) / 2) + '%';
          gp.textContent = gapText(i, s) || s.gap;
          h.appendChild(gp);
        }
      });

      var extLeftIdx = pos.length - 2, extRightIdx = pos.length - 1;
      var ext = document.createElement('div');
      ext.className = 'rc-tl__hext'; ext.id = 'rc-tl-hext-el';
      ext.style.left = pos[extLeftIdx] + '%';
      ext.style.width = (pos[extRightIdx] - pos[extLeftIdx]) + '%';
      ext.style.display = showExt ? 'block' : 'none';
      h.appendChild(ext);

      var elab = document.createElement('div');
      elab.className = 'rc-tl__hext-lab'; elab.id = 'rc-tl-hext-lab-el';
      elab.style.left = ((pos[extLeftIdx] + pos[extRightIdx]) / 2) + '%';
      elab.innerHTML = '<div class="rc-tl__et">' + extDays + ' days</div><div class="rc-tl__ec">up to 3 months</div>';
      elab.style.display = showExt ? 'block' : 'none';
      h.appendChild(elab);

      buildVertMap();
    }

    function updateMapPositions() {
      var pos = mapPositions();
      pos.forEach(function (p, i) {
        var nd = el('rc-tl-hn-' + i); var lb = el('rc-tl-hl-' + i);
        if (nd) nd.style.left = p + '%';
        if (lb) lb.style.left = p + '%';
      });
      var data = visibleStages();
      for (var i = 0; i < pos.length - 1; i++) {
        var gp = el('rc-tl-hgap-' + i);
        if (gp && data[i]) { gp.style.left = ((pos[i] + pos[i + 1]) / 2) + '%'; var t = gapText(i, data[i]); if (t) gp.textContent = t; }
      }
      var ext = el('rc-tl-hext-el'); var elab = el('rc-tl-hext-lab-el');
      var extLeftIdx = pos.length - 2, extRightIdx = pos.length - 1;
      if (ext) { ext.style.left = pos[extLeftIdx] + '%'; ext.style.width = (pos[extRightIdx] - pos[extLeftIdx]) + '%'; }
      if (elab) { elab.style.left = ((pos[extLeftIdx] + pos[extRightIdx]) / 2) + '%'; elab.innerHTML = '<div class="rc-tl__et">' + extDays + ' days</div><div class="rc-tl__ec">up to 3 months</div>'; }
      var vg = el('rc-tl-vgap-submit');
      if (vg) { var gp2 = vg.querySelector('.rc-tl__gpill'); if (gp2) gp2.textContent = sliderVal + ' days'; }
    }

    function buildVertMap() {
      var v = el('rc-tl-vert');
      if (!v) return;
      v.innerHTML = '<div class="rc-tl__vspine"></div>';
      var data = visibleStages();
      data.forEach(function (s, i) {
        var term = (i === data.length - 1);
        var showCost = CFG.showCosts && s.cost && s.cost !== '—' && s.cost.charAt(0) !== '+';
        var row = document.createElement('div');
        row.className = 'rc-tl__vrow' + (term ? ' rc-tl__vrow--term' : '');
        row.innerHTML = '<div class="rc-tl__vnode"></div><div class="rc-tl__vnum">' + s.n + '</div><div class="rc-tl__vt">' + s.t + '</div>' + (showCost ? '<div class="rc-tl__vc">' + s.cost + '</div>' : '');
        row.addEventListener('click', (function (idx) { return function () { switchTab('walk'); setTimeout(function () { jumpToStage(idx); }, 100); }; })(i));
        v.appendChild(row);

        var isSubmitGap = (i === subGapIndex());
        if (s.gap && s.gap !== 'ext' && s.gap !== 'When ready' && s.gap !== 'On agreement' && i < data.length - 1) {
          var gv = document.createElement('div');
          gv.className = 'rc-tl__vgap' + (isSubmitGap ? '' : '');
          if (isSubmitGap) gv.id = 'rc-tl-vgap-submit';
          var txt = isSubmitGap ? sliderVal + ' days' : s.gap;
          gv.innerHTML = '<span class="rc-tl__gpill">' + txt + '</span>';
          v.appendChild(gv);
        } else if (s.gap === 'ext' && showExt) {
          var ev = document.createElement('div');
          ev.className = 'rc-tl__vgap';
          ev.innerHTML = '<span class="rc-tl__gpill rc-tl__gpill--dashed">+ extension · up to 3 months</span>';
          v.appendChild(ev);
        }
      });
    }

    /* ════════════════════════════════════════════════════
       DATE LABELS — driven entirely by latestStages (from the Worker)
    ════════════════════════════════════════════════════ */
    function fmtDate(d) {
      if (!d) return '';
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
    }

    function repaint() {
      var data = visibleStages();
      /* Gap/duration labels */
      data.forEach(function (s, i) {
        var dur = el('rc-tl-td-' + i);
        if (dur) { var t = gapText(i, s); if (t) dur.textContent = t; }
      });
      /* Date labels — looped unconditionally, independent of whether a gap
         label exists, so the LAST visible stage (which has no trailing gap)
         still gets its own date. */
      data.forEach(function (s, i) {
        var trDE = el('rc-tl-trdate-' + i);
        if (trDE) { trDE.textContent = latestStages[i] ? fmtDate(latestStages[i]) : ''; }
      });
      data.forEach(function (s, i) {
        var dateEl = el('rc-tl-spdate-' + i);
        if (!dateEl) return;
        var d = latestStages[i];
        if (d) { dateEl.textContent = fmtDate(d); dateEl.style.display = 'block'; }
        else { dateEl.style.display = 'none'; }
      });
      /* Mobile card date — same latestStages source, same fmtDate(), just a
         different element id (rc-tl-mdate-N instead of rc-tl-spdate-N). */
      data.forEach(function (s, i) {
        var mdateEl = el('rc-tl-mdate-' + i);
        if (!mdateEl) return;
        var d2 = latestStages[i];
        if (d2) { mdateEl.textContent = fmtDate(d2); mdateEl.style.display = 'block'; }
        else { mdateEl.style.display = 'none'; }
      });
      data.forEach(function (s, i) {
        var ld = el('rc-tl-hldate-' + i);
        if (ld) { ld.textContent = latestStages[i] ? fmtDate(latestStages[i]) : ''; }
      });
      updateSpinePositions();
      updateMapPositions();
    }

    /* ════════════════════════════════════════════════════
       EXTENSION TOGGLE
    ════════════════════════════════════════════════════ */
    function toggleExt(on) {
      showExt = on;
      var fno = el('rc-tl-ext-no'), fyes = el('rc-tl-ext-yes');
      if (fno) fno.classList.toggle('rc-tl__ext-pill--on', !on);
      if (fyes) fyes.classList.toggle('rc-tl__ext-pill--on', on);
      var feeNote = el('rc-tl-ext-fee-note');
      if (feeNote) feeNote.style.display = on ? 'block' : 'none';
      var ftExtCtrl = el('rc-tl-ft-ext-ctrl');
      if (ftExtCtrl) ftExtCtrl.style.display = on ? 'block' : 'none';

      var saved = activeStage;
      buildPanels(); buildSpine(); buildMap(); buildMobileCards();
      activeStage = -1;
      transitionToStage(Math.min(saved >= 0 ? saved : 0, stageTotal() - 1));

      var cue = el('rc-tl-scroll-cue'); var tot = stageTotal();
      if (cue) cue.style.opacity = (activeStage >= tot - 1) ? '0' : '';

      scheduleFetch(true);
    }

    var extNo = el('rc-tl-ext-no'); if (extNo) extNo.addEventListener('click', function () { toggleExt(false); });
    var extYes = el('rc-tl-ext-yes'); if (extYes) extYes.addEventListener('click', function () { toggleExt(true); });
    var ftExRange = el('rc-tl-ft-ex-range'); if (ftExRange) ftExRange.addEventListener('input', function () { onExerciseSlider(this.value); });
    var ftSlRange = el('rc-tl-ft-sl-range'); if (ftSlRange) ftSlRange.addEventListener('input', function () { onSubmissionSlider(this.value); });
    var ftExtRangeEl = el('rc-tl-ft-ext-range'); if (ftExtRangeEl) ftExtRangeEl.addEventListener('input', function () { onExtensionSlider(this.value); });

    /* ════════════════════════════════════════════════════
       TAB SWITCHER
    ════════════════════════════════════════════════════ */
    function switchTab(which) {
      var wv = el('rc-tl-view-walk'), fv = el('rc-tl-view-full');
      var tw = el('rc-tl-tab-walk'), tf = el('rc-tl-tab-full');
      if (which === 'full' && !fv) { return; } /* removed on mobile — nothing to switch to */
      if (which === 'walk') {
        if (wv) wv.classList.add('rc-tl__view-walk--active');
        if (fv) fv.classList.remove('rc-tl__view-full--active');
        if (tw) tw.classList.add('rc-tl__pill--on');
        if (tf) tf.classList.remove('rc-tl__pill--on');
        var hint = el('rc-tl-tab-hint');
        if (hint) hint.textContent = activeStage >= 0 ? 'Stage ' + (activeStage + 1) + ' of ' + stageTotal() : 'Stage 1 of ' + stageTotal();
        setTimeout(function () { var so = el('rc-tl-scroll-outer'); if (so) window.scrollTo({ top: so.offsetTop, behavior: 'smooth' }); }, 50);
      } else {
        if (fv) fv.classList.add('rc-tl__view-full--active');
        if (wv) wv.classList.remove('rc-tl__view-walk--active');
        if (tf) tf.classList.add('rc-tl__pill--on');
        if (tw) tw.classList.remove('rc-tl__pill--on');
        var hint2 = el('rc-tl-tab-hint');
        if (hint2) hint2.textContent = 'Full journey';
        buildMap();
        repaint();
        setTimeout(function () { if (fv) fv.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
      }
    }
    var tabWalk = el('rc-tl-tab-walk'); if (tabWalk) tabWalk.addEventListener('click', function () { switchTab('walk'); });
    var tabFull = el('rc-tl-tab-full'); if (tabFull) tabFull.addEventListener('click', function () { switchTab('full'); });
    var scViewBtn = el('rc-tl-sc-view-btn'); if (scViewBtn) scViewBtn.addEventListener('click', function () { switchTab('full'); });
    var walkEndBtn = el('rc-tl-walkend-viewfull-btn'); if (walkEndBtn) walkEndBtn.addEventListener('click', function () { switchTab('full'); });

    /* ════════════════════════════════════════════════════
       MODE SWITCH (Buying / Selling) — resets + resyncs the extension
       toggle, per the skill's gotcha (e).
    ════════════════════════════════════════════════════ */
    function setMode(mode, btn) {
      MODE = mode;
      showExt = false;
      document.querySelectorAll('.rc-tl__mode-pill').forEach(function (p) { p.classList.remove('rc-tl__mode-pill--on'); });
      if (btn) btn.classList.add('rc-tl__mode-pill--on');

      var fno = el('rc-tl-ext-no'), fyes = el('rc-tl-ext-yes');
      if (fno) fno.classList.add('rc-tl__ext-pill--on');
      if (fyes) fyes.classList.remove('rc-tl__ext-pill--on');
      var feeNote = el('rc-tl-ext-fee-note'); if (feeNote) feeNote.style.display = 'none';
      var ftExtCtrl = el('rc-tl-ft-ext-ctrl'); if (ftExtCtrl) ftExtCtrl.style.display = 'none';

      var vfKick = el('rc-tl-vf-kick');
      if (vfKick) vfKick.textContent = mode === 'b' ? "The buyer's full journey" : "The seller's full journey";
      var weKick = el('rc-tl-walk-end-kick');
      if (weKick) weKick.textContent = mode === 'b' ? "That's the buyer's journey" : "That's the seller's journey";

      activeStage = -1;
      latestStages = {}; /* clear stale-mode dates immediately so nothing wrong-mode is shown before the refetch lands */
      buildPanels(); buildSpine(); buildMap(); buildMobileCards();
      transitionToStage(0);
      if (!IS_MOBILE) { onScroll(); }
      scheduleFetch(true);
    }
    var modeB = el('rc-tl-mode-b'); if (modeB) modeB.addEventListener('click', function () { setMode('b', modeB); });
    var modeS = el('rc-tl-mode-s'); if (modeS) modeS.addEventListener('click', function () { setMode('s', modeS); });

    /* ════════════════════════════════════════════════════
       SEGMENTED ANCHOR-DATE INPUT + calendar popover
       (two synced instances: walkthrough topbar + full-timeline controls)
    ════════════════════════════════════════════════════ */
    var MO3 = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
    var MO_FULL = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var DOW3 = ['M','T','W','T','F','S','S'];
    var SEG_DATE = new Date();

    function sameSeg(a, b) { return a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); }

    function segCalendar(host, getD, setD) {
      var view = new Date(getD().getFullYear(), getD().getMonth(), 1);
      function cellH(d, mute) {
        var today = new Date();
        var cls = [mute ? 'rc-tl__cmute' : '', sameSeg(d, today) ? 'rc-tl__ctoday' : '', sameSeg(d, getD()) ? 'rc-tl__csel' : ''].filter(Boolean).join(' ');
        return '<button data-d="' + isoSeg(d) + '" class="' + cls + '">' + d.getDate() + '</button>';
      }
      function draw() {
        var y = view.getFullYear(), m = view.getMonth();
        var first = (new Date(y, m, 1).getDay() + 6) % 7, len = new Date(y, m + 1, 0).getDate(), plen = new Date(y, m, 0).getDate();
        var cells = '';
        for (var i = first - 1; i >= 0; i--) cells += cellH(new Date(y, m - 1, plen - i), true);
        for (var d = 1; d <= len; d++) cells += cellH(new Date(y, m, d), false);
        var rest = (7 - ((first + len) % 7)) % 7;
        for (var d2 = 1; d2 <= rest; d2++) cells += cellH(new Date(y, m + 1, d2), true);
        host.innerHTML = '<div class="rc-tl__cnav"><div class="rc-tl__mo">' + MO_FULL[m] + ' <span>' + y + '</span></div>' +
          '<div class="rc-tl__cnav-grp"><button data-s="-1"><svg viewBox="0 0 24 24"><path d="M15 4 7 12l8 8"/></svg></button>' +
          '<button data-s="1"><svg viewBox="0 0 24 24"><path d="M9 4l8 8-8 8"/></svg></button></div></div>' +
          '<div class="rc-tl__cdow">' + DOW3.map(function (d3) { return '<div>' + d3 + '</div>'; }).join('') + '</div>' +
          '<div class="rc-tl__cgrid">' + cells + '</div>' +
          '<div class="rc-tl__cfoot"><span>' + isoSeg(getD()) + '</span><button data-t="1">Today</button></div>';
        host.querySelectorAll('[data-s]').forEach(function (b) { b.onclick = function (e) { e.stopPropagation(); view = new Date(y, m + (+b.dataset.s), 1); draw(); }; });
        var todayBtn = host.querySelector('[data-t]');
        if (todayBtn) todayBtn.onclick = function (e) { e.stopPropagation(); var td = new Date(); view = new Date(td.getFullYear(), td.getMonth(), 1); setD(td); draw(); };
        host.querySelectorAll('[data-d]').forEach(function (b) {
          b.onclick = function (e) { e.stopPropagation(); var d3 = new Date(b.dataset.d + 'T00:00:00'); view = new Date(d3.getFullYear(), d3.getMonth(), 1); setD(d3); draw(); };
        });
      }
      return { draw: draw, goto: function (d) { view = new Date(d.getFullYear(), d.getMonth(), 1); draw(); } };
    }

    function setOTPDate(val) {
      if (!val) { otpDate = null; return; }
      var parts = val.split('-');
      otpDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      scheduleFetch(false);
    }

    function renderSegBoth() {
      [{ seg: 'rc-tl-seg-otp' }, { seg: 'rc-tl-seg-otp2' }, { seg: 'rc-tl-seg-otp-m' }].forEach(function (o) {
        var seg = el(o.seg);
        if (!seg) return;
        var dCell = seg.querySelector('[data-p="d"] .rc-tl__seg-v');
        var mCell = seg.querySelector('[data-p="m"] .rc-tl__seg-v');
        var yCell = seg.querySelector('[data-p="y"] .rc-tl__seg-v');
        if (dCell) dCell.textContent = String(SEG_DATE.getDate()).padStart(2, '0');
        if (mCell) mCell.textContent = MO3[SEG_DATE.getMonth()];
        if (yCell) yCell.textContent = SEG_DATE.getFullYear();
      });
      setOTPDate(isoSeg(SEG_DATE));
    }

    function bumpSeg(p, n) {
      var d = new Date(SEG_DATE);
      if (p === 'd') d.setDate(d.getDate() + n);
      if (p === 'm') d.setMonth(d.getMonth() + n);
      if (p === 'y') d.setFullYear(d.getFullYear() + n);
      SEG_DATE = d; renderSegBoth();
    }

    function buildDateSelector(segId, popId, calId) {
      var seg = el(segId), pop = el(popId), calBtn = el(calId);
      if (!seg || !pop || !calBtn) return;
      var cal = segCalendar(pop, function () { return SEG_DATE; }, function (d) { SEG_DATE = d; renderSegBoth(); cal.goto(d); cal.draw(); });
      var buf = '', bufT = 0;
      seg.querySelectorAll('.rc-tl__seg-cell').forEach(function (cell) {
        var p = cell.dataset.p;
        cell.addEventListener('pointerdown', function () { seg.querySelectorAll('.rc-tl__seg-cell').forEach(function (x) { x.classList.remove('rc-tl__seg-cell--on'); }); cell.classList.add('rc-tl__seg-cell--on'); cell.focus(); });
        cell.addEventListener('focus', function () { seg.querySelectorAll('.rc-tl__seg-cell').forEach(function (x) { x.classList.remove('rc-tl__seg-cell--on'); }); cell.classList.add('rc-tl__seg-cell--on'); });
        cell.addEventListener('blur', function () { cell.classList.remove('rc-tl__seg-cell--on'); });
        cell.addEventListener('wheel', function (e) { e.preventDefault(); bumpSeg(p, e.deltaY > 0 ? -1 : 1); }, { passive: false });
        cell.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowUp') { e.preventDefault(); bumpSeg(p, 1); }
          else if (e.key === 'ArrowDown') { e.preventDefault(); bumpSeg(p, -1); }
          else if (/^[0-9]$/.test(e.key)) {
            var now = Date.now(); buf = (now - bufT > 900 ? '' : buf) + e.key; bufT = now;
            var n = +buf, d = new Date(SEG_DATE);
            if (p === 'd' && n >= 1 && n <= 31) d.setDate(n);
            if (p === 'm' && n >= 1 && n <= 12) d.setMonth(n - 1);
            if (p === 'y' && buf.length === 4) d.setFullYear(n);
            SEG_DATE = d; renderSegBoth();
          }
        });
      });
      calBtn.onclick = function (e) { e.stopPropagation(); pop.classList.toggle('rc-tl__seg-pop--open'); cal.goto(SEG_DATE); cal.draw(); };
      document.addEventListener('click', function () { pop.classList.remove('rc-tl__seg-pop--open'); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') pop.classList.remove('rc-tl__seg-pop--open'); });
    }

    /* ════════════════════════════════════════════════════
       INIT
    ════════════════════════════════════════════════════ */
    buildDateSelector('rc-tl-seg-otp', 'rc-tl-pop-otp', 'rc-tl-cal-otp');
    buildDateSelector('rc-tl-seg-otp2', 'rc-tl-pop-otp2', 'rc-tl-cal-otp2');
    buildDateSelector('rc-tl-seg-otp-m', 'rc-tl-pop-otp-m', 'rc-tl-cal-otp-m');
    SEG_DATE = new Date();
    renderSegBoth();

    buildPanels();
    buildSpine();
    buildMap();
    buildMobileCards();
    transitionToStage(0);
    fetchDates(true); /* immediate first fetch — no debounce on initial load */
    if (!IS_MOBILE) { onScroll(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-new-launch"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* Shopify bundles every section's javascript tag into one shared
       <script> tag site-wide — if this section isn't on the current page,
       every el(id) below would be null and throw, killing every OTHER
       section's JS later in that same bundle. Bail out immediately. */
    if (!document.getElementById('rc-tln-tab-walk')) return;

    /* ── Mobile strip: Full Timeline tab + markup removed entirely below 768px,
       and the desktop sticky spine+detail walkthrough is swapped for the
       mobile card-stack walkthrough. Checked once on load only — not on
       resize (28 Jul 2026 decision, extended 11 Sep 2026). ── */
    var IS_MOBILE = window.innerWidth < 768;
    if (IS_MOBILE) {
      var vf0 = document.getElementById('rc-tln-view-full');
      if (vf0) { vf0.remove(); }
      var tf0 = document.getElementById('rc-tln-tab-full');
      if (tf0) { tf0.remove(); }
      var svb0 = document.getElementById('rc-tln-sc-view-btn');
      if (svb0) { svb0.remove(); }
      var so0 = document.getElementById('rc-tln-scroll-outer');
      if (so0) { so0.remove(); }
    } else {
      var mw0 = document.getElementById('rc-tln-m-wrap');
      if (mw0) { mw0.remove(); }
    }

    /* Shopify does NOT run Liquid inside the javascript tag — it's compiled as a
       shared static asset across every instance of this section, site-wide.
       Read customizer settings from data-* attributes on the root element
       (which IS Liquid-rendered, since it's regular HTML) instead. */
    var rootEl = document.getElementById('rc-tln-tab-walk').closest('.rc-tl');
    var CFG = {
      showCosts: rootEl.dataset.showCosts !== 'false'
    };
    var ENDPOINT = 'https://api.roncasa.co/calc/timeline-dates';
    var DEBOUNCE_MS = 300;
    var fetchTimer = null;

    function el(id) { return document.getElementById(id); }

    /* ════════════════════════════════════════════════════
       STAGE DATA — copy/costs ported ~verbatim from source. Single flat
       flow, 5 stages, OTP Granted through Completion of Sale. No "tip"
       field exists in the source for any stage — none invented here.
    ════════════════════════════════════════════════════ */
    var D = [
      {n:"01",t:"OTP Granted",sub:"Pay 5% downpayment",
       desc:"Grant/receive the Option to Purchase and pay the 5% booking fee. Select your loan package and start arranging your mortgage now. Your developer must furnish the Sale &amp; Purchase Agreement (S&amp;P) within 14 days of this date.",
       cost:"5%",costL:"Booking Fee",wait:"Up to 14 days",waitL:"To Receive S&amp;P"},
      {n:"02",t:"Receive S&amp;P",sub:"Sale &amp; Purchase Agreement",
       desc:"Your developer prepares and passes you the Sale &amp; Purchase Agreement (S&amp;P), within 14 days of OTP by law, though it sometimes arrives sooner. From here, you have up to 3 weeks to exercise it at the law firm.",
       cost:"—",costL:"Payment Due",wait:"Up to 21 days",waitL:"To Exercise",
       hasExSlider:true},
      {n:"03",t:"Exercise S&amp;P at Law Firm",sub:"Sign, pay legal fees",
       desc:"Sign your mortgage documents and pay your legal fees. If you're paying the 15% balance by CPF, you'll also sign CPF withdrawal forms here. Your lawyer submits them to the CPF Board, which auto-disburses the 15% at the 8-week mark from today. If paying cash, nothing further is due yet; your lawyer will contact you closer to that 8-week mark to arrange the transfer. The only payments due right now are Buyer's Stamp Duty (BSD), and legal fees.",
       cost:"Legal Fees",costL:"Also Due Now",wait:"14 days",waitL:"BSD Due By",
       hasSlider:true},
      {n:"04",t:"BSD Payable",sub:"Buyer's / Additional Buyer's Stamp Duty",
       desc:"Buyer's Stamp Duty (and ABSD, if it applies to you) is due exactly 14 days after signing. This is set by law, not something a buyer or lawyer can move.",
       cost:"Tiered",costL:"BSD/ABSD Rate",wait:"6 wks",waitL:"To Completion"},
      {n:"05",t:"Completion of Sale",sub:"Remaining 15% downpayment",
       desc:"The remaining 15% reaches the developer now, fixed at 8 weeks after signing. If you're on CPF, the CPF Board auto-transfers the 15% from your Ordinary Account; if paying cash, you'll have transferred funds or dropped off a cashier's order a few days beforehand, per your lawyer's instructions. 20% is paid in total by now. If you're taking a loan (e.g. 75%), disbursement starts from here: if not, the balance is called directly, and the progressive payment schedule below begins ticking from Foundation.",
       cost:"15%",costL:"Remaining Down",wait:"20% total",waitL:"Paid By Now"}
    ];

    /* ════════════════════════════════════════════════════
       STATE — two adjustable windows, no mode split, no extension.
       - otpToSPDays: OTP → Receive S&P (7–14, statutory ceiling 14 days).
         Slider lives on the Receive S&P stage card (hasExSlider).
       - spToExerciseDays: Receive S&P → Exercise at law firm (7–21,
         statutory ceiling 21 days). Slider lives on the Exercise stage
         card itself (hasSlider).
       BSD (14 days after Exercise) and Completion (42 days after BSD) are
       both fixed/statutory — no sliders on either.
    ════════════════════════════════════════════════════ */
    var otpToSPDays = 14;
    var spToExerciseDays = 21;
    var activeStage = -1;
    var EX_GAP_IDX = 0;   /* gaps[0] — OTP → Receive S&P, adjustable */
    var SUB_GAP_IDX = 1;  /* gaps[1] — Receive S&P → Exercise, adjustable */

    /* Latest data from the Worker — gaps array + per-stage-index dates.
       Never computed locally; only ever assigned from a fetch response.
       Unlike HDB Resale, stage index 0 DOES carry a date (the anchor
       itself — OTP Granted date). */
    var latestGaps = [];
    var latestStages = {};
    var latestTotalDays = 0;
    var anchorDate = null; /* Date object — anchor date, local echo of SEG_DATE for display fallback */

    function visibleStages() { return D; }
    function stageTotal() { return D.length; }

    /* ════════════════════════════════════════════════════
       WORKER FETCH — the only place stage dates / day-gaps come from
    ════════════════════════════════════════════════════ */
    function isoSeg(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }

    function buildEndpointUrl() {
      var p = new URLSearchParams();
      p.set('tool', 'new-launch-purchase');
      p.set('anchor', anchorDate ? isoSeg(anchorDate) : isoSeg(new Date()));
      p.set('otp_to_sp_days', otpToSPDays);
      p.set('sp_to_exercise_days', spToExerciseDays);
      return ENDPOINT + '?' + p.toString();
    }

    function parseStageDates(raw) {
      var out = {};
      if (!raw) return out;
      Object.keys(raw).forEach(function (k) {
        var parts = raw[k].split('-');
        out[k] = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      });
      return out;
    }

    function fetchDates(rebuildAfter) {
      fetch(buildEndpointUrl())
        .then(function (r) { return r.json(); })
        .then(function (data) {
          latestGaps = data.gaps || [];
          latestStages = parseStageDates(data.stages);
          latestTotalDays = data.total_days || 0;
          if (rebuildAfter) {
            var rebuiltTarget = Math.min(Math.max(activeStage, 0), stageTotal() - 1);
            buildPanels(); buildSpine(); buildMap(); buildMobileCards();
            /* buildPanels() replaces every .rc-tl__sp node, so the previously-active
               panel's element is gone — force re-activation even if the target index
               is unchanged, or transitionToStage's idx===activeStage guard skips it
               and every panel stays at opacity:0. */
            activeStage = -1;
            transitionToStage(rebuiltTarget);
          }
          repaint();
        })
        .catch(function () { /* leave previous state — don't blank the UI on a transient failure */ });
    }

    function scheduleFetch(rebuildAfter) {
      clearTimeout(fetchTimer);
      fetchTimer = setTimeout(function () { fetchDates(rebuildAfter); }, DEBOUNCE_MS);
    }

    /* Optimistic local patch of a single gap slot — a direct assignment of the
       raw slider value already known to the browser, not a recomputed date
       cascade — so the spine/map reposition instantly while dates catch up
       once the debounced fetch resolves. */
    function patchGap(idx, val) {
      if (idx >= 0 && idx < latestGaps.length) { latestGaps[idx] = val; }
    }

    /* ════════════════════════════════════════════════════
       PROPORTIONAL POSITIONS — layout math, stays client-side (uses latestGaps)
    ════════════════════════════════════════════════════ */
    function spinePositions() {
      var gaps = latestGaps.length ? latestGaps : visibleStages().slice(0, -1).map(function () { return 1; });
      var tot = gaps.reduce(function (a, b) { return a + b; }, 0) || 1;
      var pos = [0]; var c = 0;
      for (var i = 0; i < gaps.length; i++) { c += gaps[i]; pos.push(c / tot * 100); }
      var MIN_GAP = 9;
      for (var j = 1; j < pos.length; j++) { if (pos[j] < pos[j - 1] + MIN_GAP) { pos[j] = pos[j - 1] + MIN_GAP; } }
      if (pos[pos.length - 1] > 100) {
        var scale = 100 / pos[pos.length - 1];
        for (var k = 0; k < pos.length; k++) { pos[k] = pos[k] * scale; }
      }
      return pos;
    }

    function mapPositions() {
      var gaps = latestGaps.length ? latestGaps.slice() : visibleStages().slice(0, -1).map(function () { return 1; });
      var tot = gaps.reduce(function (a, b) { return a + b; }, 0) || 1;
      var pL = 5, span = 90;
      var pos = [pL]; var c = 0;
      for (var i = 0; i < gaps.length; i++) { c += gaps[i]; pos.push(pL + span * (c / tot)); }
      return pos;
    }

    function gapText(i) {
      if (latestGaps[i] !== undefined) { return latestGaps[i] + ' days'; }
      return '';
    }

    /* ════════════════════════════════════════════════════
       LEFT SPINE
    ════════════════════════════════════════════════════ */
    function buildSpine() {
      var track = el('rc-tln-spine-track');
      if (!track) return;
      track.querySelectorAll('.rc-tl__tick-row,.rc-tl__tick-dur').forEach(function (n) { n.remove(); });
      var data = visibleStages();
      var pos = spinePositions();
      data.forEach(function (s, i) {
        var row = document.createElement('div');
        row.className = 'rc-tl__tick-row';
        row.id = 'rc-tln-tr-' + i;
        row.style.top = pos[i] + '%';
        row.innerHTML = '<span class="rc-tl__tnum">' + s.n + '</span>' +
          '<span class="rc-tl__tdot"></span>' +
          '<div class="rc-tl__tright"><span class="rc-tl__tdate" id="rc-tln-trdate-' + i + '"></span><span class="rc-tl__ttext">' + s.t + '</span></div>';
        row.addEventListener('click', function () { jumpToStage(i); });
        track.appendChild(row);

        if (i < data.length - 1) {
          var midPct = (pos[i] + pos[i + 1]) / 2;
          var dur = document.createElement('div');
          dur.className = 'rc-tl__tick-dur';
          dur.id = 'rc-tln-td-' + i;
          dur.style.top = midPct + '%';
          dur.textContent = gapText(i);
          track.appendChild(dur);
        }
      });
    }

    function updateSpineFill(stageIdx) {
      var pos = spinePositions();
      var fill = el('rc-tln-spine-fill');
      if (fill) { fill.style.height = pos[stageIdx] + '%'; }
    }

    function updateSpinePositions() {
      var pos = spinePositions();
      var data = visibleStages();
      data.forEach(function (s, i) {
        var row = el('rc-tln-tr-' + i);
        if (row) { row.style.top = pos[i] + '%'; }
        var dur = el('rc-tln-td-' + i);
        if (dur) {
          var midPct = (pos[i] + (pos[i + 1] !== undefined ? pos[i + 1] : pos[i])) / 2;
          dur.style.top = midPct + '%';
          var txt = gapText(i);
          if (txt) { dur.textContent = txt; }
        }
      });
      if (activeStage >= 0) { updateSpineFill(activeStage); }
    }

    /* ════════════════════════════════════════════════════
       STAGE PANELS
    ════════════════════════════════════════════════════ */
    /* Shared body-content generator — used by BOTH buildPanels() (desktop
       panel, sfx='') and buildMobileCards() (mobile card, sfx='-m'), same
       reasoning as the HDB Resale sibling. */
    function renderStageBody(s, i, sfx) {
      var exSliderHTML = '';
      if (s.hasExSlider) {
        var rspPct = ((otpToSPDays - 7) / (14 - 7) * 100).toFixed(1);
        exSliderHTML = '<div class="rc-tl__sp-slider"><span class="rc-tl__sl-eye">Days, OTP to Receive S&amp;P (up to 14 days, statutory)</span>' +
          '<div class="rc-tl__sl-pill"><div class="rc-tl__sl-fill" id="rc-tln-rsp-fill' + sfx + '" style="width:' + rspPct + '%">' +
          '<span class="rc-tl__sl-fill-txt" id="rc-tln-rsp-num' + sfx + '">' + otpToSPDays + ' days</span><span class="rc-tl__sl-handle"></span></div>' +
          '<span class="rc-tl__sl-pill-max">14 max</span>' +
          '<input type="range" class="rc-tl__sl-range" id="rc-tln-rsp-range' + sfx + '" min="7" max="14" value="' + otpToSPDays + '"/></div></div>';
      }

      var sliderHTML = '';
      if (s.hasSlider) {
        var lfPct = ((spToExerciseDays - 7) / (21 - 7) * 100).toFixed(1);
        sliderHTML = '<div class="rc-tl__sp-slider"><span class="rc-tl__sl-eye">Days, Receive S&amp;P to Exercise at Law Firm (up to 21 days, statutory)</span>' +
          '<div class="rc-tl__sl-pill"><div class="rc-tl__sl-fill" id="rc-tln-lf-fill' + sfx + '" style="width:' + lfPct + '%">' +
          '<span class="rc-tl__sl-fill-txt" id="rc-tln-lf-num' + sfx + '">' + spToExerciseDays + ' days</span><span class="rc-tl__sl-handle"></span></div>' +
          '<span class="rc-tl__sl-pill-max">21 max</span>' +
          '<input type="range" class="rc-tl__sl-range" id="rc-tln-lf-range' + sfx + '" min="7" max="21" value="' + spToExerciseDays + '"/></div></div>';
      }

      return {
        chips: CFG.showCosts ? ('<div class="rc-tl__sp-chips"><div class="rc-tl__sp-chip"><div class="rc-tl__cl">' + s.costL + '</div><div class="rc-tl__cv">' + s.cost + '</div></div>' +
          '<div class="rc-tl__sp-chip"><div class="rc-tl__cl">' + s.waitL + '</div><div class="rc-tl__cv">' + s.wait + '</div></div></div>') : '',
        controls: exSliderHTML + sliderHTML
      };
    }

    function buildPanels() {
      var wrap = el('rc-tln-detail-wrap');
      if (!wrap) return;
      wrap.innerHTML = '';
      var data = visibleStages();
      var total = data.length;
      var totalStr = (total < 10 ? '0' : '') + total;

      data.forEach(function (s, i) {
        var body = renderStageBody(s, i, '');
        var panel = document.createElement('div');
        panel.className = 'rc-tl__sp';
        panel.id = 'rc-tln-sp-' + i;
        panel.innerHTML =
          '<div class="rc-tl__sp-num">Stage <span>' + s.n + '</span> / ' + totalStr + '</div>' +
          '<div class="rc-tl__sp-name">' + s.t + '</div>' +
          '<div class="rc-tl__sp-sub">' + s.sub + '</div>' +
          '<div class="rc-tl__sp-stage-date" id="rc-tln-spdate-' + i + '"></div>' +
          '<div class="rc-tl__sp-desc">' + s.desc + '</div>' +
          body.chips + body.controls;
        wrap.appendChild(panel);
      });

      bindPanelControls('');
    }

    /* Mobile card-stack walkthrough — see header comment. */
    function buildMobileCards() {
      var wrap = el('rc-tln-m-stages');
      if (!wrap) return;
      wrap.innerHTML = '';
      var data = visibleStages();
      var total = data.length;
      var totalStr = (total < 10 ? '0' : '') + total;

      data.forEach(function (s, i) {
        var body = renderStageBody(s, i, '-m');
        var row = document.createElement('div');
        row.className = 'rc-tl__m-card-wrap';
        row.id = 'rc-tln-m-row-' + i;
        row.innerHTML = '<div class="rc-tl__m-dot"></div><div class="rc-tl__m-card">' +
          '<div class="rc-tl__m-num">Stage ' + s.n + ' / ' + totalStr + '</div>' +
          '<h3>' + s.t + '</h3>' +
          '<div class="rc-tl__m-sub">' + s.sub + '</div>' +
          '<div class="rc-tl__m-date" id="rc-tln-mdate-' + i + '"></div>' +
          '<div class="rc-tl__m-desc">' + s.desc + '</div>' +
          body.chips + body.controls +
          '</div>';
        wrap.appendChild(row);
      });

      bindPanelControls('-m');
      initMobileObserver();
    }

    function initMobileObserver() {
      var rows = Array.prototype.slice.call(document.querySelectorAll('.rc-tl__m-card-wrap'));
      var fill = el('rc-tln-m-fill');
      if (!rows.length || !fill) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('rc-tl__m-in'); } });
      }, { rootMargin: '0px 0px -15% 0px', threshold: 0.1 });
      rows.forEach(function (r) { io.observe(r); });

      function updateFill() {
        if (rows.length < 2) return;
        var track = document.querySelector('.rc-tl__m-track');
        var firstDot = rows[0].querySelector('.rc-tl__m-dot'), lastDot = rows[rows.length - 1].querySelector('.rc-tl__m-dot');
        if (!track || !firstDot || !lastDot) return;
        var first = firstDot.getBoundingClientRect(), last = lastDot.getBoundingClientRect();
        var mid = window.innerHeight * 0.5;
        var total = last.top - first.top;
        if (!total) return;
        var p = Math.max(0, Math.min(1, (mid - first.top) / total));
        fill.style.height = Math.max(0, (last.top - track.getBoundingClientRect().top) * p) + 'px';
      }
      var tickingM = false;
      window.addEventListener('scroll', function () {
        if (!tickingM) { requestAnimationFrame(function () { updateFill(); tickingM = false; }); tickingM = true; }
      }, { passive: true });
      window.addEventListener('resize', updateFill);
      updateFill();
    }

    function bindPanelControls(sfx) {
      sfx = sfx || '';
      var exRange = el('rc-tln-rsp-range' + sfx);
      if (exRange) { exRange.addEventListener('input', function () { onExSlider(this.value); }); }
      var slRange = el('rc-tln-lf-range' + sfx);
      if (slRange) { slRange.addEventListener('input', function () { onSubSlider(this.value); }); }
    }

    /* ════════════════════════════════════════════════════
       TRANSITION TO STAGE
    ════════════════════════════════════════════════════ */
    function transitionToStage(idx) {
      if (idx === activeStage) { return; }
      if (activeStage >= 0) {
        var oldP = el('rc-tln-sp-' + activeStage); if (oldP) { oldP.classList.remove('rc-tl__sp--active'); }
        var oldT = el('rc-tln-tr-' + activeStage); if (oldT) { oldT.classList.remove('rc-tl__tick-row--active'); }
      }
      for (var j = 0; j < idx; j++) { var dT = el('rc-tln-tr-' + j); if (dT) { dT.classList.add('rc-tl__tick-row--done'); } }
      var panel = el('rc-tln-sp-' + idx); if (panel) { panel.classList.add('rc-tl__sp--active'); }
      var tick = el('rc-tln-tr-' + idx); if (tick) { tick.classList.remove('rc-tl__tick-row--done'); tick.classList.add('rc-tl__tick-row--active'); }
      var ghost = el('rc-tln-ghost-num');
      if (ghost) {
        ghost.classList.remove('rc-tl__ghost-num--pop'); void ghost.offsetWidth;
        ghost.textContent = visibleStages()[idx] ? visibleStages()[idx].n : String(idx + 1);
        ghost.classList.add('rc-tl__ghost-num--pop');
      }
      var tot = stageTotal(); var totS = (tot < 10 ? '0' : '') + tot;
      var sN = visibleStages()[idx] ? visibleStages()[idx].n : String(idx + 1);
      var sc = el('rc-tln-stage-counter'); if (sc) { sc.innerHTML = '<b>' + sN + '</b> / ' + totS; }
      var hint = el('rc-tln-tab-hint'); if (hint) { hint.textContent = 'Stage ' + (idx + 1) + ' of ' + tot; }
      updateSpineFill(idx);
      activeStage = idx;
      var cue = el('rc-tln-scroll-cue');
      if (cue) { cue.style.opacity = idx >= stageTotal() - 1 ? '0' : ''; }
    }

    /* ════════════════════════════════════════════════════
       SCROLL LOGIC
    ════════════════════════════════════════════════════ */
    function getProgress() {
      var outer = el('rc-tln-scroll-outer');
      if (!outer || outer.offsetHeight === 0) { return 0; }
      var rect = outer.getBoundingClientRect();
      var scrolled = Math.max(0, -rect.top);
      var total = Math.max(1, outer.offsetHeight - window.innerHeight);
      return Math.min(1, scrolled / total);
    }

    function onScroll() {
      var wv = el('rc-tln-view-walk');
      if (!wv || !wv.classList.contains('rc-tl__view-walk--active')) { return; }
      var p = getProgress();
      var pf = el('rc-tln-prog-fill'); if (pf) { pf.style.height = (p * 100) + '%'; }
      var N = stageTotal();
      var idx = Math.min(N - 1, Math.floor(p * N));
      transitionToStage(idx);
    }

    var ticking = false;
    if (!IS_MOBILE) {
      window.addEventListener('scroll', function () {
        if (!ticking) { requestAnimationFrame(function () { onScroll(); ticking = false; }); ticking = true; }
      }, { passive: true });
      window.addEventListener('resize', onScroll);
    }

    function jumpToStage(i) {
      var outer = el('rc-tln-scroll-outer');
      if (!outer) return;
      var N = stageTotal();
      var targetP = N > 1 ? i / (N - 1) : 0;
      var total = outer.offsetHeight - window.innerHeight;
      window.scrollTo({ top: outer.offsetTop + targetP * total, behavior: 'smooth' });
    }

    /* ════════════════════════════════════════════════════
       SLIDERS
    ════════════════════════════════════════════════════ */
    function onExSlider(val) {
      otpToSPDays = parseInt(val, 10);
      var f = el('rc-tln-rsp-fill'), n = el('rc-tln-rsp-num');
      var pct = (otpToSPDays - 7) / (14 - 7) * 100;
      if (f) f.style.width = pct + '%';
      if (n) n.textContent = otpToSPDays + ' days';
      var mf = el('rc-tln-rsp-fill-m'), mn = el('rc-tln-rsp-num-m'), mr = el('rc-tln-rsp-range-m');
      if (mf) mf.style.width = pct + '%';
      if (mn) mn.textContent = otpToSPDays + ' days';
      if (mr) mr.value = otpToSPDays;
      var ftf = el('rc-tln-ft-rsp-fill'), ftn = el('rc-tln-ft-rsp-num'), ftr = el('rc-tln-ft-rsp-range');
      if (ftf) ftf.style.width = pct + '%';
      if (ftn) ftn.textContent = otpToSPDays + ' days';
      if (ftr) ftr.value = otpToSPDays;
      patchGap(EX_GAP_IDX, otpToSPDays);
      updateSpinePositions(); updateMapPositions();
      scheduleFetch(false);
    }

    function onSubSlider(val) {
      spToExerciseDays = parseInt(val, 10);
      var f = el('rc-tln-lf-fill'), n = el('rc-tln-lf-num');
      var pct = (spToExerciseDays - 7) / (21 - 7) * 100;
      if (f) f.style.width = pct + '%';
      if (n) n.textContent = spToExerciseDays + ' days';
      var mf2 = el('rc-tln-lf-fill-m'), mn2 = el('rc-tln-lf-num-m'), mr2 = el('rc-tln-lf-range-m');
      if (mf2) mf2.style.width = pct + '%';
      if (mn2) mn2.textContent = spToExerciseDays + ' days';
      if (mr2) mr2.value = spToExerciseDays;
      var ftf = el('rc-tln-ft-lf-fill'), ftn = el('rc-tln-ft-lf-num'), ftr = el('rc-tln-ft-lf-range');
      if (ftf) ftf.style.width = pct + '%';
      if (ftn) ftn.textContent = spToExerciseDays + ' days';
      if (ftr) ftr.value = spToExerciseDays;
      patchGap(SUB_GAP_IDX, spToExerciseDays);
      updateSpinePositions(); updateMapPositions();
      scheduleFetch(false);
    }

    var ftExRange = el('rc-tln-ft-rsp-range'); if (ftExRange) ftExRange.addEventListener('input', function () { onExSlider(this.value); });
    var ftSlRange = el('rc-tln-ft-lf-range'); if (ftSlRange) ftSlRange.addEventListener('input', function () { onSubSlider(this.value); });

    /* ════════════════════════════════════════════════════
       HORIZONTAL MAP
    ════════════════════════════════════════════════════ */
    function buildMap() {
      var h = el('rc-tln-horiz');
      if (!h) { buildVertMap(); return; }
      h.querySelectorAll('.rc-tl__hn,.rc-tl__hl,.rc-tl__hgap').forEach(function (n) { n.remove(); });
      var pos = mapPositions();
      var data = visibleStages();
      var N = data.length;

      data.forEach(function (s, i) {
        var xi = pos[i];
        var term = (i === N - 1);
        var nd = document.createElement('div');
        nd.className = 'rc-tl__hn' + (term ? ' rc-tl__hn--term' : '');
        nd.style.left = xi + '%';
        nd.id = 'rc-tln-hn-' + i;
        nd.addEventListener('click', (function (idx) { return function () { switchTab('walk'); setTimeout(function () { jumpToStage(idx); }, 100); }; })(i));
        h.appendChild(nd);

        var up = (i % 2 === 0);
        var showCost = CFG.showCosts && s.cost && s.cost !== '—' && s.cost.charAt(0) !== '+';
        var lb = document.createElement('div');
        lb.className = 'rc-tl__hl ' + (up ? 'rc-tl__hl--up' : 'rc-tl__hl--dn');
        lb.style.left = xi + '%';
        lb.id = 'rc-tln-hl-' + i;
        lb.innerHTML = '<div class="rc-tl__tick"></div><div class="rc-tl__hln">' + s.n + '</div><div class="rc-tl__hlt">' + s.t + '</div>' + (showCost ? '<div class="rc-tl__hlc">' + s.cost + '</div>' : '') + '<div class="rc-tl__hldate" id="rc-tln-hldate-' + i + '"></div>';
        h.appendChild(lb);

        var tooClose = (i < pos.length - 1 && Math.abs(pos[i + 1] - pos[i]) < 4);
        if (!tooClose && i < N - 1) {
          var gp = document.createElement('div');
          gp.className = 'rc-tl__hgap';
          gp.id = 'rc-tln-hgap-' + i;
          gp.style.left = ((xi + pos[i + 1]) / 2) + '%';
          gp.textContent = gapText(i);
          h.appendChild(gp);
        }
      });

      buildVertMap();
    }

    function updateMapPositions() {
      var pos = mapPositions();
      pos.forEach(function (p, i) {
        var nd = el('rc-tln-hn-' + i); var lb = el('rc-tln-hl-' + i);
        if (nd) nd.style.left = p + '%';
        if (lb) lb.style.left = p + '%';
      });
      for (var i = 0; i < pos.length - 1; i++) {
        var gp = el('rc-tln-hgap-' + i);
        if (gp) { gp.style.left = ((pos[i] + pos[i + 1]) / 2) + '%'; var t = gapText(i); if (t) gp.textContent = t; }
      }
      var vgEx = el('rc-tln-vgap-ex'); if (vgEx) { var gpEx = vgEx.querySelector('.rc-tl__gpill'); if (gpEx) gpEx.textContent = otpToSPDays + ' days'; }
      var vgSub = el('rc-tln-vgap-sub'); if (vgSub) { var gpSub = vgSub.querySelector('.rc-tl__gpill'); if (gpSub) gpSub.textContent = spToExerciseDays + ' days'; }
    }

    function buildVertMap() {
      var v = el('rc-tln-vert');
      if (!v) return;
      v.innerHTML = '<div class="rc-tl__vspine"></div>';
      var data = visibleStages();
      data.forEach(function (s, i) {
        var term = (i === data.length - 1);
        var showCost = CFG.showCosts && s.cost && s.cost !== '—' && s.cost.charAt(0) !== '+';
        var row = document.createElement('div');
        row.className = 'rc-tl__vrow' + (term ? ' rc-tl__vrow--term' : '');
        row.innerHTML = '<div class="rc-tl__vnode"></div><div class="rc-tl__vnum">' + s.n + '</div><div class="rc-tl__vt">' + s.t + '</div>' + (showCost ? '<div class="rc-tl__vc">' + s.cost + '</div>' : '');
        row.addEventListener('click', (function (idx) { return function () { switchTab('walk'); setTimeout(function () { jumpToStage(idx); }, 100); }; })(i));
        v.appendChild(row);

        if (i < data.length - 1) {
          var isExGap = (i === EX_GAP_IDX), isSubGap = (i === SUB_GAP_IDX);
          var gv = document.createElement('div');
          gv.className = 'rc-tl__vgap';
          if (isExGap) gv.id = 'rc-tln-vgap-ex';
          if (isSubGap) gv.id = 'rc-tln-vgap-sub';
          gv.innerHTML = '<span class="rc-tl__gpill">' + gapText(i) + '</span>';
          v.appendChild(gv);
        }
      });
    }

    /* ════════════════════════════════════════════════════
       DATE LABELS — driven entirely by latestStages (from the Worker).
       Stage index 0 (OTP Granted) DOES carry a date here.
    ════════════════════════════════════════════════════ */
    function fmtDate(d) {
      if (!d) return '';
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
    }

    function repaint() {
      var data = visibleStages();
      /* Gap/duration labels */
      data.forEach(function (s, i) {
        var dur = el('rc-tln-td-' + i);
        if (dur) { var t = gapText(i); if (t) dur.textContent = t; }
      });
      /* Date labels — looped unconditionally, independent of whether a gap
         label exists, so the LAST visible stage (which has no trailing gap)
         still gets its own date. */
      data.forEach(function (s, i) {
        var trDE = el('rc-tln-trdate-' + i);
        if (trDE) { trDE.textContent = latestStages[i] ? fmtDate(latestStages[i]) : ''; }
      });
      data.forEach(function (s, i) {
        var dateEl = el('rc-tln-spdate-' + i);
        if (!dateEl) return;
        var d = latestStages[i];
        if (d) { dateEl.textContent = fmtDate(d); dateEl.style.display = 'block'; }
        else { dateEl.style.display = 'none'; }
      });
      data.forEach(function (s, i) {
        var mdateEl = el('rc-tln-mdate-' + i);
        if (!mdateEl) return;
        var d2 = latestStages[i];
        if (d2) { mdateEl.textContent = fmtDate(d2); mdateEl.style.display = 'block'; }
        else { mdateEl.style.display = 'none'; }
      });
      data.forEach(function (s, i) {
        var ld = el('rc-tln-hldate-' + i);
        if (ld) { ld.textContent = latestStages[i] ? fmtDate(latestStages[i]) : ''; }
      });
      updateSpinePositions();
      updateMapPositions();
    }

    /* ════════════════════════════════════════════════════
       TAB SWITCHER
    ════════════════════════════════════════════════════ */
    function switchTab(which) {
      var wv = el('rc-tln-view-walk'), fv = el('rc-tln-view-full');
      var tw = el('rc-tln-tab-walk'), tf = el('rc-tln-tab-full');
      if (which === 'full' && !fv) { return; } /* removed on mobile — nothing to switch to */
      if (which === 'walk') {
        if (wv) wv.classList.add('rc-tl__view-walk--active');
        if (fv) fv.classList.remove('rc-tl__view-full--active');
        if (tw) tw.classList.add('rc-tl__pill--on');
        if (tf) tf.classList.remove('rc-tl__pill--on');
        var hint = el('rc-tln-tab-hint');
        if (hint) hint.textContent = activeStage >= 0 ? 'Stage ' + (activeStage + 1) + ' of ' + stageTotal() : 'Stage 1 of ' + stageTotal();
        setTimeout(function () { var so = el('rc-tln-scroll-outer'); if (so) window.scrollTo({ top: so.offsetTop, behavior: 'smooth' }); }, 50);
      } else {
        if (fv) fv.classList.add('rc-tl__view-full--active');
        if (wv) wv.classList.remove('rc-tl__view-walk--active');
        if (tf) tf.classList.add('rc-tl__pill--on');
        if (tw) tw.classList.remove('rc-tl__pill--on');
        var hint2 = el('rc-tln-tab-hint');
        if (hint2) hint2.textContent = 'Full journey';
        buildMap();
        repaint();
        setTimeout(function () { if (fv) fv.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
      }
    }
    var tabWalk = el('rc-tln-tab-walk'); if (tabWalk) tabWalk.addEventListener('click', function () { switchTab('walk'); });
    var tabFull = el('rc-tln-tab-full'); if (tabFull) tabFull.addEventListener('click', function () { switchTab('full'); });
    var scViewBtn = el('rc-tln-sc-view-btn'); if (scViewBtn) scViewBtn.addEventListener('click', function () { switchTab('full'); });
    var walkendProgBtn = el('rc-tln-walkend-prog-btn');
    if (walkendProgBtn) walkendProgBtn.addEventListener('click', function () { var ps = el('rc-tln-prog-sec'); if (ps) ps.scrollIntoView({ behavior: 'smooth' }); });

    /* ════════════════════════════════════════════════════
       SEGMENTED ANCHOR-DATE INPUT + calendar popover
       (two synced instances: walkthrough topbar + full-timeline controls)
    ════════════════════════════════════════════════════ */
    var MO3 = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
    var MO_FULL = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var DOW3 = ['M','T','W','T','F','S','S'];
    var SEG_DATE = new Date();

    function sameSeg(a, b) { return a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); }

    function segCalendar(host, getD, setD) {
      var view = new Date(getD().getFullYear(), getD().getMonth(), 1);
      function cellH(d, mute) {
        var today = new Date();
        var cls = [mute ? 'rc-tl__cmute' : '', sameSeg(d, today) ? 'rc-tl__ctoday' : '', sameSeg(d, getD()) ? 'rc-tl__csel' : ''].filter(Boolean).join(' ');
        return '<button data-d="' + isoSeg(d) + '" class="' + cls + '">' + d.getDate() + '</button>';
      }
      function draw() {
        var y = view.getFullYear(), m = view.getMonth();
        var first = (new Date(y, m, 1).getDay() + 6) % 7, len = new Date(y, m + 1, 0).getDate(), plen = new Date(y, m, 0).getDate();
        var cells = '';
        for (var i = first - 1; i >= 0; i--) cells += cellH(new Date(y, m - 1, plen - i), true);
        for (var d = 1; d <= len; d++) cells += cellH(new Date(y, m, d), false);
        var rest = (7 - ((first + len) % 7)) % 7;
        for (var d2 = 1; d2 <= rest; d2++) cells += cellH(new Date(y, m + 1, d2), true);
        host.innerHTML = '<div class="rc-tl__cnav"><div class="rc-tl__mo">' + MO_FULL[m] + ' <span>' + y + '</span></div>' +
          '<div class="rc-tl__cnav-grp"><button data-s="-1"><svg viewBox="0 0 24 24"><path d="M15 4 7 12l8 8"/></svg></button>' +
          '<button data-s="1"><svg viewBox="0 0 24 24"><path d="M9 4l8 8-8 8"/></svg></button></div></div>' +
          '<div class="rc-tl__cdow">' + DOW3.map(function (d3) { return '<div>' + d3 + '</div>'; }).join('') + '</div>' +
          '<div class="rc-tl__cgrid">' + cells + '</div>' +
          '<div class="rc-tl__cfoot"><span>' + isoSeg(getD()) + '</span><button data-t="1">Today</button></div>';
        host.querySelectorAll('[data-s]').forEach(function (b) { b.onclick = function (e) { e.stopPropagation(); view = new Date(y, m + (+b.dataset.s), 1); draw(); }; });
        var todayBtn = host.querySelector('[data-t]');
        if (todayBtn) todayBtn.onclick = function (e) { e.stopPropagation(); var td = new Date(); view = new Date(td.getFullYear(), td.getMonth(), 1); setD(td); draw(); };
        host.querySelectorAll('[data-d]').forEach(function (b) {
          b.onclick = function (e) { e.stopPropagation(); var d3 = new Date(b.dataset.d + 'T00:00:00'); view = new Date(d3.getFullYear(), d3.getMonth(), 1); setD(d3); draw(); };
        });
      }
      return { draw: draw, goto: function (d) { view = new Date(d.getFullYear(), d.getMonth(), 1); draw(); } };
    }

    function setAnchorDate(val) {
      if (!val) { anchorDate = null; return; }
      var parts = val.split('-');
      anchorDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      scheduleFetch(false);
    }

    function renderSegBoth() {
      [{ seg: 'rc-tln-seg-otp' }, { seg: 'rc-tln-seg-otp2' }, { seg: 'rc-tln-seg-otp-m' }].forEach(function (o) {
        var seg = el(o.seg);
        if (!seg) return;
        var dCell = seg.querySelector('[data-p="d"] .rc-tl__seg-v');
        var mCell = seg.querySelector('[data-p="m"] .rc-tl__seg-v');
        var yCell = seg.querySelector('[data-p="y"] .rc-tl__seg-v');
        if (dCell) dCell.textContent = String(SEG_DATE.getDate()).padStart(2, '0');
        if (mCell) mCell.textContent = MO3[SEG_DATE.getMonth()];
        if (yCell) yCell.textContent = SEG_DATE.getFullYear();
      });
      setAnchorDate(isoSeg(SEG_DATE));
    }

    function bumpSeg(p, n) {
      var d = new Date(SEG_DATE);
      if (p === 'd') d.setDate(d.getDate() + n);
      if (p === 'm') d.setMonth(d.getMonth() + n);
      if (p === 'y') d.setFullYear(d.getFullYear() + n);
      SEG_DATE = d; renderSegBoth();
    }

    function buildDateSelector(segId, popId, calId) {
      var seg = el(segId), pop = el(popId), calBtn = el(calId);
      if (!seg || !pop || !calBtn) return;
      var cal = segCalendar(pop, function () { return SEG_DATE; }, function (d) { SEG_DATE = d; renderSegBoth(); cal.goto(d); cal.draw(); });
      var buf = '', bufT = 0;
      seg.querySelectorAll('.rc-tl__seg-cell').forEach(function (cell) {
        var p = cell.dataset.p;
        cell.addEventListener('pointerdown', function () { seg.querySelectorAll('.rc-tl__seg-cell').forEach(function (x) { x.classList.remove('rc-tl__seg-cell--on'); }); cell.classList.add('rc-tl__seg-cell--on'); cell.focus(); });
        cell.addEventListener('focus', function () { seg.querySelectorAll('.rc-tl__seg-cell').forEach(function (x) { x.classList.remove('rc-tl__seg-cell--on'); }); cell.classList.add('rc-tl__seg-cell--on'); });
        cell.addEventListener('blur', function () { cell.classList.remove('rc-tl__seg-cell--on'); });
        cell.addEventListener('wheel', function (e) { e.preventDefault(); bumpSeg(p, e.deltaY > 0 ? -1 : 1); }, { passive: false });
        cell.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowUp') { e.preventDefault(); bumpSeg(p, 1); }
          else if (e.key === 'ArrowDown') { e.preventDefault(); bumpSeg(p, -1); }
          else if (/^[0-9]$/.test(e.key)) {
            var now = Date.now(); buf = (now - bufT > 900 ? '' : buf) + e.key; bufT = now;
            var n = +buf, d = new Date(SEG_DATE);
            if (p === 'd' && n >= 1 && n <= 31) d.setDate(n);
            if (p === 'm' && n >= 1 && n <= 12) d.setMonth(n - 1);
            if (p === 'y' && buf.length === 4) d.setFullYear(n);
            SEG_DATE = d; renderSegBoth();
          }
        });
      });
      calBtn.onclick = function (e) { e.stopPropagation(); pop.classList.toggle('rc-tl__seg-pop--open'); cal.goto(SEG_DATE); cal.draw(); };
      document.addEventListener('click', function () { pop.classList.remove('rc-tl__seg-pop--open'); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') pop.classList.remove('rc-tl__seg-pop--open'); });
    }

    /* ════════════════════════════════════════════════════
       INIT
    ════════════════════════════════════════════════════ */
    buildDateSelector('rc-tln-seg-otp', 'rc-tln-pop-otp', 'rc-tln-cal-otp');
    buildDateSelector('rc-tln-seg-otp2', 'rc-tln-pop-otp2', 'rc-tln-cal-otp2');
    buildDateSelector('rc-tln-seg-otp-m', 'rc-tln-pop-otp-m', 'rc-tln-cal-otp-m');
    SEG_DATE = new Date();
    renderSegBoth();

    buildPanels();
    buildSpine();
    buildMap();
    buildMobileCards();
    transitionToStage(0);
    fetchDates(true); /* immediate first fetch — no debounce on initial load */
    if (!IS_MOBILE) { onScroll(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-private-property"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* Shopify bundles every section's javascript tag into one shared
       <script> tag site-wide — if this section isn't on the current page,
       every el(id) below would be null and throw, killing every OTHER
       section's JS later in that same bundle. Bail out immediately. */
    if (!document.getElementById('rc-pp-detail-wrap')) return;

    /* ── Mobile strip: Full Timeline tab + markup removed entirely below 768px,
       and the desktop sticky spine+detail walkthrough is swapped for the
       mobile card-stack walkthrough. Checked once on load only — not on
       resize (28 Jul 2026 decision, extended 11 Sep 2026). ── */
    var IS_MOBILE = window.innerWidth < 768;
    if (IS_MOBILE) {
      var vf0 = document.getElementById('rc-pp-view-full');
      if (vf0) { vf0.remove(); }
      var tf0 = document.getElementById('rc-pp-tab-full');
      if (tf0) { tf0.remove(); }
      var svb0 = document.getElementById('rc-pp-sc-view-btn');
      if (svb0) { svb0.remove(); }
      var wvb0 = document.getElementById('rc-pp-walkend-viewfull-btn');
      if (wvb0) { wvb0.remove(); }
      var so0 = document.getElementById('rc-pp-scroll-outer');
      if (so0) { so0.remove(); }
    } else {
      var mw0 = document.getElementById('rc-pp-m-wrap');
      if (mw0) { mw0.remove(); }
    }

    /* Shopify does NOT run Liquid inside the javascript tag — it's compiled as a
       shared static asset across every instance of this section, site-wide.
       Read customizer settings from data-* attributes on the root element
       (which IS Liquid-rendered, since it's regular HTML) instead. */
    var rootEl = document.getElementById('rc-pp-detail-wrap').closest('.rc-pp');
    var CFG = {
      showCosts: rootEl.dataset.showCosts !== 'false'
    };
    var ENDPOINT = 'https://api.roncasa.co/calc/timeline-dates';
    var DEBOUNCE_MS = 300;
    var fetchTimer = null;

    function el(id) { return document.getElementById(id); }

    /* ════════════════════════════════════════════════════
       STAGE DATA — buying / selling perspectives, 6 stages each,
       ported ~verbatim from source HTML. Same shape, same gap
       semantics at every index across both modes (no extension
       stage, no mode-specific stage count) — so unlike the HDB
       reference, no mode-conditional index checks are needed
       anywhere in the position/date math below.
    ════════════════════════════════════════════════════ */
    var D = {
      b: [
        {n:"01",t:"Preliminary Checks",sub:"IPA, budget, viewings",
         desc:"Get an In-Principle Approval (IPA), and a general read on your budget from a banker. A feel for what you can borrow before you shop. Once that's settled, conduct viewings.",
         cost:"Free",costL:"Cost",wait:"Before viewing",waitL:"Do this first",
         tip:"Talk to a banker before you fall in love with a unit. Shopping within a realistic ceiling saves you from a painful renegotiation later.",
         gap:"When ready"},
        {n:"02",t:"Receive Option To Purchase (OTP)",sub:"Secure the unit",
         desc:"Pay the 1% option fee in cash to secure the OTP. Decide on your law firm and apply for your bank loan now. The exercise clock has started.",
         cost:"1% (cash)",costL:"Option Fee Sent",wait:"~2 wks",waitL:"To Exercise",
         tip:"Get the loan application moving the day you sign. The exercise deadline doesn't wait for slow paperwork.",
         gap:null,hasExSlider:true},
        {n:"03",t:"Due Date to Exercise Option",sub:"Commit to buy, at Law Firm",
         desc:"Exercise the Option at your law firm. Bring your cheque book for the 4% exercise fee, Buyer's Stamp Duty, and legal fees: cheques are banked in on the due date, and you'll sign your mortgage documents.",
         cost:"4% (cash)",costL:"Exercise Fee",wait:"~12 wks",waitL:"To Completion",
         tip:"This date (not the OTP date, not completion) starts your 3-year Seller's Stamp Duty clock. Mark it.",
         gap:null,hasSlider:true},
        {n:"04",t:"BSD Payable",sub:"Buyer's Stamp Duty",
         desc:"Buyer's Stamp Duty is due in cash first. Ask your law firm to apply for BSD remission if you have sufficient CPF OA. You can claim it back from CPF after completion.",
         cost:"Tiered",costL:"BSD Rate",wait:"Cash first",waitL:"Order of funds",
         tip:"Cash portions must clear before CPF can be used for any balance payment. Plan your cash flow around that order, not the other way round. This date is indicative, not a fixed appointment. It's sometimes handled by email or through your agent.",
         gap:null},
        {n:"05",t:"Submit Final Downpayment",sub:"Balance 20%, cash portion",
         desc:"Submit the cashier's order for your balance 20% downpayment (the cash portion) to your law firm, two weeks ahead of completion.",
         cost:"20%",costL:"Balance Down",wait:"2 wks before",waitL:"Ahead of Completion",
         tip:"Confirm the exact cashier's order amount with your law firm a few days ahead, banks need lead time to issue it.",
         gap:null},
        {n:"06",t:"Completion",sub:"Receive keys",
         desc:"Attend completion at the law firm and collect your keys at the end of the business day.",
         cost:"Keys",costL:"You Receive",wait:"End of day",waitL:"Handover",
         tip:"Do the final walkthrough before you leave the law firm's office that day, not after.",
         gap:null}
      ],
      s: [
        {n:"01",t:"Preliminary Checks",sub:"SSD check, plan the sale",
         desc:"Check whether Seller's Stamp Duty (SSD) applies (it's based on your own exercise/purchase date, not a fixed calendar rule), and plan your sale around it. Get a sense of your price before listing.",
         cost:"Free",costL:"Cost",wait:"Before listing",waitL:"Do this first",
         tip:"SSD is calculated from your own exercise date, not from when you first booked or viewed. Get this wrong and it can cost you a real percentage of the price. Check it before committing to a sale timeline.",
         gap:"When ready"},
        {n:"02",t:"Grant Option To Purchase (OTP)",sub:"Receive the option fee",
         desc:"Receive the 1% option fee in cash from the buyer, and decide on your own law firm. Once you've received this, no further monies move until completion: everything the buyer pays after this point is held by the law firm, not paid to you directly.",
         cost:"1% (cash)",costL:"Option Fee Received",wait:"~2 wks",waitL:"Buyer's Window to Exercise",
         tip:"You can't sell to anyone else during this window, but there's nothing further for you to do until the buyer exercises.",
         gap:null,hasExSlider:true},
        {n:"03",t:"Due Date to Exercise Option",sub:"Buyer commits, at Law Firm",
         desc:"The buyer exercises the Option at their law firm, paying the 4% exercise fee, Buyer's Stamp Duty, and legal fees. All of this is held by the law firm, none of it comes to you directly at this stage.",
         cost:"Held by firm",costL:"Buyer's Funds",wait:"~12 wks",waitL:"To Completion",
         tip:"This date starts the buyer's clock, not yours, but it's worth double-checking your own SSD position was already settled back at Preliminary.",
         gap:null,hasSlider:true},
        {n:"04",t:"BSD Payable (Buyer's Side)",sub:"No action needed from you",
         desc:"Buyer's Stamp Duty is the buyer's obligation, paid to IRAS via their law firm. As the seller there's nothing for you to do here, the funds stay with the law firm until completion.",
         cost:"n/a",costL:"Your Action",wait:"Buyer's cost",waitL:"Who Pays",
         tip:"This stage mainly exists so you can track where the transaction is at. It doesn't require anything from you.",
         gap:null},
        {n:"05",t:"Submit Keys & Update MCST / Loan",sub:"Prepare for handover",
         desc:"Two weeks ahead of completion, submit your keys to your law firm and update them on your MCST payment status and outstanding loan redemption figures with your bank.",
         cost:"—",costL:"Cost",wait:"2 wks before",waitL:"Ahead of Completion",
         tip:"Get your loan redemption figure from your bank early. A stale figure on completion day can delay the whole appointment. This date is indicative, not fixed: keys sometimes get handed over earlier, or the agent coordinates it on your behalf.",
         gap:null},
        {n:"06",t:"Completion",sub:"Cost received",
         desc:"Attend completion. Your outstanding loan is repaid from sale proceeds, CPF principal plus accrued interest is refunded to your CPF OA, and the balance proceeds are disbursed to you.",
         cost:"Price − Loan − Legal",costL:"You Receive",wait:"At completion",waitL:"When",
         tip:"Your CPF refund goes to your CPF OA with accrued interest, not cash in hand. Factor this into your next purchase budget.",
         gap:null}
      ]
    };

    /* ════════════════════════════════════════════════════
       STATE
    ════════════════════════════════════════════════════ */
    var MODE = 'b';
    var exerciseDays = 14;   /* OTP → Exercise due date, user-adjustable (7–28, default 14) */
    var complDays = 84;      /* Exercise → Completion, user-adjustable (70–84, default 84) */
    var activeStage = -1;
    var otpDate = null;      /* Date object — anchor date, local echo of SEG_DATE for display fallback */

    /* Latest data from the Worker — gaps array + per-stage-index dates.
       Never computed locally; only ever assigned from a fetch response. */
    var latestGaps = [];
    var latestStages = {};
    var latestTotalDays = 0;

    /* Flat 6-stage array in every mode — no extension stage to slice off,
       so unlike timeline-hdb-resale.liquid's visibleStages(), this always
       returns the full mode array untouched. */
    function visibleStages() { return D[MODE]; }
    function stageTotal() { return visibleStages().length; }

    /* ════════════════════════════════════════════════════
       WORKER FETCH — the only place stage dates / day-gaps come from.
       No mode param: both modes share identical date/gap math, only the
       stage copy differs — see the file header comment.
    ════════════════════════════════════════════════════ */
    function isoSeg(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }

    function buildEndpointUrl() {
      var p = new URLSearchParams();
      p.set('tool', 'private-property-purchase');
      p.set('anchor', otpDate ? isoSeg(otpDate) : isoSeg(new Date()));
      p.set('exercise_days', exerciseDays);
      p.set('compl_days', complDays);
      return ENDPOINT + '?' + p.toString();
    }

    function parseStageDates(raw) {
      var out = {};
      if (!raw) return out;
      Object.keys(raw).forEach(function (k) {
        var parts = raw[k].split('-');
        out[k] = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      });
      return out;
    }

    function fetchDates(rebuildAfter) {
      fetch(buildEndpointUrl())
        .then(function (r) { return r.json(); })
        .then(function (data) {
          latestGaps = data.gaps || [];
          latestStages = parseStageDates(data.stages);
          latestTotalDays = data.total_days || 0;
          if (rebuildAfter) {
            var rebuiltTarget = Math.min(Math.max(activeStage, 0), stageTotal() - 1);
            buildPanels(); buildSpine(); buildMap(); buildMobileCards();
            /* buildPanels() replaces every .rc-tl__sp node, so the previously-active
               panel's element is gone — force re-activation even if the target index
               is unchanged, or transitionToStage's idx===activeStage guard skips it
               and every panel stays at opacity:0. */
            activeStage = -1;
            transitionToStage(rebuiltTarget);
          }
          repaint();
        })
        .catch(function () { /* leave previous state — don't blank the UI on a transient failure */ });
    }

    function scheduleFetch(rebuildAfter) {
      clearTimeout(fetchTimer);
      fetchTimer = setTimeout(function () { fetchDates(rebuildAfter); }, DEBOUNCE_MS);
    }

    /* Optimistic local patch of a single gap slot — a direct assignment for
       the exercise slider (gaps[1] = exerciseDays), and a derived remainder
       for the completion slider (gaps[3] = complDays - 28, matching the
       Worker's own "mid" formula) — so the spine/map reposition instantly
       while dates catch up once the debounced fetch resolves. */
    function patchGap(idx, val) {
      if (idx >= 0 && idx < latestGaps.length) { latestGaps[idx] = val; }
    }

    /* ════════════════════════════════════════════════════
       PROPORTIONAL POSITIONS — layout math, stays client-side (uses latestGaps)
    ════════════════════════════════════════════════════ */
    function gapsFallback() {
      return new Array(Math.max(1, visibleStages().length - 1)).fill(1);
    }

    function spinePositions() {
      var gaps = latestGaps.length ? latestGaps : gapsFallback();
      var tot = gaps.reduce(function (a, b) { return a + b; }, 0) || 1;
      var pos = [0]; var c = 0;
      for (var i = 0; i < gaps.length; i++) { c += gaps[i]; pos.push(c / tot * 100); }
      var MIN_GAP = 9;
      for (var j = 1; j < pos.length; j++) { if (pos[j] < pos[j - 1] + MIN_GAP) { pos[j] = pos[j - 1] + MIN_GAP; } }
      if (pos[pos.length - 1] > 100) {
        var scale = 100 / pos[pos.length - 1];
        for (var k = 0; k < pos.length; k++) { pos[k] = pos[k] * scale; }
      }
      return pos;
    }

    function mapPositions() {
      var gaps = latestGaps.length ? latestGaps : gapsFallback();
      var tot = gaps.reduce(function (a, b) { return a + b; }, 0) || 1;
      var pL = 5, span = 90;
      var pos = [pL]; var c = 0;
      for (var i = 0; i < gaps.length; i++) { c += gaps[i]; pos.push(pL + span * (c / tot)); }
      return pos;
    }

    function gapText(i) {
      if (i === 0) return 'When ready';
      return (latestGaps[i] !== undefined ? latestGaps[i] : '') + ' days';
    }

    /* ════════════════════════════════════════════════════
       LEFT SPINE
    ════════════════════════════════════════════════════ */
    function buildSpine() {
      var track = el('rc-pp-spine-track');
      if (!track) return;
      track.querySelectorAll('.rc-pp__tick-row,.rc-pp__tick-dur').forEach(function (n) { n.remove(); });
      var data = visibleStages();
      var pos = spinePositions();
      data.forEach(function (s, i) {
        var row = document.createElement('div');
        row.className = 'rc-pp__tick-row';
        row.id = 'rc-pp-tr-' + i;
        row.style.top = pos[i] + '%';
        row.innerHTML = '<span class="rc-pp__tnum">' + s.n + '</span>' +
          '<span class="rc-pp__tdot"></span>' +
          '<div class="rc-pp__tright"><span class="rc-pp__tdate" id="rc-pp-trdate-' + i + '"></span><span class="rc-pp__ttext">' + s.t + '</span></div>';
        row.addEventListener('click', function () { jumpToStage(i); });
        track.appendChild(row);

        if (i < data.length - 1) {
          var midPct = (pos[i] + pos[i + 1]) / 2;
          var dur = document.createElement('div');
          dur.className = 'rc-pp__tick-dur';
          dur.id = 'rc-pp-td-' + i;
          dur.style.top = midPct + '%';
          dur.textContent = gapText(i);
          track.appendChild(dur);
        }
      });
    }

    function updateSpineFill(stageIdx) {
      var pos = spinePositions();
      var fill = el('rc-pp-spine-fill');
      if (fill) { fill.style.height = pos[stageIdx] + '%'; }
    }

    function updateSpinePositions() {
      var pos = spinePositions();
      var data = visibleStages();
      data.forEach(function (s, i) {
        var row = el('rc-pp-tr-' + i);
        if (row) { row.style.top = pos[i] + '%'; }
        var dur = el('rc-pp-td-' + i);
        if (dur) {
          var midPct = (pos[i] + (pos[i + 1] !== undefined ? pos[i + 1] : pos[i])) / 2;
          dur.style.top = midPct + '%';
          dur.textContent = gapText(i);
        }
      });
      if (activeStage >= 0) { updateSpineFill(activeStage); }
    }

    /* ════════════════════════════════════════════════════
       STAGE PANELS
    ════════════════════════════════════════════════════ */
    function exerciseCtx(v) {
      if (v <= 10) { return 'Tight, financing needs to be all but locked in before you sign the OTP'; }
      if (v <= 14) { return 'Standard — the typical 2-week window'; }
      if (v <= 21) { return 'Comfortable, some room if a loan needs extra processing time'; }
      return 'On the longer end, confirm this is actually what the OTP states before relying on it';
    }
    function complCtx(v) {
      if (v <= 74) { return "Fastest case, 10 weeks. Rare; confirm the bank's loan disbursement can genuinely clear this quickly before relying on it."; }
      if (v <= 80) { return 'Faster than standard, still workable, but check with the bank on timing.'; }
      return 'Standard, 12 weeks is what banks typically need to clear the loan side of a private purchase.';
    }

    /* Shared body-content generator — used by BOTH buildPanels() (desktop
       panel, sfx='') and buildMobileCards() (mobile card, sfx='-m'), same
       reasoning as the HDB Resale sibling. */
    function renderStageBody(s, i, sfx) {
      var sliderHTML = '';
      if (s.hasSlider) {
        var pct = (complDays / 84 * 100).toFixed(1);
        var wks = Math.round(complDays / 7);
        sliderHTML = '<div class="rc-pp__sp-slider">' +
          '<span class="rc-pp__sl-eye">Days from Exercise to Completion (10–12 wks, rarely faster)</span>' +
          '<div class="rc-pp__sl-pill"><div class="rc-pp__sl-fill" id="rc-pp-cd-fill' + sfx + '" style="width:' + pct + '%">' +
          '<span class="rc-pp__sl-fill-txt" id="rc-pp-cd-num' + sfx + '">' + complDays + ' days</span><span class="rc-pp__sl-handle"></span></div>' +
          '<span class="rc-pp__sl-pill-max">84 max</span>' +
          '<input type="range" class="rc-pp__sl-range" id="rc-pp-cd-range' + sfx + '" min="70" max="84" value="' + complDays + '"/></div>' +
          '<div class="rc-pp__sl-ctx" id="rc-pp-cd-ctx' + sfx + '">' + complCtx(complDays) + '</div>' +
          '<div class="rc-pp__sl-ctx" id="rc-pp-cd-wks-note' + sfx + '" style="margin-top:2px">≈ ' + wks + ' weeks from date of exercise. BSD Payable and the Downpayment/Keys stage dates below are indicative, not fixed appointments. They\'re sometimes handled by email or your agent, or completed earlier.</div>' +
          '</div>';
      }

      var exSliderHTML = '';
      if (s.hasExSlider) {
        var exPct = (exerciseDays / 28 * 100).toFixed(1);
        exSliderHTML = '<div class="rc-pp__sp-slider"><span class="rc-pp__sl-eye">Days until Exercise due date (typically 2 wks, max 28 days)</span>' +
          '<div class="rc-pp__sl-pill"><div class="rc-pp__sl-fill" id="rc-pp-ex-fill' + sfx + '" style="width:' + exPct + '%">' +
          '<span class="rc-pp__sl-fill-txt" id="rc-pp-ex-num' + sfx + '">' + exerciseDays + ' days</span><span class="rc-pp__sl-handle"></span></div>' +
          '<span class="rc-pp__sl-pill-max">28 max</span>' +
          '<input type="range" class="rc-pp__sl-range" id="rc-pp-ex-range' + sfx + '" min="7" max="28" value="' + exerciseDays + '"/></div>' +
          '<div class="rc-pp__sl-ctx" id="rc-pp-ex-ctx' + sfx + '">' + exerciseCtx(exerciseDays) + '</div></div>';
      }

      return {
        chips: CFG.showCosts ? ('<div class="rc-pp__sp-chips"><div class="rc-pp__sp-chip"><div class="rc-pp__cl">' + s.costL + '</div><div class="rc-pp__cv">' + s.cost + '</div></div>' +
          '<div class="rc-pp__sp-chip"><div class="rc-pp__cl">' + s.waitL + '</div><div class="rc-pp__cv">' + s.wait + '</div></div></div>') : '',
        controls: exSliderHTML + sliderHTML,
        tip: '<div class="rc-pp__sp-note"><span class="rc-pp__nl">Ron\'s Note</span><p>' + s.tip + '</p></div>'
      };
    }

    function buildPanels() {
      var wrap = el('rc-pp-detail-wrap');
      if (!wrap) return;
      wrap.innerHTML = '';
      var data = visibleStages();
      var total = data.length;
      var totalStr = (total < 10 ? '0' : '') + total;

      data.forEach(function (s, i) {
        var body = renderStageBody(s, i, '');
        var panel = document.createElement('div');
        panel.className = 'rc-pp__sp';
        panel.id = 'rc-pp-sp-' + i;
        panel.innerHTML =
          '<div class="rc-pp__sp-num">Stage <span>' + s.n + '</span> / ' + totalStr + '</div>' +
          '<div class="rc-pp__sp-name">' + s.t + '</div>' +
          '<div class="rc-pp__sp-sub">' + s.sub + '</div>' +
          '<div class="rc-pp__sp-stage-date" id="rc-pp-spdate-' + i + '"></div>' +
          '<div class="rc-pp__sp-desc">' + s.desc + '</div>' +
          body.chips + body.controls + body.tip;
        wrap.appendChild(panel);
      });

      bindPanelControls('');
    }

    /* Mobile card-stack walkthrough — see header comment. */
    function buildMobileCards() {
      var wrap = el('rc-pp-m-stages');
      if (!wrap) return;
      wrap.innerHTML = '';
      var data = visibleStages();
      var total = data.length;
      var totalStr = (total < 10 ? '0' : '') + total;

      data.forEach(function (s, i) {
        var body = renderStageBody(s, i, '-m');
        var row = document.createElement('div');
        row.className = 'rc-pp__m-card-wrap';
        row.id = 'rc-pp-m-row-' + i;
        row.innerHTML = '<div class="rc-pp__m-dot"></div><div class="rc-pp__m-card">' +
          '<div class="rc-pp__m-num">Stage ' + s.n + ' / ' + totalStr + '</div>' +
          '<h3>' + s.t + '</h3>' +
          '<div class="rc-pp__m-sub">' + s.sub + '</div>' +
          '<div class="rc-pp__m-date" id="rc-pp-mdate-' + i + '"></div>' +
          '<div class="rc-pp__m-desc">' + s.desc + '</div>' +
          body.chips + body.controls + body.tip +
          '</div>';
        wrap.appendChild(row);
      });

      bindPanelControls('-m');
      initMobileObserver();
    }

    function initMobileObserver() {
      var rows = Array.prototype.slice.call(document.querySelectorAll('.rc-pp__m-card-wrap'));
      var fill = el('rc-pp-m-fill');
      if (!rows.length || !fill) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('rc-pp__m-in'); } });
      }, { rootMargin: '0px 0px -15% 0px', threshold: 0.1 });
      rows.forEach(function (r) { io.observe(r); });

      function updateFill() {
        if (rows.length < 2) return;
        var track = document.querySelector('.rc-pp__m-track');
        var firstDot = rows[0].querySelector('.rc-pp__m-dot'), lastDot = rows[rows.length - 1].querySelector('.rc-pp__m-dot');
        if (!track || !firstDot || !lastDot) return;
        var first = firstDot.getBoundingClientRect(), last = lastDot.getBoundingClientRect();
        var mid = window.innerHeight * 0.5;
        var total = last.top - first.top;
        if (!total) return;
        var p = Math.max(0, Math.min(1, (mid - first.top) / total));
        fill.style.height = Math.max(0, (last.top - track.getBoundingClientRect().top) * p) + 'px';
      }
      var tickingM = false;
      window.addEventListener('scroll', function () {
        if (!tickingM) { requestAnimationFrame(function () { updateFill(); tickingM = false; }); tickingM = true; }
      }, { passive: true });
      window.addEventListener('resize', updateFill);
      updateFill();
    }

    function bindPanelControls(sfx) {
      sfx = sfx || '';
      var exRange = el('rc-pp-ex-range' + sfx);
      if (exRange) { exRange.addEventListener('input', function () { onExerciseSlider(this.value); }); }
      var cdRange = el('rc-pp-cd-range' + sfx);
      if (cdRange) { cdRange.addEventListener('input', function () { onComplSlider(this.value); }); }
    }

    /* ════════════════════════════════════════════════════
       TRANSITION TO STAGE
    ════════════════════════════════════════════════════ */
    function transitionToStage(idx) {
      if (idx === activeStage) { return; }
      if (activeStage >= 0) {
        var oldP = el('rc-pp-sp-' + activeStage); if (oldP) { oldP.classList.remove('rc-pp__sp--active'); }
        var oldT = el('rc-pp-tr-' + activeStage); if (oldT) { oldT.classList.remove('rc-pp__tick-row--active'); }
      }
      for (var j = 0; j < idx; j++) { var dT = el('rc-pp-tr-' + j); if (dT) { dT.classList.add('rc-pp__tick-row--done'); } }
      var panel = el('rc-pp-sp-' + idx); if (panel) { panel.classList.add('rc-pp__sp--active'); }
      var tick = el('rc-pp-tr-' + idx); if (tick) { tick.classList.remove('rc-pp__tick-row--done'); tick.classList.add('rc-pp__tick-row--active'); }
      var ghost = el('rc-pp-ghost-num');
      if (ghost) {
        ghost.classList.remove('rc-pp__ghost-num--pop'); void ghost.offsetWidth;
        ghost.textContent = visibleStages()[idx] ? visibleStages()[idx].n : String(idx + 1);
        ghost.classList.add('rc-pp__ghost-num--pop');
      }
      var tot = stageTotal(); var totS = (tot < 10 ? '0' : '') + tot;
      var sN = visibleStages()[idx] ? visibleStages()[idx].n : String(idx + 1);
      var sc = el('rc-pp-stage-counter'); if (sc) { sc.innerHTML = '<b>' + sN + '</b> / ' + totS; }
      var hint = el('rc-pp-tab-hint'); if (hint) { hint.textContent = 'Stage ' + (idx + 1) + ' of ' + tot; }
      updateSpineFill(idx);
      activeStage = idx;
      var cue = el('rc-pp-scroll-cue');
      if (cue) { cue.style.opacity = idx >= stageTotal() - 1 ? '0' : ''; }
    }

    /* ════════════════════════════════════════════════════
       SCROLL LOGIC
    ════════════════════════════════════════════════════ */
    function getProgress() {
      var outer = el('rc-pp-scroll-outer');
      if (!outer || outer.offsetHeight === 0) { return 0; }
      var rect = outer.getBoundingClientRect();
      var scrolled = Math.max(0, -rect.top);
      var total = Math.max(1, outer.offsetHeight - window.innerHeight);
      return Math.min(1, scrolled / total);
    }

    function onScroll() {
      var wv = el('rc-pp-view-walk');
      if (!wv || !wv.classList.contains('rc-pp__view-walk--active')) { return; }
      var p = getProgress();
      var pf = el('rc-pp-prog-fill'); if (pf) { pf.style.height = (p * 100) + '%'; }
      var N = stageTotal();
      var idx = Math.min(N - 1, Math.floor(p * N));
      transitionToStage(idx);
    }

    var ticking = false;
    if (!IS_MOBILE) {
      window.addEventListener('scroll', function () {
        if (!ticking) { requestAnimationFrame(function () { onScroll(); ticking = false; }); ticking = true; }
      }, { passive: true });
      window.addEventListener('resize', onScroll);
    }

    function jumpToStage(i) {
      var outer = el('rc-pp-scroll-outer');
      if (!outer) return;
      var N = stageTotal();
      var targetP = N > 1 ? i / (N - 1) : 0;
      var total = outer.offsetHeight - window.innerHeight;
      window.scrollTo({ top: outer.offsetTop + targetP * total, behavior: 'smooth' });
    }

    /* ════════════════════════════════════════════════════
       SLIDERS
    ════════════════════════════════════════════════════ */
    function onExerciseSlider(val) {
      exerciseDays = parseInt(val, 10);
      var f = el('rc-pp-ex-fill'), n = el('rc-pp-ex-num'), c = el('rc-pp-ex-ctx');
      if (f) f.style.width = (exerciseDays / 28 * 100) + '%';
      if (n) n.textContent = exerciseDays + ' days';
      if (c) c.textContent = exerciseCtx(exerciseDays);
      var mf = el('rc-pp-ex-fill-m'), mn = el('rc-pp-ex-num-m'), mc = el('rc-pp-ex-ctx-m'), mr = el('rc-pp-ex-range-m');
      if (mf) mf.style.width = (exerciseDays / 28 * 100) + '%';
      if (mn) mn.textContent = exerciseDays + ' days';
      if (mc) mc.textContent = exerciseCtx(exerciseDays);
      if (mr) mr.value = exerciseDays;
      var ftf = el('rc-pp-ft-ex-fill'), ftn = el('rc-pp-ft-ex-num'), ftr = el('rc-pp-ft-ex-range');
      if (ftf) ftf.style.width = (exerciseDays / 28 * 100) + '%';
      if (ftn) ftn.textContent = exerciseDays + ' days';
      if (ftr) ftr.value = exerciseDays;
      patchGap(1, exerciseDays);
      updateSpinePositions(); updateMapPositions();
      scheduleFetch(false);
    }

    function onComplSlider(val) {
      complDays = parseInt(val, 10);
      var f = el('rc-pp-cd-fill'), n = el('rc-pp-cd-num'), c = el('rc-pp-cd-ctx'), w = el('rc-pp-cd-wks-note');
      if (f) f.style.width = (complDays / 84 * 100) + '%';
      if (n) n.textContent = complDays + ' days';
      if (c) c.textContent = complCtx(complDays);
      if (w) w.textContent = '≈ ' + Math.round(complDays / 7) + " weeks from date of exercise. BSD Payable and the Downpayment/Keys stage dates below are indicative, not fixed appointments. They're sometimes handled by email or your agent, or completed earlier.";
      var mf2 = el('rc-pp-cd-fill-m'), mn2 = el('rc-pp-cd-num-m'), mc2 = el('rc-pp-cd-ctx-m'), mw2 = el('rc-pp-cd-wks-note-m'), mr2 = el('rc-pp-cd-range-m');
      if (mf2) mf2.style.width = (complDays / 84 * 100) + '%';
      if (mn2) mn2.textContent = complDays + ' days';
      if (mc2) mc2.textContent = complCtx(complDays);
      if (mw2) mw2.textContent = '≈ ' + Math.round(complDays / 7) + " weeks from date of exercise. BSD Payable and the Downpayment/Keys stage dates below are indicative, not fixed appointments. They're sometimes handled by email or your agent, or completed earlier.";
      if (mr2) mr2.value = complDays;
      var ftf = el('rc-pp-ft-cd-fill'), ftn = el('rc-pp-ft-cd-num'), ftr = el('rc-pp-ft-cd-range');
      if (ftf) ftf.style.width = (complDays / 84 * 100) + '%';
      if (ftn) ftn.textContent = complDays + ' days';
      if (ftr) ftr.value = complDays;
      /* Derived remainder for the BSD-Payable → Downpayment/Keys gap, mirroring
         the Worker's own "mid = complDays - 14 - 14" formula. */
      patchGap(3, Math.max(0, complDays - 28));
      updateSpinePositions(); updateMapPositions();
      scheduleFetch(false);
    }

    /* ════════════════════════════════════════════════════
       HORIZONTAL MAP
    ════════════════════════════════════════════════════ */
    function buildMap() {
      var h = el('rc-pp-horiz');
      if (!h) { buildVertMap(); return; }
      h.querySelectorAll('.rc-pp__hn,.rc-pp__hl,.rc-pp__hgap').forEach(function (n) { n.remove(); });
      var pos = mapPositions();
      var data = visibleStages();
      var N = data.length;

      data.forEach(function (s, i) {
        var xi = pos[i];
        var term = (i === N - 1);
        var nd = document.createElement('div');
        nd.className = 'rc-pp__hn' + (term ? ' rc-pp__hn--term' : '');
        nd.style.left = xi + '%';
        nd.id = 'rc-pp-hn-' + i;
        nd.addEventListener('click', (function (idx) { return function () { switchTab('walk'); setTimeout(function () { jumpToStage(idx); }, 100); }; })(i));
        h.appendChild(nd);

        var up = (i % 2 === 0);
        var showCost = CFG.showCosts && s.cost && s.cost !== '—' && s.cost.charAt(0) !== '+';
        var lb = document.createElement('div');
        lb.className = 'rc-pp__hl ' + (up ? 'rc-pp__hl--up' : 'rc-pp__hl--dn');
        lb.style.left = xi + '%';
        lb.id = 'rc-pp-hl-' + i;
        lb.innerHTML = '<div class="rc-pp__tick"></div><div class="rc-pp__hln">' + s.n + '</div><div class="rc-pp__hlt">' + s.t + '</div>' + (showCost ? '<div class="rc-pp__hlc">' + s.cost + '</div>' : '') + '<div class="rc-pp__hldate" id="rc-pp-hldate-' + i + '"></div>';
        h.appendChild(lb);

        var tooClose = (i < pos.length - 1 && Math.abs(pos[i + 1] - pos[i]) < 4);
        if (!tooClose && i < N - 1 && i > 0) {
          var gp = document.createElement('div');
          gp.className = 'rc-pp__hgap';
          gp.id = 'rc-pp-hgap-' + i;
          gp.style.left = ((xi + pos[i + 1]) / 2) + '%';
          gp.textContent = gapText(i);
          h.appendChild(gp);
        }
      });

      buildVertMap();
    }

    function updateMapPositions() {
      var pos = mapPositions();
      pos.forEach(function (p, i) {
        var nd = el('rc-pp-hn-' + i); var lb = el('rc-pp-hl-' + i);
        if (nd) nd.style.left = p + '%';
        if (lb) lb.style.left = p + '%';
      });
      for (var i = 0; i < pos.length - 1; i++) {
        var gp = el('rc-pp-hgap-' + i);
        if (gp) { gp.style.left = ((pos[i] + pos[i + 1]) / 2) + '%'; gp.textContent = gapText(i); }
      }
    }

    function buildVertMap() {
      var v = el('rc-pp-vert');
      if (!v) return;
      v.innerHTML = '<div class="rc-pp__vspine"></div>';
      var data = visibleStages();
      data.forEach(function (s, i) {
        var term = (i === data.length - 1);
        var showCost = CFG.showCosts && s.cost && s.cost !== '—' && s.cost.charAt(0) !== '+';
        var row = document.createElement('div');
        row.className = 'rc-pp__vrow' + (term ? ' rc-pp__vrow--term' : '');
        row.innerHTML = '<div class="rc-pp__vnode"></div><div class="rc-pp__vnum">' + s.n + '</div><div class="rc-pp__vt">' + s.t + '</div>' + (showCost ? '<div class="rc-pp__vc">' + s.cost + '</div>' : '');
        row.addEventListener('click', (function (idx) { return function () { switchTab('walk'); setTimeout(function () { jumpToStage(idx); }, 100); }; })(i));
        v.appendChild(row);

        if (i < data.length - 1) {
          var gv = document.createElement('div');
          gv.className = 'rc-pp__vgap';
          gv.innerHTML = '<span class="rc-pp__gpill">' + gapText(i) + '</span>';
          v.appendChild(gv);
        }
      });
    }

    /* ════════════════════════════════════════════════════
       DATE LABELS — driven entirely by latestStages (from the Worker)
    ════════════════════════════════════════════════════ */
    function fmtDate(d) {
      if (!d) return '';
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
    }

    function repaint() {
      var data = visibleStages();
      /* Gap/duration labels */
      data.forEach(function (s, i) {
        var dur = el('rc-pp-td-' + i);
        if (dur && i < data.length - 1) { dur.textContent = gapText(i); }
      });
      /* Date labels — looped unconditionally, independent of whether a gap
         label exists, so the LAST visible stage (which has no trailing gap)
         still gets its own date. */
      data.forEach(function (s, i) {
        var trDE = el('rc-pp-trdate-' + i);
        if (trDE) { trDE.textContent = latestStages[i] ? fmtDate(latestStages[i]) : ''; }
      });
      data.forEach(function (s, i) {
        var dateEl = el('rc-pp-spdate-' + i);
        if (!dateEl) return;
        var d = latestStages[i];
        if (d) { dateEl.textContent = fmtDate(d); dateEl.style.display = 'block'; }
        else { dateEl.style.display = 'none'; }
      });
      data.forEach(function (s, i) {
        var mdateEl = el('rc-pp-mdate-' + i);
        if (!mdateEl) return;
        var d2 = latestStages[i];
        if (d2) { mdateEl.textContent = fmtDate(d2); mdateEl.style.display = 'block'; }
        else { mdateEl.style.display = 'none'; }
      });
      data.forEach(function (s, i) {
        var ld = el('rc-pp-hldate-' + i);
        if (ld) { ld.textContent = latestStages[i] ? fmtDate(latestStages[i]) : ''; }
      });
      updateSpinePositions();
      updateMapPositions();
    }

    /* ════════════════════════════════════════════════════
       TAB SWITCHER
    ════════════════════════════════════════════════════ */
    function switchTab(which) {
      var wv = el('rc-pp-view-walk'), fv = el('rc-pp-view-full');
      var tw = el('rc-pp-tab-walk'), tf = el('rc-pp-tab-full');
      if (which === 'full' && !fv) { return; } /* removed on mobile — nothing to switch to */
      if (which === 'walk') {
        if (wv) wv.classList.add('rc-pp__view-walk--active');
        if (fv) fv.classList.remove('rc-pp__view-full--active');
        if (tw) tw.classList.add('rc-pp__pill--on');
        if (tf) tf.classList.remove('rc-pp__pill--on');
        var hint = el('rc-pp-tab-hint');
        if (hint) hint.textContent = activeStage >= 0 ? 'Stage ' + (activeStage + 1) + ' of ' + stageTotal() : 'Stage 1 of ' + stageTotal();
        setTimeout(function () { var so = el('rc-pp-scroll-outer'); if (so) window.scrollTo({ top: so.offsetTop, behavior: 'smooth' }); }, 50);
      } else {
        if (fv) fv.classList.add('rc-pp__view-full--active');
        if (wv) wv.classList.remove('rc-pp__view-walk--active');
        if (tf) tf.classList.add('rc-pp__pill--on');
        if (tw) tw.classList.remove('rc-pp__pill--on');
        var hint2 = el('rc-pp-tab-hint');
        if (hint2) hint2.textContent = 'Full journey';
        buildMap();
        repaint();
        setTimeout(function () { if (fv) fv.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
      }
    }
    var tabWalk = el('rc-pp-tab-walk'); if (tabWalk) tabWalk.addEventListener('click', function () { switchTab('walk'); });
    var tabFull = el('rc-pp-tab-full'); if (tabFull) tabFull.addEventListener('click', function () { switchTab('full'); });
    var scViewBtn = el('rc-pp-sc-view-btn'); if (scViewBtn) scViewBtn.addEventListener('click', function () { switchTab('full'); });
    var walkEndBtn = el('rc-pp-walkend-viewfull-btn'); if (walkEndBtn) walkEndBtn.addEventListener('click', function () { switchTab('full'); });

    /* ════════════════════════════════════════════════════
       MODE SWITCH (Buying / Selling)
    ════════════════════════════════════════════════════ */
    function setMode(mode, btn) {
      MODE = mode;
      document.querySelectorAll('.rc-pp__mode-pill').forEach(function (p) { p.classList.remove('rc-pp__mode-pill--on'); });
      if (btn) btn.classList.add('rc-pp__mode-pill--on');

      var vfKick = el('rc-pp-vf-kick');
      if (vfKick) vfKick.textContent = mode === 'b' ? "The buyer's full journey" : "The seller's full journey";
      var weKick = el('rc-pp-walk-end-kick');
      if (weKick) weKick.textContent = mode === 'b' ? "That's the buyer's journey" : "That's the seller's journey";
      var otpLbl = mode === 'b' ? 'OTP date (received)' : 'OTP date (granted)';
      var lbl1 = el('rc-pp-otp-lbl'); if (lbl1) lbl1.textContent = otpLbl;
      var lbl2 = el('rc-pp-ft-otp-lbl'); if (lbl2) lbl2.textContent = otpLbl;
      var lbl3 = el('rc-pp-otp-lbl-m'); if (lbl3) lbl3.textContent = otpLbl;

      activeStage = -1;
      latestStages = {}; /* clear stale-mode dates immediately so nothing wrong-mode is shown before the refetch lands */
      buildPanels(); buildSpine(); buildMap(); buildMobileCards();
      transitionToStage(0);
      if (!IS_MOBILE) { onScroll(); }
      scheduleFetch(true);
    }
    var modeB = el('rc-pp-mode-b'); if (modeB) modeB.addEventListener('click', function () { setMode('b', modeB); });
    var modeS = el('rc-pp-mode-s'); if (modeS) modeS.addEventListener('click', function () { setMode('s', modeS); });

    /* ════════════════════════════════════════════════════
       SEGMENTED ANCHOR-DATE INPUT + calendar popover
       (two synced instances: walkthrough topbar + full-timeline controls)
    ════════════════════════════════════════════════════ */
    var MO3 = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
    var MO_FULL = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var DOW3 = ['M','T','W','T','F','S','S'];
    var SEG_DATE = new Date();

    function sameSeg(a, b) { return a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); }

    function segCalendar(host, getD, setD) {
      var view = new Date(getD().getFullYear(), getD().getMonth(), 1);
      function cellH(d, mute) {
        var today = new Date();
        var cls = [mute ? 'rc-pp__cmute' : '', sameSeg(d, today) ? 'rc-pp__ctoday' : '', sameSeg(d, getD()) ? 'rc-pp__csel' : ''].filter(Boolean).join(' ');
        return '<button data-d="' + isoSeg(d) + '" class="' + cls + '">' + d.getDate() + '</button>';
      }
      function draw() {
        var y = view.getFullYear(), m = view.getMonth();
        var first = (new Date(y, m, 1).getDay() + 6) % 7, len = new Date(y, m + 1, 0).getDate(), plen = new Date(y, m, 0).getDate();
        var cells = '';
        for (var i = first - 1; i >= 0; i--) cells += cellH(new Date(y, m - 1, plen - i), true);
        for (var d = 1; d <= len; d++) cells += cellH(new Date(y, m, d), false);
        var rest = (7 - ((first + len) % 7)) % 7;
        for (var d2 = 1; d2 <= rest; d2++) cells += cellH(new Date(y, m + 1, d2), true);
        host.innerHTML = '<div class="rc-pp__cnav"><div class="rc-pp__mo">' + MO_FULL[m] + ' <span>' + y + '</span></div>' +
          '<div class="rc-pp__cnav-grp"><button data-s="-1"><svg viewBox="0 0 24 24"><path d="M15 4 7 12l8 8"/></svg></button>' +
          '<button data-s="1"><svg viewBox="0 0 24 24"><path d="M9 4l8 8-8 8"/></svg></button></div></div>' +
          '<div class="rc-pp__cdow">' + DOW3.map(function (d3) { return '<div>' + d3 + '</div>'; }).join('') + '</div>' +
          '<div class="rc-pp__cgrid">' + cells + '</div>' +
          '<div class="rc-pp__cfoot"><span>' + isoSeg(getD()) + '</span><button data-t="1">Today</button></div>';
        host.querySelectorAll('[data-s]').forEach(function (b) { b.onclick = function (e) { e.stopPropagation(); view = new Date(y, m + (+b.dataset.s), 1); draw(); }; });
        var todayBtn = host.querySelector('[data-t]');
        if (todayBtn) todayBtn.onclick = function (e) { e.stopPropagation(); var td = new Date(); view = new Date(td.getFullYear(), td.getMonth(), 1); setD(td); draw(); };
        host.querySelectorAll('[data-d]').forEach(function (b) {
          b.onclick = function (e) { e.stopPropagation(); var d3 = new Date(b.dataset.d + 'T00:00:00'); view = new Date(d3.getFullYear(), d3.getMonth(), 1); setD(d3); draw(); };
        });
      }
      return { draw: draw, goto: function (d) { view = new Date(d.getFullYear(), d.getMonth(), 1); draw(); } };
    }

    function setOTPDate(val) {
      if (!val) { otpDate = null; return; }
      var parts = val.split('-');
      otpDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      scheduleFetch(false);
    }

    function renderSegBoth() {
      [{ seg: 'rc-pp-seg-otp' }, { seg: 'rc-pp-seg-otp2' }, { seg: 'rc-pp-seg-otp-m' }].forEach(function (o) {
        var seg = el(o.seg);
        if (!seg) return;
        var dCell = seg.querySelector('[data-p="d"] .rc-pp__seg-v');
        var mCell = seg.querySelector('[data-p="m"] .rc-pp__seg-v');
        var yCell = seg.querySelector('[data-p="y"] .rc-pp__seg-v');
        if (dCell) dCell.textContent = String(SEG_DATE.getDate()).padStart(2, '0');
        if (mCell) mCell.textContent = MO3[SEG_DATE.getMonth()];
        if (yCell) yCell.textContent = SEG_DATE.getFullYear();
      });
      setOTPDate(isoSeg(SEG_DATE));
    }

    function bumpSeg(p, n) {
      var d = new Date(SEG_DATE);
      if (p === 'd') d.setDate(d.getDate() + n);
      if (p === 'm') d.setMonth(d.getMonth() + n);
      if (p === 'y') d.setFullYear(d.getFullYear() + n);
      SEG_DATE = d; renderSegBoth();
    }

    function buildDateSelector(segId, popId, calId) {
      var seg = el(segId), pop = el(popId), calBtn = el(calId);
      if (!seg || !pop || !calBtn) return;
      var cal = segCalendar(pop, function () { return SEG_DATE; }, function (d) { SEG_DATE = d; renderSegBoth(); cal.goto(d); cal.draw(); });
      var buf = '', bufT = 0;
      seg.querySelectorAll('.rc-pp__seg-cell').forEach(function (cell) {
        var p = cell.dataset.p;
        cell.addEventListener('pointerdown', function () { seg.querySelectorAll('.rc-pp__seg-cell').forEach(function (x) { x.classList.remove('rc-pp__seg-cell--on'); }); cell.classList.add('rc-pp__seg-cell--on'); cell.focus(); });
        cell.addEventListener('focus', function () { seg.querySelectorAll('.rc-pp__seg-cell').forEach(function (x) { x.classList.remove('rc-pp__seg-cell--on'); }); cell.classList.add('rc-pp__seg-cell--on'); });
        cell.addEventListener('blur', function () { cell.classList.remove('rc-pp__seg-cell--on'); });
        cell.addEventListener('wheel', function (e) { e.preventDefault(); bumpSeg(p, e.deltaY > 0 ? -1 : 1); }, { passive: false });
        cell.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowUp') { e.preventDefault(); bumpSeg(p, 1); }
          else if (e.key === 'ArrowDown') { e.preventDefault(); bumpSeg(p, -1); }
          else if (/^[0-9]$/.test(e.key)) {
            var now = Date.now(); buf = (now - bufT > 900 ? '' : buf) + e.key; bufT = now;
            var n = +buf, d = new Date(SEG_DATE);
            if (p === 'd' && n >= 1 && n <= 31) d.setDate(n);
            if (p === 'm' && n >= 1 && n <= 12) d.setMonth(n - 1);
            if (p === 'y' && buf.length === 4) d.setFullYear(n);
            SEG_DATE = d; renderSegBoth();
          }
        });
      });
      calBtn.onclick = function (e) { e.stopPropagation(); pop.classList.toggle('rc-pp__seg-pop--open'); cal.goto(SEG_DATE); cal.draw(); };
      document.addEventListener('click', function () { pop.classList.remove('rc-pp__seg-pop--open'); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') pop.classList.remove('rc-pp__seg-pop--open'); });
    }

    /* ════════════════════════════════════════════════════
       INIT
    ════════════════════════════════════════════════════ */
    buildDateSelector('rc-pp-seg-otp', 'rc-pp-pop-otp', 'rc-pp-cal-otp');
    buildDateSelector('rc-pp-seg-otp2', 'rc-pp-pop-otp2', 'rc-pp-cal-otp2');
    buildDateSelector('rc-pp-seg-otp-m', 'rc-pp-pop-otp-m', 'rc-pp-cal-otp-m');
    SEG_DATE = new Date();
    renderSegBoth();

    buildPanels();
    buildSpine();
    buildMap();
    buildMobileCards();
    transitionToStage(0);
    fetchDates(true); /* immediate first fetch — no debounce on initial load */
    if (!IS_MOBILE) { onScroll(); }
  })();

  } catch(e) { console.error(e); }
})();
})();
